<template>
  <div>
    <div class="main" id="reflush">
        <header>
            <img src="https://api.dianzibiaopai.top/public/content/logo/jb.png" alt="">
        </header>
        <div class="m-lists f-fs1">

<!--<div class="details-tit c-3e3f41">
    <b>浙江中天钢铁有限公司</b>
</div>-->
<div class="details-info">
    <div class="detailed-tit f-clr">
        <span class="f-fl">标牌信息</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div class="f-clr list-info">
        <div class="f-fl"><span class="c-808080">质保书编号：</span><span id="productName">{{ info.QA }}</span></div>
    </div>
    <div class="f-clr list-info">
        <div class="f-fl"><span class="c-808080">产品名称：</span><span id="productName">{{ info.name }}</span></div>
    </div>
    <div class="f-clr list-info">
        <div class="f-fl list-l t-overflow"><span class="c-808080">批次：</span><span id="proBatch">{{ info.batch }}</span></div>
        <div class="f-fr list-r t-overflow"><span class="c-808080">时间：</span><span id="bsnDt">{{ info.date }}</span></div>
    </div>
    <div class="f-clr list-info">
        <div class="f-fl list-l"><span class="c-808080">材质：</span><span id="proMaterial">{{ info.brand }}</span></div>
        <div class="f-fr list-r"><span class="c-808080">规格：</span><span id="proSpec">{{ info.specifications }}</span></div>
    </div>
    <div class="f-clr list-info">
        <div class="f-fl list-l  t-overflow"><span class="f-fl c-808080 ">长度：</span><span id="proSize">{{info.length}}</span></div>
        <div class="f-fr list-r t-overflow"><span class="c-808080">支数：</span><span id="zhiConut">{{info.count}}</span></div>
    </div>

    <div class="f-clr list-info">
        <div class="f-fr list-r"><span class="c-808080">实重：</span><span id="shizhong">{{info.weight}}</span></div>
        <div class="f-fl list-l"><span class="c-808080">理重: </span><span id="lizhong">{{info.theoretical}}</span> </div>
    </div>



</div>

<!--成分信息E-->
<!--物理特性S-->
<div class="details-info phisical-info" id = "div_01">
    <div class="detailed-tit f-clr">
        <span class="f-fl">物理特性</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div v-html="info.physicsdesc" class="chemistry-table table-info"></div>

</div>
<!--化学特性S-->
<div class="details-info hx-info" id = "div_02">
    <div class="detailed-tit f-clr">
        <span class="f-fl">化学特性</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div v-html="info.chemistrydesc" class="chemistry-table table-info"></div>


</div>



<div class="enImgs">
    <div class="detailed-tit f-clr">
        <span class="f-fl" id="enterName">企业荣誉</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div class="enImgs-container">
    <img class="bg-autoSize" src="https://api.dianzibiaopai.top/public/content/230202_1.jpg" />
    <img class="bg-autoSize" src="https://api.dianzibiaopai.top/public/content/230202_2.jpg" />
    <img class="bg-autoSize" src="https://api.dianzibiaopai.top/public/content/230202_3.jpg" />
    <img class="bg-autoSize" src="https://api.dianzibiaopai.top/public/content/230202_4.jpg" />
    <img class="bg-autoSize" src="https://api.dianzibiaopai.top/public/content/230202_5.jpg" />
    </div>
</div>
<div>
    <div class="detailed-tit f-clr">
        <span class="f-fl" id="enterName">建邦风采</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div>
        <video width="100%" autoplay controls>
            <source src="https://api.dianzibiaopai.top/public/content/jbxcp2018.mp4" type="video/mp4">
        </video>
    </div>
</div>
<div>
    <div class="detailed-tit f-clr">
        <span class="f-fl" id="enterName">物流轨迹</span>
        <span class="f-fr c-gray"></span>
    </div>
    <div id="gjdiv">
        <div class="query-btn" onclick="gjdianji">查询</div>
   </div>

</div>
    <!--物理特性E-->
    <div class="phisical-info company-info">
        <div class="detailed-tit f-clr">
            <span class="f-fl" id="enterName">山西建邦集团有限公司</span>
            <span class="f-fr c-gray"></span>
        </div>
        <div class="f-ti2 b-dc simple-info" id="simple-info">
            <img src="https://api.dianzibiaopai.top/public/content/tongcai.png" hspace="8" vspace="5" alt="" align="right">
            山西建邦集团有限公司创建于1988年，资产总额240亿元，占地 6000亩，现有职工5000余人。国家球墨生铁、高纯生铁、四面肋热轧钢筋、热轧钢筋用连铸方坯标准制定成员单位，中国企业500强、中国制造业企业500强、中国企业信用500强、中国民营企业500强、中国制造业民营企业500强、中国对外贸易民营企业500强、中国民营企业信用100强、工信部第二批符合钢铁行业规范条件企业、国家级绿色工厂、国家高新技术企业、全国节能减排示范企业、全国环境守法示范企业、国家两化融合示范单位。
            <p>企业取得了“环境管理体系、质量管理体系、职业健康安全管理体系、能源管理体系”四体系认证，公司下设建邦铸造、通才工贸、澳洲矿业等十四个实体和北京、四川、重庆、西安等二十四个驻外分公司，是一家集进出口贸易、炼铁、炼钢、轧材、铸造、清洁发电、新型建材、矿山开采、铁路运输、现代物流、电子商务、金融投资、房地产开发、钢材深加工、教育培训、产学研融合为一体的跨区域跨国界经营、跨行业多元化发展的中大型钢铁联合企业。已形成年产600万吨铁（其中150万吨高纯铸造风电生铁）、650万吨钢、650万吨材、1000万吨铁路到发量、210万吨新型建材、12亿度清洁发电的产能规模和“控资源、进出口、大物流、洁生产、水循环、能回收、气发电、电炼铁、铁炼钢、钢轧材、材深延、渣产建材”的绿色循环生态链。</p>
        </div>
    </div>

</div>
<footer class="footer">
            <div class="contact">
                <div class="footer-title">联系我们</div>
                <div class="contact-container">
				    <div class="contact-item">
                        <div class="contact-item-label">网址：</div>
                        <div>www.sxjbjt.com</div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-item-label">地址：</div>
                        <div>山西省侯马市文明路430号建邦国际（建邦集团）</div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-item-label">地址：</div>
                        <div>山西省侯马市侯北产业园（建邦铸造）</div>
                    </div>
					  <div class="contact-item">
                        <div class="contact-item-label">地址：</div>
                        <div>山西省曲沃千万吨级冶金工业园区（通才公司）</div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-item-label">电话：</div>
                        <div>
                            <div>0357-4035288（建材）</div>
                            <div>0357-4062208（球铁）</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="qrcode">
                <div class="footer-title">二维码</div>
                <div class="qrcode-img">
                    <img src="https://api.dianzibiaopai.top/public/content/dianshang.png" alt="">
                </div>
            </div>
        </footer>
    </div>
  </div>
</template>

<script>
export default {
    props:['info'],

}
</script>

<style scoped>
    


article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
    display: block;
}
audio, canvas, progress, video {
    display: inline-block;
    vertical-align: baseline;
}
audio:not([controls]) {
    display: none;
    height: 0;
}
[hidden], template {
    display: none;
}
a {
    background-color: transparent;
}
a:active, a:hover {
    outline: 0 none;
}
abbr[title] {
    border-bottom: 1px dotted;
}
b, strong {
    font-weight: bold;
}
dfn {
    font-style: italic;
}
h1 {
    font-size: 2em;
    margin: 0.67em 0;
}
mark {
    background: #ff0 none repeat scroll 0 0;
    color: #000;
}
small {
    font-size: 80%;
}
sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
}
sup {
    top: -0.5em;
}
sub {
    bottom: -0.25em;
}
img {
    border: 0 none;
}
svg:not(:root) {
    overflow: hidden;
}
figure {
    margin: 1em 40px;
}
hr {
    box-sizing: content-box;
    height: 0;
}
pre {
    overflow: auto;
}
code, kbd, pre, samp {
    font-family: monospace,monospace;
    font-size: 1em;
}
button, input, optgroup, select, textarea {
    color: inherit;
    font: inherit;
    margin: 0;
}
button {
    overflow: visible;
}
button, select {
    text-transform: none;
}
button, html input[type="button"], input[type="reset"], input[type="submit"] {
    cursor: pointer;
}
button[disabled], html input[disabled] {
    cursor: default;
}
button::-moz-focus-inner, input::-moz-focus-inner {
    border: 0 none;
    padding: 0;
}
input {
    line-height: normal;
}
input[type="checkbox"], input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
}
input[type="search"] {
    box-sizing: content-box;
}
fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
}
legend {
    border: 0 none;
    padding: 0;
}
textarea {
    overflow: auto;
}
optgroup {
    font-weight: bold;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
td, th {
    padding: 0;
}
@media print {
*, *::before, *::after {
    background: transparent none repeat scroll 0 0 !important;
    box-shadow: none !important;
    color: #000 !important;
    text-shadow: none !important;
}
a, a:visited {
    text-decoration: underline;
}
a[href]::after {
    content: " (" attr(href) ")";
}
abbr[title]::after {
    content: " (" attr(title) ")";
}
a[href^="#"]::after, a[href^="javascript:"]::after {
    content: "";
}
pre, blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
}
thead {
    display: table-header-group;
}
tr, img {
    page-break-inside: avoid;
}
img {
    max-width: 100% !important;
}
p, h2, h3 {
    orphans: 3;
    widows: 3;
}
h2, h3 {
    page-break-after: avoid;
}
select {
    background: #fff none repeat scroll 0 0 !important;
}
.navbar {
    display: none;
}
.btn > .caret, .dropup > .btn > .caret {
    border-top-color: #000 !important;
}
.label {
    border: 1px solid #000;
}
.table {
    border-collapse: collapse !important;
}
.table td, .table th {
    background-color: #fff !important;
}
.table-bordered th, .table-bordered td {
    border: 1px solid #ddd !important;
}
}
* {
    box-sizing: border-box;
}
*::before, *::after {
    box-sizing: border-box;
}


input, button, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
a {
    color: #383838;
    text-decoration: none;
}
a:hover, a:focus {
    color: #ff4d3a;
    text-decoration: none;
}
a:focus {
    outline: thin dotted;
    outline-offset: -2px;
}
figure {
    margin: 0;
}
img {
    vertical-align: middle;
}
.img-responsive, .thumbnail > img, .thumbnail a > img, .carousel-inner > .item > img, .carousel-inner > .item > a > img {
    display: block;
    height: auto;
    max-width: 100%;
}
.img-rounded {
    border-radius: 0;
}
.img-thumbnail {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0;
    display: inline-block;
    height: auto;
    line-height: 1.42857;
    max-width: 100%;
    padding: 4px;
    transition: all 0.2s ease-in-out 0s;
}
.img-circle {
    border-radius: 50%;
}
hr {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    border-color: #eee -moz-use-text-color -moz-use-text-color;
    border-image: none;
    border-style: solid none none;
    border-width: 1px 0 0;
    margin-bottom: 20px;
    margin-top: 20px;
}
.sr-only {
    border: 0 none;
    clip: rect(0px, 0px, 0px, 0px);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}
.sr-only-focusable:active, .sr-only-focusable:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
    width: auto;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    color: inherit;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
}
h1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {
    color: #777;
    font-weight: normal;
    line-height: 1;
}
h1, .h1, h2, .h2, h3, .h3 {
    margin-bottom: 10px;
    margin-top: 20px;
}
h1 small, .h1 small, h2 small, .h2 small, h3 small, .h3 small, h1 .small, .h1 .small, h2 .small, .h2 .small, h3 .small, .h3 .small {
    font-size: 65%;
}
h4, .h4, h5, .h5, h6, .h6 {
    margin-bottom: 10px;
    margin-top: 10px;
}
h4 small, .h4 small, h5 small, .h5 small, h6 small, .h6 small, h4 .small, .h4 .small, h5 .small, .h5 .small, h6 .small, .h6 .small {
    font-size: 75%;
}
h1, .h1 {
    font-size: 30px;
}
h2, .h2 {
    font-size: 26px;
}
h3, .h3 {
    font-size: 22px;
}
h4, .h4 {
    font-size: 18px;
}
h5, .h5 {
    font-size: 14px;
}
h6, .h6 {
    font-size: 12px;
}
p {
    margin: 0 0 10px;
}
.lead {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.4;
    margin-bottom: 20px;
}
@media (min-width: 768px) {
.lead {
    font-size: 21px;
}
}
small, .small {
    font-size: 85%;
}
mark, .mark {
    background-color: #fc9526;
    padding: 0.2em;
}
.text-left {
    text-align: left;
}
.text-right {
    text-align: right;
}
.text-center {
    text-align: center;
}
.text-justify {
    text-align: justify;
}
.text-nowrap {
    white-space: nowrap;
}
.text-lowercase {
    text-transform: lowercase;
}
.text-uppercase {
    text-transform: uppercase;
}
.text-capitalize {
    text-transform: capitalize;
}
.text-muted {
    color: #777;
}
.text-primary {
    color: #248aaf;
}
a.text-primary:hover {
    color: #1b6985;
}
.text-success {
    color: #3cbc8d;
}
a.text-success:hover {
    color: #309570;
}
.text-info {
    color: #3dbfd9;
}
a.text-info:hover {
    color: #25a4be;
}
.text-warning {
    color: #fc9526;
}
a.text-warning:hover {
    color: #ec7c03;
}
.text-danger {
    color: #eb5745;
}
a.text-danger:hover {
    color: #e42f19;
}
.bg-primary {
    background-color: #248aaf;
    color: #fff;
}
a.bg-primary:hover {
    background-color: #1b6985;
}
.bg-success {
    background-color: #3cbc8d;
}
a.bg-success:hover {
    background-color: #309570;
}
.bg-info {
    background-color: #3dbfd9;
}
a.bg-info:hover {
    background-color: #25a4be;
}
.bg-warning {
    background-color: #fc9526;
}
a.bg-warning:hover {
    background-color: #ec7c03;
}
.bg-danger {
    background-color: #eb5745;
}
a.bg-danger:hover {
    background-color: #e42f19;
}
.page-header {
    border-bottom: 1px solid #eee;
    margin: 40px 0 20px;
    padding-bottom: 9px;
}
ul, ol {
    margin-bottom: 10px;
    margin-top: 0;
}
ul ul, ol ul, ul ol, ol ol {
    margin-bottom: 0;
}
.list-unstyled {
    list-style: outside none none;
    padding-left: 0;
}
.list-inline {
    list-style: outside none none;
    margin-left: -5px;
    padding-left: 0;
}
.list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
}
dl {
    margin-bottom: 20px;
    margin-top: 0;
}
dt, dd {
    line-height: 1.42857;
}
dt {
    font-weight: bold;
}
dd {
    margin-left: 0;
}
@media (min-width: 768px) {
.dl-horizontal dt {
    clear: left;
    float: left;
    overflow: hidden;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 160px;
}
.dl-horizontal dd {
    margin-left: 180px;
}
}
abbr[title], abbr[data-original-title] {
    border-bottom: 1px dotted #777;
    cursor: help;
}
.initialism {
    font-size: 90%;
    text-transform: uppercase;
}
blockquote {
    border-left: 5px solid #eee;
    font-size: 17.5px;
    margin: 0 0 20px;
    padding: 10px 20px;
}
blockquote p:last-child, blockquote ul:last-child, blockquote ol:last-child {
    margin-bottom: 0;
}
blockquote footer, blockquote small, blockquote .small {
    color: #777;
    display: block;
    font-size: 80%;
    line-height: 1.42857;
}
blockquote footer::before, blockquote small::before, blockquote .small::before {
    content: "鈥� ";
}
.blockquote-reverse, blockquote.pull-right {
    border-left: 0 none;
    border-right: 5px solid #eee;
    padding-left: 0;
    padding-right: 15px;
    text-align: right;
}
.blockquote-reverse footer::before, blockquote.pull-right footer::before, .blockquote-reverse small::before, blockquote.pull-right small::before, .blockquote-reverse .small::before, blockquote.pull-right .small::before {
    content: "";
}
.blockquote-reverse footer::after, blockquote.pull-right footer::after, .blockquote-reverse small::after, blockquote.pull-right small::after, .blockquote-reverse .small::after, blockquote.pull-right .small::after {
    content: " 鈥�";
}
address {
    font-style: normal;
    line-height: 1.42857;
    margin-bottom: 20px;
}
code, kbd, pre, samp {
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
}
code {
    background-color: #f8f8f8;
    border-radius: 0;
    color: #333;
    font-size: 90%;
    padding: 2px 4px;
}
kbd {
    background-color: #333;
    border-radius: 0;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25) inset;
    color: #fff;
    font-size: 90%;
    padding: 2px 4px;
}
kbd kbd {
    box-shadow: none;
    font-size: 100%;
    font-weight: bold;
    padding: 0;
}
pre {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 0;
    color: #333;
    display: block;
    font-size: 13px;
    line-height: 1.42857;
    margin: 0 0 10px;
    padding: 9.5px;
    word-break: break-all;
    word-wrap: break-word;
}
pre code {
    background-color: transparent;
    border-radius: 0;
    color: inherit;
    font-size: inherit;
    padding: 0;
    white-space: pre-wrap;
}
.pre-scrollable {
    max-height: 340px;
    overflow-y: scroll;
}
.container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}
@media (min-width: 768px) {
.container {
    width: 750px;
}
}
@media (min-width: 992px) {
.container {
    width: 970px;
}
}
@media (min-width: 1200px) {
.container {
    width: 1170px;
}
}
.container-fluid {
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}
.row {
    margin-left: -15px;
    margin-right: -15px;
}
.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
}
.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
    float: left;
}
.col-xs-12 {
    width: 100%;
}
.col-xs-11 {
    width: 91.6667%;
}
.col-xs-10 {
    width: 83.3333%;
}
.col-xs-9 {
    width: 75%;
}
.col-xs-8 {
    width: 66.6667%;
}
.col-xs-7 {
    width: 58.3333%;
}
.col-xs-6 {
    width: 50%;
}
.col-xs-5 {
    width: 41.6667%;
}
.col-xs-4 {
    width: 33.3333%;
}
.col-xs-3 {
    width: 25%;
}
.col-xs-2 {
    width: 16.6667%;
}
.col-xs-1 {
    width: 8.33333%;
}
.col-xs-pull-12 {
    right: 100%;
}
.col-xs-pull-11 {
    right: 91.6667%;
}
.col-xs-pull-10 {
    right: 83.3333%;
}
.col-xs-pull-9 {
    right: 75%;
}
.col-xs-pull-8 {
    right: 66.6667%;
}
.col-xs-pull-7 {
    right: 58.3333%;
}
.col-xs-pull-6 {
    right: 50%;
}
.col-xs-pull-5 {
    right: 41.6667%;
}
.col-xs-pull-4 {
    right: 33.3333%;
}
.col-xs-pull-3 {
    right: 25%;
}
.col-xs-pull-2 {
    right: 16.6667%;
}
.col-xs-pull-1 {
    right: 8.33333%;
}
.col-xs-pull-0 {
    right: auto;
}
.col-xs-push-12 {
    left: 100%;
}
.col-xs-push-11 {
    left: 91.6667%;
}
.col-xs-push-10 {
    left: 83.3333%;
}
.col-xs-push-9 {
    left: 75%;
}
.col-xs-push-8 {
    left: 66.6667%;
}
.col-xs-push-7 {
    left: 58.3333%;
}
.col-xs-push-6 {
    left: 50%;
}
.col-xs-push-5 {
    left: 41.6667%;
}
.col-xs-push-4 {
    left: 33.3333%;
}
.col-xs-push-3 {
    left: 25%;
}
.col-xs-push-2 {
    left: 16.6667%;
}
.col-xs-push-1 {
    left: 8.33333%;
}
.col-xs-push-0 {
    left: auto;
}
.col-xs-offset-12 {
    margin-left: 100%;
}
.col-xs-offset-11 {
    margin-left: 91.6667%;
}
.col-xs-offset-10 {
    margin-left: 83.3333%;
}
.col-xs-offset-9 {
    margin-left: 75%;
}
.col-xs-offset-8 {
    margin-left: 66.6667%;
}
.col-xs-offset-7 {
    margin-left: 58.3333%;
}
.col-xs-offset-6 {
    margin-left: 50%;
}
.col-xs-offset-5 {
    margin-left: 41.6667%;
}
.col-xs-offset-4 {
    margin-left: 33.3333%;
}
.col-xs-offset-3 {
    margin-left: 25%;
}
.col-xs-offset-2 {
    margin-left: 16.6667%;
}
.col-xs-offset-1 {
    margin-left: 8.33333%;
}
.col-xs-offset-0 {
    margin-left: 0;
}
@media (min-width: 768px) {
.col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
    float: left;
}
.col-sm-12 {
    width: 100%;
}
.col-sm-11 {
    width: 91.6667%;
}
.col-sm-10 {
    width: 83.3333%;
}
.col-sm-9 {
    width: 75%;
}
.col-sm-8 {
    width: 66.6667%;
}
.col-sm-7 {
    width: 58.3333%;
}
.col-sm-6 {
    width: 50%;
}
.col-sm-5 {
    width: 41.6667%;
}
.col-sm-4 {
    width: 33.3333%;
}
.col-sm-3 {
    width: 25%;
}
.col-sm-2 {
    width: 16.6667%;
}
.col-sm-1 {
    width: 8.33333%;
}
.col-sm-pull-12 {
    right: 100%;
}
.col-sm-pull-11 {
    right: 91.6667%;
}
.col-sm-pull-10 {
    right: 83.3333%;
}
.col-sm-pull-9 {
    right: 75%;
}
.col-sm-pull-8 {
    right: 66.6667%;
}
.col-sm-pull-7 {
    right: 58.3333%;
}
.col-sm-pull-6 {
    right: 50%;
}
.col-sm-pull-5 {
    right: 41.6667%;
}
.col-sm-pull-4 {
    right: 33.3333%;
}
.col-sm-pull-3 {
    right: 25%;
}
.col-sm-pull-2 {
    right: 16.6667%;
}
.col-sm-pull-1 {
    right: 8.33333%;
}
.col-sm-pull-0 {
    right: auto;
}
.col-sm-push-12 {
    left: 100%;
}
.col-sm-push-11 {
    left: 91.6667%;
}
.col-sm-push-10 {
    left: 83.3333%;
}
.col-sm-push-9 {
    left: 75%;
}
.col-sm-push-8 {
    left: 66.6667%;
}
.col-sm-push-7 {
    left: 58.3333%;
}
.col-sm-push-6 {
    left: 50%;
}
.col-sm-push-5 {
    left: 41.6667%;
}
.col-sm-push-4 {
    left: 33.3333%;
}
.col-sm-push-3 {
    left: 25%;
}
.col-sm-push-2 {
    left: 16.6667%;
}
.col-sm-push-1 {
    left: 8.33333%;
}
.col-sm-push-0 {
    left: auto;
}
.col-sm-offset-12 {
    margin-left: 100%;
}
.col-sm-offset-11 {
    margin-left: 91.6667%;
}
.col-sm-offset-10 {
    margin-left: 83.3333%;
}
.col-sm-offset-9 {
    margin-left: 75%;
}
.col-sm-offset-8 {
    margin-left: 66.6667%;
}
.col-sm-offset-7 {
    margin-left: 58.3333%;
}
.col-sm-offset-6 {
    margin-left: 50%;
}
.col-sm-offset-5 {
    margin-left: 41.6667%;
}
.col-sm-offset-4 {
    margin-left: 33.3333%;
}
.col-sm-offset-3 {
    margin-left: 25%;
}
.col-sm-offset-2 {
    margin-left: 16.6667%;
}
.col-sm-offset-1 {
    margin-left: 8.33333%;
}
.col-sm-offset-0 {
    margin-left: 0;
}
}
@media (min-width: 992px) {
.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
    float: left;
}
.col-md-12 {
    width: 100%;
}
.col-md-11 {
    width: 91.6667%;
}
.col-md-10 {
    width: 83.3333%;
}
.col-md-9 {
    width: 75%;
}
.col-md-8 {
    width: 66.6667%;
}
.col-md-7 {
    width: 58.3333%;
}
.col-md-6 {
    width: 50%;
}
.col-md-5 {
    width: 41.6667%;
}
.col-md-4 {
    width: 33.3333%;
}
.col-md-3 {
    width: 25%;
}
.col-md-2 {
    width: 16.6667%;
}
.col-md-1 {
    width: 8.33333%;
}
.col-md-pull-12 {
    right: 100%;
}
.col-md-pull-11 {
    right: 91.6667%;
}
.col-md-pull-10 {
    right: 83.3333%;
}
.col-md-pull-9 {
    right: 75%;
}
.col-md-pull-8 {
    right: 66.6667%;
}
.col-md-pull-7 {
    right: 58.3333%;
}
.col-md-pull-6 {
    right: 50%;
}
.col-md-pull-5 {
    right: 41.6667%;
}
.col-md-pull-4 {
    right: 33.3333%;
}
.col-md-pull-3 {
    right: 25%;
}
.col-md-pull-2 {
    right: 16.6667%;
}
.col-md-pull-1 {
    right: 8.33333%;
}
.col-md-pull-0 {
    right: auto;
}
.col-md-push-12 {
    left: 100%;
}
.col-md-push-11 {
    left: 91.6667%;
}
.col-md-push-10 {
    left: 83.3333%;
}
.col-md-push-9 {
    left: 75%;
}
.col-md-push-8 {
    left: 66.6667%;
}
.col-md-push-7 {
    left: 58.3333%;
}
.col-md-push-6 {
    left: 50%;
}
.col-md-push-5 {
    left: 41.6667%;
}
.col-md-push-4 {
    left: 33.3333%;
}
.col-md-push-3 {
    left: 25%;
}
.col-md-push-2 {
    left: 16.6667%;
}
.col-md-push-1 {
    left: 8.33333%;
}
.col-md-push-0 {
    left: auto;
}
.col-md-offset-12 {
    margin-left: 100%;
}
.col-md-offset-11 {
    margin-left: 91.6667%;
}
.col-md-offset-10 {
    margin-left: 83.3333%;
}
.col-md-offset-9 {
    margin-left: 75%;
}
.col-md-offset-8 {
    margin-left: 66.6667%;
}
.col-md-offset-7 {
    margin-left: 58.3333%;
}
.col-md-offset-6 {
    margin-left: 50%;
}
.col-md-offset-5 {
    margin-left: 41.6667%;
}
.col-md-offset-4 {
    margin-left: 33.3333%;
}
.col-md-offset-3 {
    margin-left: 25%;
}
.col-md-offset-2 {
    margin-left: 16.6667%;
}
.col-md-offset-1 {
    margin-left: 8.33333%;
}
.col-md-offset-0 {
    margin-left: 0;
}
}
@media (min-width: 1200px) {
.col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
    float: left;
}
.col-lg-12 {
    width: 100%;
}
.col-lg-11 {
    width: 91.6667%;
}
.col-lg-10 {
    width: 83.3333%;
}
.col-lg-9 {
    width: 75%;
}
.col-lg-8 {
    width: 66.6667%;
}
.col-lg-7 {
    width: 58.3333%;
}
.col-lg-6 {
    width: 50%;
}
.col-lg-5 {
    width: 41.6667%;
}
.col-lg-4 {
    width: 33.3333%;
}
.col-lg-3 {
    width: 25%;
}
.col-lg-2 {
    width: 16.6667%;
}
.col-lg-1 {
    width: 8.33333%;
}
.col-lg-pull-12 {
    right: 100%;
}
.col-lg-pull-11 {
    right: 91.6667%;
}
.col-lg-pull-10 {
    right: 83.3333%;
}
.col-lg-pull-9 {
    right: 75%;
}
.col-lg-pull-8 {
    right: 66.6667%;
}
.col-lg-pull-7 {
    right: 58.3333%;
}
.col-lg-pull-6 {
    right: 50%;
}
.col-lg-pull-5 {
    right: 41.6667%;
}
.col-lg-pull-4 {
    right: 33.3333%;
}
.col-lg-pull-3 {
    right: 25%;
}
.col-lg-pull-2 {
    right: 16.6667%;
}
.col-lg-pull-1 {
    right: 8.33333%;
}
.col-lg-pull-0 {
    right: auto;
}
.col-lg-push-12 {
    left: 100%;
}
.col-lg-push-11 {
    left: 91.6667%;
}
.col-lg-push-10 {
    left: 83.3333%;
}
.col-lg-push-9 {
    left: 75%;
}
.col-lg-push-8 {
    left: 66.6667%;
}
.col-lg-push-7 {
    left: 58.3333%;
}
.col-lg-push-6 {
    left: 50%;
}
.col-lg-push-5 {
    left: 41.6667%;
}
.col-lg-push-4 {
    left: 33.3333%;
}
.col-lg-push-3 {
    left: 25%;
}
.col-lg-push-2 {
    left: 16.6667%;
}
.col-lg-push-1 {
    left: 8.33333%;
}
.col-lg-push-0 {
    left: auto;
}
.col-lg-offset-12 {
    margin-left: 100%;
}
.col-lg-offset-11 {
    margin-left: 91.6667%;
}
.col-lg-offset-10 {
    margin-left: 83.3333%;
}
.col-lg-offset-9 {
    margin-left: 75%;
}
.col-lg-offset-8 {
    margin-left: 66.6667%;
}
.col-lg-offset-7 {
    margin-left: 58.3333%;
}
.col-lg-offset-6 {
    margin-left: 50%;
}
.col-lg-offset-5 {
    margin-left: 41.6667%;
}
.col-lg-offset-4 {
    margin-left: 33.3333%;
}
.col-lg-offset-3 {
    margin-left: 25%;
}
.col-lg-offset-2 {
    margin-left: 16.6667%;
}
.col-lg-offset-1 {
    margin-left: 8.33333%;
}
.col-lg-offset-0 {
    margin-left: 0;
}
}
table {
    background-color: transparent;
}
caption {
    color: #777;
    padding-bottom: 8px;
    padding-top: 8px;
    text-align: left;
}
th {
    text-align: left;
}
.table {
    margin-bottom: 20px;
    max-width: 100%;
    width: 100%;
}
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    border-top: 1px solid #ddd;
    line-height: 1.42857;
    padding: 8px;
    vertical-align: top;
}
.table > thead > tr > th {
    border-bottom: 2px solid #ddd;
    vertical-align: bottom;
}
.table > caption + thead > tr:first-child > th, .table > colgroup + thead > tr:first-child > th, .table > thead:first-child > tr:first-child > th, .table > caption + thead > tr:first-child > td, .table > colgroup + thead > tr:first-child > td, .table > thead:first-child > tr:first-child > td {
    border-top: 0 none;
}
.table > tbody + tbody {
    border-top: 2px solid #ddd;
}
.table .table {
    background-color: #fff;
}
.table-condensed > thead > tr > th, .table-condensed > tbody > tr > th, .table-condensed > tfoot > tr > th, .table-condensed > thead > tr > td, .table-condensed > tbody > tr > td, .table-condensed > tfoot > tr > td {
    padding: 5px;
}
.table-bordered {
    border: 1px solid #ddd;
}
.table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {
    border: 1px solid #ddd;
}
.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {
    border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(2n+1) {
    background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
    background-color: #f5f5f5;
}
table col[class*="col-"] {
    display: table-column;
    float: none;
    position: static;
}
table td[class*="col-"], table th[class*="col-"] {
    display: table-cell;
    float: none;
    position: static;
}
.table > thead > tr > td.active, .table > tbody > tr > td.active, .table > tfoot > tr > td.active, .table > thead > tr > th.active, .table > tbody > tr > th.active, .table > tfoot > tr > th.active, .table > thead > tr.active > td, .table > tbody > tr.active > td, .table > tfoot > tr.active > td, .table > thead > tr.active > th, .table > tbody > tr.active > th, .table > tfoot > tr.active > th {
    background-color: #f5f5f5;
}
.table-hover > tbody > tr > td.active:hover, .table-hover > tbody > tr > th.active:hover, .table-hover > tbody > tr.active:hover > td, .table-hover > tbody > tr:hover > .active, .table-hover > tbody > tr.active:hover > th {
    background-color: #e8e8e8;
}
.table > thead > tr > td.success, .table > tbody > tr > td.success, .table > tfoot > tr > td.success, .table > thead > tr > th.success, .table > tbody > tr > th.success, .table > tfoot > tr > th.success, .table > thead > tr.success > td, .table > tbody > tr.success > td, .table > tfoot > tr.success > td, .table > thead > tr.success > th, .table > tbody > tr.success > th, .table > tfoot > tr.success > th {
    background-color: #3cbc8d;
}
.table-hover > tbody > tr > td.success:hover, .table-hover > tbody > tr > th.success:hover, .table-hover > tbody > tr.success:hover > td, .table-hover > tbody > tr:hover > .success, .table-hover > tbody > tr.success:hover > th {
    background-color: #36a97f;
}
.table > thead > tr > td.info, .table > tbody > tr > td.info, .table > tfoot > tr > td.info, .table > thead > tr > th.info, .table > tbody > tr > th.info, .table > tfoot > tr > th.info, .table > thead > tr.info > td, .table > tbody > tr.info > td, .table > tfoot > tr.info > td, .table > thead > tr.info > th, .table > tbody > tr.info > th, .table > tfoot > tr.info > th {
    background-color: #3dbfd9;
}
.table-hover > tbody > tr > td.info:hover, .table-hover > tbody > tr > th.info:hover, .table-hover > tbody > tr.info:hover > td, .table-hover > tbody > tr:hover > .info, .table-hover > tbody > tr.info:hover > th {
    background-color: #29b7d3;
}
.table > thead > tr > td.warning, .table > tbody > tr > td.warning, .table > tfoot > tr > td.warning, .table > thead > tr > th.warning, .table > tbody > tr > th.warning, .table > tfoot > tr > th.warning, .table > thead > tr.warning > td, .table > tbody > tr.warning > td, .table > tfoot > tr.warning > td, .table > thead > tr.warning > th, .table > tbody > tr.warning > th, .table > tfoot > tr.warning > th {
    background-color: #fc9526;
}
.table-hover > tbody > tr > td.warning:hover, .table-hover > tbody > tr > th.warning:hover, .table-hover > tbody > tr.warning:hover > td, .table-hover > tbody > tr:hover > .warning, .table-hover > tbody > tr.warning:hover > th {
    background-color: #fc890d;
}
.table > thead > tr > td.danger, .table > tbody > tr > td.danger, .table > tfoot > tr > td.danger, .table > thead > tr > th.danger, .table > tbody > tr > th.danger, .table > tfoot > tr > th.danger, .table > thead > tr.danger > td, .table > tbody > tr.danger > td, .table > tfoot > tr.danger > td, .table > thead > tr.danger > th, .table > tbody > tr.danger > th, .table > tfoot > tr.danger > th {
    background-color: #eb5745;
}
.table-hover > tbody > tr > td.danger:hover, .table-hover > tbody > tr > th.danger:hover, .table-hover > tbody > tr.danger:hover > td, .table-hover > tbody > tr:hover > .danger, .table-hover > tbody > tr.danger:hover > th {
    background-color: #e9422e;
}
.table-responsive {
    min-height: 0.01%;
    overflow-x: auto;
}
@media screen and (max-width: 767px) {
.table-responsive {
    border: 1px solid #ddd;
    margin-bottom: 15px;
    overflow-y: hidden;
    width: 100%;
}
.table-responsive > .table {
    margin-bottom: 0;
}
.table-responsive > .table > thead > tr > th, .table-responsive > .table > tbody > tr > th, .table-responsive > .table > tfoot > tr > th, .table-responsive > .table > thead > tr > td, .table-responsive > .table > tbody > tr > td, .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
}
.table-responsive > .table-bordered {
    border: 0 none;
}
.table-responsive > .table-bordered > thead > tr > th:first-child, .table-responsive > .table-bordered > tbody > tr > th:first-child, .table-responsive > .table-bordered > tfoot > tr > th:first-child, .table-responsive > .table-bordered > thead > tr > td:first-child, .table-responsive > .table-bordered > tbody > tr > td:first-child, .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0 none;
}
.table-responsive > .table-bordered > thead > tr > th:last-child, .table-responsive > .table-bordered > tbody > tr > th:last-child, .table-responsive > .table-bordered > tfoot > tr > th:last-child, .table-responsive > .table-bordered > thead > tr > td:last-child, .table-responsive > .table-bordered > tbody > tr > td:last-child, .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0 none;
}
.table-responsive > .table-bordered > tbody > tr:last-child > th, .table-responsive > .table-bordered > tfoot > tr:last-child > th, .table-responsive > .table-bordered > tbody > tr:last-child > td, .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0 none;
}
}
fieldset {
    border: 0 none;
    margin: 0;
    min-width: 0;
    padding: 0;
}
legend {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    border-color: -moz-use-text-color -moz-use-text-color #e5e5e5;
    border-image: none;
    border-style: none none solid;
    border-width: 0 0 1px;
    color: #333;
    display: block;
    font-size: 21px;
    line-height: inherit;
    margin-bottom: 20px;
    padding: 0;
    width: 100%;
}
label {
    display: inline-block;
    font-weight: bold;
    margin-bottom: 5px;
    max-width: 100%;
}
input[type="search"] {
    box-sizing: border-box;
}
input[type="radio"], input[type="checkbox"] {
    line-height: normal;
    margin: 4px 0 0;
}
input[type="file"] {
    display: block;
}
input[type="range"] {
    display: block;
    width: 100%;
}
select[multiple], select[size] {
    height: auto;
}
input[type="file"]:focus, input[type="radio"]:focus, input[type="checkbox"]:focus {
    outline: thin dotted;
    outline-offset: -2px;
}
output {
    color: #555;
    display: block;
    font-size: 14px;
    line-height: 1.42857;
    padding-top: 7px;
}
.form-control {
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 0;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
    color: #555;
    display: block;
    font-size: 14px;
    height: 34px;
    line-height: 1.42857;
    padding: 6px 12px;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    width: 100%;
}
.form-control:focus {
    border-color: #66afe9;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(102, 175, 233, 0.6);
    outline: 0 none;
}
.form-control::-moz-placeholder {
    color: #999;
    opacity: 1;
}
.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #eee;
    cursor: not-allowed;
    opacity: 1;
}
textarea.form-control {
    height: auto;
}
input[type="search"] {
}
@media not all {
input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"] {
    line-height: 34px;
}
input.input-sm[type="date"], input.input-sm[type="time"], input.input-sm[type="datetime-local"], input.input-sm[type="month"], .input-group-sm input[type="date"], .input-group-sm input[type="time"], .input-group-sm input[type="datetime-local"], .input-group-sm input[type="month"] {
    line-height: 30px;
}
input.input-lg[type="date"], input.input-lg[type="time"], input.input-lg[type="datetime-local"], input.input-lg[type="month"], .input-group-lg input[type="date"], .input-group-lg input[type="time"], .input-group-lg input[type="datetime-local"], .input-group-lg input[type="month"] {
    line-height: 46px;
}
}
.form-group {
    margin-bottom: 15px;
}
.radio, .checkbox {
    display: block;
    margin-bottom: 10px;
    margin-top: 10px;
    position: relative;
}
.radio label, .checkbox label {
    cursor: pointer;
    font-weight: normal;
    margin-bottom: 0;
    min-height: 20px;
    padding-left: 20px;
}
.radio input[type="radio"], .radio-inline input[type="radio"], .checkbox input[type="checkbox"], .checkbox-inline input[type="checkbox"] {
    margin-left: -20px;
    position: absolute;
}
.radio + .radio, .checkbox + .checkbox {
    margin-top: -5px;
}
.radio-inline, .checkbox-inline {
    cursor: pointer;
    display: inline-block;
    font-weight: normal;
    margin-bottom: 0;
    padding-left: 20px;
    vertical-align: middle;
}
.radio-inline + .radio-inline, .checkbox-inline + .checkbox-inline {
    margin-left: 10px;
    margin-top: 0;
}
input[type="radio"][disabled], input[type="checkbox"][disabled], input.disabled[type="radio"], input.disabled[type="checkbox"], fieldset[disabled] input[type="radio"], fieldset[disabled] input[type="checkbox"] {
    cursor: not-allowed;
}
.radio-inline.disabled, .checkbox-inline.disabled, fieldset[disabled] .radio-inline, fieldset[disabled] .checkbox-inline {
    cursor: not-allowed;
}
.radio.disabled label, .checkbox.disabled label, fieldset[disabled] .radio label, fieldset[disabled] .checkbox label {
    cursor: not-allowed;
}
.form-control-static {
    margin-bottom: 0;
    padding-bottom: 7px;
    padding-top: 7px;
}
.form-control-static.input-lg, .form-control-static.input-sm {
    padding-left: 0;
    padding-right: 0;
}
.input-st {
	width:120px;
}
.input-sm {
    border-radius: 0;
    font-size: 12px;
    height: 30px;
    line-height: 1.5;
    padding: 5px 10px;
}
select.input-sm {
    height: 30px;
    line-height: 30px;
}
textarea.input-sm, select.input-sm[multiple] {
    height: auto;
}
.form-group-sm .form-control {
    border-radius: 0;
    font-size: 12px;
    height: 30px;
    line-height: 1.5;
    padding: 5px 10px;
}
select.form-group-sm .form-control {
    height: 30px;
    line-height: 30px;
}
textarea.form-group-sm .form-control, select.form-group-sm[multiple] .form-control {
    height: auto;
}
.form-group-sm .form-control-static {
    font-size: 12px;
    height: 30px;
    line-height: 1.5;
    padding: 5px 10px;
}
.input-lg {
    border-radius: 0;
    font-size: 18px;
    height: 46px;
    line-height: 1.33333;
    padding: 10px 16px;
}
select.input-lg {
    height: 46px;
    line-height: 46px;
}
textarea.input-lg, select.input-lg[multiple] {
    height: auto;
}
.form-group-lg .form-control {
    border-radius: 0;
    font-size: 18px;
    height: 46px;
    line-height: 1.33333;
    padding: 10px 16px;
}
select.form-group-lg .form-control {
    height: 46px;
    line-height: 46px;
}
textarea.form-group-lg .form-control, select.form-group-lg[multiple] .form-control {
    height: auto;
}
.form-group-lg .form-control-static {
    font-size: 18px;
    height: 46px;
    line-height: 1.33333;
    padding: 10px 16px;
}
.has-feedback {
    position: relative;
}
.has-feedback .form-control {
    padding-right: 42.5px;
}
.form-control-feedback {
    display: block;
    height: 34px;
    line-height: 34px;
    pointer-events: none;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 34px;
    z-index: 2;
}
.input-lg + .form-control-feedback {
    height: 46px;
    line-height: 46px;
    width: 46px;
}
.input-sm + .form-control-feedback {
    height: 30px;
    line-height: 30px;
    width: 30px;
}
.has-success .help-block, .has-success .control-label, .has-success .radio, .has-success .checkbox, .has-success .radio-inline, .has-success .checkbox-inline, .has-success.radio label, .has-success.checkbox label, .has-success.radio-inline label, .has-success.checkbox-inline label {
    color: #3cbc8d;
}
.has-success .form-control {
    border-color: #3cbc8d;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
}
.has-success .form-control:focus {
    border-color: #309570;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 6px #86d8ba;
}
.has-success .input-group-addon {
    background-color: #3cbc8d;
    border-color: #3cbc8d;
    color: #3cbc8d;
}
.has-success .form-control-feedback {
    color: #3cbc8d;
}
.has-warning .help-block, .has-warning .control-label, .has-warning .radio, .has-warning .checkbox, .has-warning .radio-inline, .has-warning .checkbox-inline, .has-warning.radio label, .has-warning.checkbox label, .has-warning.radio-inline label, .has-warning.checkbox-inline label {
    color: #fc9526;
}
.has-warning .form-control {
    border-color: #fc9526;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
}
.has-warning .form-control:focus {
    border-color: #ec7c03;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 6px #fdc68b;
}
.has-warning .input-group-addon {
    background-color: #fc9526;
    border-color: #fc9526;
    color: #fc9526;
}
.has-warning .form-control-feedback {
    color: #fc9526;
}
.has-error .help-block, .has-error .control-label, .has-error .radio, .has-error .checkbox, .has-error .radio-inline, .has-error .checkbox-inline, .has-error.radio label, .has-error.checkbox label, .has-error.radio-inline label, .has-error.checkbox-inline label {
    color: #eb5745;
}
.has-error .form-control {
    border-color: #eb5745;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
}
.has-error .form-control:focus {
    border-color: #e42f19;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 6px #f5aaa1;
}
.has-error .input-group-addon {
    background-color: #eb5745;
    border-color: #eb5745;
    color: #eb5745;
}
.has-error .form-control-feedback {
    color: #eb5745;
}
.has-feedback label ~ .form-control-feedback {
    top: 25px;
}
.has-feedback label.sr-only ~ .form-control-feedback {
    top: 0;
}
.help-block {
    color: #737373;
    display: block;
    margin-bottom: 10px;
    margin-top: 5px;
}
@media (min-width: 768px) {
.form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
}
.form-inline .form-control {
    display: inline-block;
    vertical-align: middle;
    width: auto;
}
.form-inline .form-control-static {
    display: inline-block;
}
.form-inline .input-group {
    display: inline-table;
    vertical-align: middle;
}
.form-inline .input-group .input-group-addon, .form-inline .input-group .input-group-btn, .form-inline .input-group .form-control {
    width: auto;
}
.form-inline .input-group > .form-control {
    width: 100%;
}
.form-inline .control-label {
    margin-bottom: 0;
    vertical-align: middle;
}
.form-inline .radio, .form-inline .checkbox {
    display: inline-block;
    margin-bottom: 0;
    margin-top: 0;
    vertical-align: middle;
}
.form-inline .radio label, .form-inline .checkbox label {
    padding-left: 0;
}
.form-inline .radio input[type="radio"], .form-inline .checkbox input[type="checkbox"] {
    margin-left: 0;
    position: relative;
}
.form-inline .has-feedback .form-control-feedback {
    top: 0;
}
}
.form-horizontal .radio, .form-horizontal .checkbox, .form-horizontal .radio-inline, .form-horizontal .checkbox-inline {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 7px;
}
.form-horizontal .radio, .form-horizontal .checkbox {
    min-height: 27px;
}
.form-horizontal .form-group {
    margin-left: -15px;
    margin-right: -15px;
}
@media (min-width: 768px) {
.form-horizontal .control-label {
    margin-bottom: 0;
    padding-top: 7px;
    text-align: right;
}
}
.form-horizontal .has-feedback .form-control-feedback {
    right: 15px;
}
@media (min-width: 768px) {
.form-horizontal .form-group-lg .control-label {
    padding-top: 14.3333px;
}
}
@media (min-width: 768px) {
.form-horizontal .form-group-sm .control-label {
    padding-top: 6px;
}
}
.btn {
    -moz-user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 0;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857;
    margin-bottom: 0;
    padding: 6px 12px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
}
.btn:focus, .btn:active:focus, .btn.active:focus, .btn.focus, .btn.focus:active, .btn.active.focus {
    outline: thin dotted;
    outline-offset: -2px;
}
.btn:hover, .btn:focus, .btn.focus {
    color: #333;
    text-decoration: none;
}
.btn:active, .btn.active {
    background-image: none;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.125) inset;
    outline: 0 none;
}
.btn.disabled, .btn[disabled], fieldset[disabled] .btn {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.65;
    pointer-events: none;
}
.btn-default {
    background-color: #fff;
    border-color: #ccc;
    color: #333;
}
.btn-default:hover, .btn-default:focus, .btn-default.focus, .btn-default:active, .btn-default.active, .open > .dropdown-toggle.btn-default {
    background-color: #e6e6e6;
    border-color: #adadad;
    color: #333;
}
.btn-default:active, .btn-default.active, .open > .dropdown-toggle.btn-default {
    background-image: none;
}
.btn-default.disabled, .btn-default[disabled], fieldset[disabled] .btn-default, .btn-default.disabled:hover, .btn-default[disabled]:hover, fieldset[disabled] .btn-default:hover, .btn-default.disabled:focus, .btn-default[disabled]:focus, fieldset[disabled] .btn-default:focus, .btn-default.disabled.focus, .btn-default.focus[disabled], fieldset[disabled] .btn-default.focus, .btn-default.disabled:active, .btn-default[disabled]:active, fieldset[disabled] .btn-default:active, .btn-default.disabled.active, .btn-default.active[disabled], fieldset[disabled] .btn-default.active {
    background-color: #fff;
    border-color: #ccc;
}
.btn-default .badge {
    background-color: #333;
    color: #fff;
}
.btn-primary {
    background-color: #248aaf;
    border-color: #20799a;
    color: #fff;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary.focus, .btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {
    background-color: #1b6985;
    border-color: #155167;
    color: #fff;
}
.btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {
    background-image: none;
}
.btn-primary.disabled, .btn-primary[disabled], fieldset[disabled] .btn-primary, .btn-primary.disabled:hover, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary:hover, .btn-primary.disabled:focus, .btn-primary[disabled]:focus, fieldset[disabled] .btn-primary:focus, .btn-primary.disabled.focus, .btn-primary.focus[disabled], fieldset[disabled] .btn-primary.focus, .btn-primary.disabled:active, .btn-primary[disabled]:active, fieldset[disabled] .btn-primary:active, .btn-primary.disabled.active, .btn-primary.active[disabled], fieldset[disabled] .btn-primary.active {
    background-color: #248aaf;
    border-color: #20799a;
}
.btn-primary .badge {
    background-color: #fff;
    color: #248aaf;
}
.btn-success {
    background-color: #3cbc8d;
    border-color: #36a97f;
    color: #fff;
}
.btn-success:hover, .btn-success:focus, .btn-success.focus, .btn-success:active, .btn-success.active, .open > .dropdown-toggle.btn-success {
    background-color: #309570;
    border-color: #277a5c;
    color: #fff;
}
.btn-success:active, .btn-success.active, .open > .dropdown-toggle.btn-success {
    background-image: none;
}
.btn-success.disabled, .btn-success[disabled], fieldset[disabled] .btn-success, .btn-success.disabled:hover, .btn-success[disabled]:hover, fieldset[disabled] .btn-success:hover, .btn-success.disabled:focus, .btn-success[disabled]:focus, fieldset[disabled] .btn-success:focus, .btn-success.disabled.focus, .btn-success.focus[disabled], fieldset[disabled] .btn-success.focus, .btn-success.disabled:active, .btn-success[disabled]:active, fieldset[disabled] .btn-success:active, .btn-success.disabled.active, .btn-success.active[disabled], fieldset[disabled] .btn-success.active {
    background-color: #3cbc8d;
    border-color: #36a97f;
}
.btn-success .badge {
    background-color: #fff;
    color: #3cbc8d;
}
.btn-info {
    background-color: #3dbfd9;
    border-color: #29b7d3;
    color: #fff;
}
.btn-info:hover, .btn-info:focus, .btn-info.focus, .btn-info:active, .btn-info.active, .open > .dropdown-toggle.btn-info {
    background-color: #25a4be;
    border-color: #1f8ba0;
    color: #fff;
}
.btn-info:active, .btn-info.active, .open > .dropdown-toggle.btn-info {
    background-image: none;
}
.btn-info.disabled, .btn-info[disabled], fieldset[disabled] .btn-info, .btn-info.disabled:hover, .btn-info[disabled]:hover, fieldset[disabled] .btn-info:hover, .btn-info.disabled:focus, .btn-info[disabled]:focus, fieldset[disabled] .btn-info:focus, .btn-info.disabled.focus, .btn-info.focus[disabled], fieldset[disabled] .btn-info.focus, .btn-info.disabled:active, .btn-info[disabled]:active, fieldset[disabled] .btn-info:active, .btn-info.disabled.active, .btn-info.active[disabled], fieldset[disabled] .btn-info.active {
    background-color: #3dbfd9;
    border-color: #29b7d3;
}
.btn-info .badge {
    background-color: #fff;
    color: #3dbfd9;
}
.btn-warning {
    background-color: #fc9526;
    border-color: #fc890d;
    color: #fff;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning.focus, .btn-warning:active, .btn-warning.active, .open > .dropdown-toggle.btn-warning {
    background-color: #ec7c03;
    border-color: #c96903;
    color: #fff;
}
.btn-warning:active, .btn-warning.active, .open > .dropdown-toggle.btn-warning {
    background-image: none;
}
.btn-warning.disabled, .btn-warning[disabled], fieldset[disabled] .btn-warning, .btn-warning.disabled:hover, .btn-warning[disabled]:hover, fieldset[disabled] .btn-warning:hover, .btn-warning.disabled:focus, .btn-warning[disabled]:focus, fieldset[disabled] .btn-warning:focus, .btn-warning.disabled.focus, .btn-warning.focus[disabled], fieldset[disabled] .btn-warning.focus, .btn-warning.disabled:active, .btn-warning[disabled]:active, fieldset[disabled] .btn-warning:active, .btn-warning.disabled.active, .btn-warning.active[disabled], fieldset[disabled] .btn-warning.active {
    background-color: #fc9526;
    border-color: #fc890d;
}
.btn-warning .badge {
    background-color: #fff;
    color: #fc9526;
}
.btn-danger {
    background-color: #eb5745;
    border-color: #e9422e;
    color: #fff;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger.focus, .btn-danger:active, .btn-danger.active, .open > .dropdown-toggle.btn-danger {
    background-color: #e42f19;
    border-color: #c42815;
    color: #fff;
}
.btn-danger:active, .btn-danger.active, .open > .dropdown-toggle.btn-danger {
    background-image: none;
}
.btn-danger.disabled, .btn-danger[disabled], fieldset[disabled] .btn-danger, .btn-danger.disabled:hover, .btn-danger[disabled]:hover, fieldset[disabled] .btn-danger:hover, .btn-danger.disabled:focus, .btn-danger[disabled]:focus, fieldset[disabled] .btn-danger:focus, .btn-danger.disabled.focus, .btn-danger.focus[disabled], fieldset[disabled] .btn-danger.focus, .btn-danger.disabled:active, .btn-danger[disabled]:active, fieldset[disabled] .btn-danger:active, .btn-danger.disabled.active, .btn-danger.active[disabled], fieldset[disabled] .btn-danger.active {
    background-color: #eb5745;
    border-color: #e9422e;
}
.btn-danger .badge {
    background-color: #fff;
    color: #eb5745;
}
.btn-link {
    border-radius: 0;
    color: #383838;
    font-weight: normal;
}
.btn-link, .btn-link:active, .btn-link.active, .btn-link[disabled], fieldset[disabled] .btn-link {
    background-color: transparent;
    box-shadow: none;
}
.btn-link, .btn-link:hover, .btn-link:focus, .btn-link:active {
    border-color: transparent;
}
.btn-link:hover, .btn-link:focus {
    background-color: transparent;
    color: #ff4d3a;
    text-decoration: none;
}
.btn-link[disabled]:hover, fieldset[disabled] .btn-link:hover, .btn-link[disabled]:focus, fieldset[disabled] .btn-link:focus {
    color: #777;
    text-decoration: none;
}
.btn-lg, .btn-group-lg > .btn {
    border-radius: 0;
    font-size: 18px;
    line-height: 1.33333;
    padding: 10px 16px;
}
.btn-sm, .btn-group-sm > .btn {
    border-radius: 0;
    font-size: 12px;
    line-height: 1.5;
    padding: 5px 10px;
}
.btn-xs, .btn-group-xs > .btn {
    border-radius: 0;
    font-size: 12px;
    line-height: 1.5;
    padding: 1px 5px;
}
.btn-block {
    display: block;
    width: 100%;
}
.btn-block + .btn-block {
    margin-top: 5px;
}
input.btn-block[type="submit"], input.btn-block[type="reset"], input.btn-block[type="button"] {
    width: 100%;
}
.fade {
    opacity: 0;
    transition: opacity 0.15s linear 0s;
}
.fade.in {
    opacity: 1;
}
.collapse {
    display: none;
    visibility: hidden;
}
.collapse.in {
    display: block;
    visibility: visible;
}
tr.collapse.in {
    display: table-row;
}
tbody.collapse.in {
    display: table-row-group;
}
.collapsing {
    height: 0;
    overflow: hidden;
    position: relative;
    transition-duration: 0.35s;
    transition-property: height, visibility;
    transition-timing-function: ease;
}
.caret {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid;
    display: inline-block;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    width: 0;
}
.dropup, .dropdown {
    position: relative;
}
.dropdown-toggle:focus {
    outline: 0 none;
}
.dropdown-menu {
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.176);
    display: none;
    float: left;
    font-size: 14px;
    left: 0;
    list-style: outside none none;
    margin: 2px 0 0;
    min-width: 160px;
    padding: 5px 0;
    position: absolute;
    text-align: left;
    top: 100%;
    z-index: 1000;
}
.dropdown-menu.pull-right {
    left: auto;
    right: 0;
}
.dropdown-menu .divider {
    background-color: #e5e5e5;
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
}
.dropdown-menu > li > a {
    clear: both;
    color: #333;
    display: block;
    font-weight: normal;
    line-height: 1.42857;
    padding: 3px 20px;
    white-space: nowrap;
}
.dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
    background-color: #383838;
    color: #fff;
    text-decoration: none;
}
.dropdown-menu > .active > a, .dropdown-menu > .active > a:hover, .dropdown-menu > .active > a:focus {
    background-color: #383838;
    color: #fff;
    outline: 0 none;
    text-decoration: none;
}
.dropdown-menu > .disabled > a, .dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {
    color: #777;
}
.dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {
    background-color: transparent;
    background-image: none;
    cursor: not-allowed;
    text-decoration: none;
}
.open > .dropdown-menu {
    display: block;
}
.open > a {
    outline: 0 none;
}
.dropdown-menu-right {
    left: auto;
    right: 0;
}
.dropdown-menu-left {
    left: 0;
    right: auto;
}
.dropdown-header {
    color: #777;
    display: block;
    font-size: 12px;
    line-height: 1.42857;
    padding: 3px 20px;
    white-space: nowrap;
}
.dropdown-backdrop {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 990;
}
.pull-right > .dropdown-menu {
    left: auto;
    right: 0;
}
.dropup .caret, .navbar-fixed-bottom .dropdown .caret {
    border-bottom: 4px solid;
    border-top: 0 none;
    content: "";
}
.dropup .dropdown-menu, .navbar-fixed-bottom .dropdown .dropdown-menu {
    bottom: 100%;
    margin-bottom: 2px;
    top: auto;
}
@media (min-width: 768px) {
.navbar-right .dropdown-menu {
    left: auto;
    right: 0;
}
.navbar-right .dropdown-menu-left {
    left: 0;
    right: auto;
}
}
.btn-group, .btn-group-vertical {
    display: inline-block;
    position: relative;
    vertical-align: middle;
}
.btn-group > .btn, .btn-group-vertical > .btn {
    float: left;
    position: relative;
}
.btn-group > .btn:hover, .btn-group-vertical > .btn:hover, .btn-group > .btn:focus, .btn-group-vertical > .btn:focus, .btn-group > .btn:active, .btn-group-vertical > .btn:active, .btn-group > .btn.active, .btn-group-vertical > .btn.active {
    z-index: 2;
}
.btn-group .btn + .btn, .btn-group .btn + .btn-group, .btn-group .btn-group + .btn, .btn-group .btn-group + .btn-group {
    margin-left: -1px;
}
.btn-toolbar {
    margin-left: -5px;
}
.btn-toolbar .btn-group, .btn-toolbar .input-group {
    float: left;
}
.btn-toolbar > .btn, .btn-toolbar > .btn-group, .btn-toolbar > .input-group {
    margin-left: 5px;
}
.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
    border-radius: 0;
}
.btn-group > .btn:first-child {
    margin-left: 0;
}
.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.btn-group > .btn:last-child:not(:first-child), .btn-group > .dropdown-toggle:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.btn-group > .btn-group {
    float: left;
}
.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {
    border-radius: 0;
}
.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child, .btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.btn-group .dropdown-toggle:active, .btn-group.open .dropdown-toggle {
    outline: 0 none;
}
.btn-group > .btn + .dropdown-toggle {
    padding-left: 8px;
    padding-right: 8px;
}
.btn-group > .btn-lg + .dropdown-toggle {
    padding-left: 12px;
    padding-right: 12px;
}
.btn-group.open .dropdown-toggle {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.125) inset;
}
.btn-group.open .dropdown-toggle.btn-link {
    box-shadow: none;
}
.btn .caret {
    margin-left: 0;
}
.btn-lg .caret {
    border-width: 5px 5px 0;
}
.dropup .btn-lg .caret {
    border-width: 0 5px 5px;
}
.btn-group-vertical > .btn, .btn-group-vertical > .btn-group, .btn-group-vertical > .btn-group > .btn {
    display: block;
    float: none;
    max-width: 100%;
    width: 100%;
}
.btn-group-vertical > .btn-group > .btn {
    float: none;
}
.btn-group-vertical > .btn + .btn, .btn-group-vertical > .btn + .btn-group, .btn-group-vertical > .btn-group + .btn, .btn-group-vertical > .btn-group + .btn-group {
    margin-left: 0;
    margin-top: -1px;
}
.btn-group-vertical > .btn:not(:first-child):not(:last-child) {
    border-radius: 0;
}
.btn-group-vertical > .btn:first-child:not(:last-child) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.btn-group-vertical > .btn:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {
    border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child, .btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.btn-group-justified {
    border-collapse: separate;
    display: table;
    table-layout: fixed;
    width: 100%;
}
.btn-group-justified > .btn, .btn-group-justified > .btn-group {
    display: table-cell;
    float: none;
    width: 1%;
}
.btn-group-justified > .btn-group .btn {
    width: 100%;
}
.btn-group-justified > .btn-group .dropdown-menu {
    left: auto;
}
[data-toggle="buttons"] > .btn input[type="radio"], [data-toggle="buttons"] > .btn-group > .btn input[type="radio"], [data-toggle="buttons"] > .btn input[type="checkbox"], [data-toggle="buttons"] > .btn-group > .btn input[type="checkbox"] {
    clip: rect(0px, 0px, 0px, 0px);
    pointer-events: none;
    position: absolute;
}
.input-group {
    border-collapse: separate;
    display: table;
    position: relative;
}
.input-group[class*="col-"] {
    float: none;
    padding-left: 0;
    padding-right: 0;
}
.input-group .form-control {
    float: left;
    margin-bottom: 0;
    position: relative;
    width: 100%;
    z-index: 2;
}
.input-group-lg > .form-control, .input-group-lg > .input-group-addon, .input-group-lg > .input-group-btn > .btn {
    border-radius: 0;
    font-size: 18px;
    height: 46px;
    line-height: 1.33333;
    padding: 10px 16px;
}
select.input-group-lg > .form-control, select.input-group-lg > .input-group-addon, select.input-group-lg > .input-group-btn > .btn {
    height: 46px;
    line-height: 46px;
}
textarea.input-group-lg > .form-control, textarea.input-group-lg > .input-group-addon, textarea.input-group-lg > .input-group-btn > .btn, select.input-group-lg[multiple] > .form-control, select.input-group-lg[multiple] > .input-group-addon, select.input-group-lg[multiple] > .input-group-btn > .btn {
    height: auto;
}
.input-group-sm > .form-control, .input-group-sm > .input-group-addon, .input-group-sm > .input-group-btn > .btn {
    border-radius: 0;
    font-size: 12px;
    height: 30px;
    line-height: 1.5;
    padding: 5px 10px;
}
select.input-group-sm > .form-control, select.input-group-sm > .input-group-addon, select.input-group-sm > .input-group-btn > .btn {
    height: 30px;
    line-height: 30px;
}
textarea.input-group-sm > .form-control, textarea.input-group-sm > .input-group-addon, textarea.input-group-sm > .input-group-btn > .btn, select.input-group-sm[multiple] > .form-control, select.input-group-sm[multiple] > .input-group-addon, select.input-group-sm[multiple] > .input-group-btn > .btn {
    height: auto;
}
.input-group-addon, .input-group-btn, .input-group .form-control {
    display: table-cell;
}
.input-group-addon:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child), .input-group .form-control:not(:first-child):not(:last-child) {
    border-radius: 0;
}
.input-group-addon, .input-group-btn {
    vertical-align: middle;
    white-space: nowrap;
    width: 1%;
}
.input-group-addon {
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 0;
    color: #555;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    padding: 6px 12px;
    text-align: center;
}
.input-group-addon.input-sm {
    border-radius: 0;
    font-size: 12px;
    padding: 5px 10px;
}
.input-group-addon.input-lg {
    border-radius: 0;
    font-size: 18px;
    padding: 10px 16px;
}
.input-group-addon input[type="radio"], .input-group-addon input[type="checkbox"] {
    margin-top: 0;
}
.input-group .form-control:first-child, .input-group-addon:first-child, .input-group-btn:first-child > .btn, .input-group-btn:first-child > .btn-group > .btn, .input-group-btn:first-child > .dropdown-toggle, .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle), .input-group-btn:last-child > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.input-group-addon:first-child {
    border-right: 0 none;
}
.input-group .form-control:last-child, .input-group-addon:last-child, .input-group-btn:last-child > .btn, .input-group-btn:last-child > .btn-group > .btn, .input-group-btn:last-child > .dropdown-toggle, .input-group-btn:first-child > .btn:not(:first-child), .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.input-group-addon:last-child {
    border-left: 0 none;
}
.input-group-btn {
    font-size: 0;
    position: relative;
    white-space: nowrap;
}
.input-group-btn > .btn {
    position: relative;
}
.input-group-btn > .btn + .btn {
    margin-left: -1px;
}
.input-group-btn > .btn:hover, .input-group-btn > .btn:focus, .input-group-btn > .btn:active {
    z-index: 2;
}
.input-group-btn:first-child > .btn, .input-group-btn:first-child > .btn-group {
    margin-right: -1px;
}
.input-group-btn:last-child > .btn, .input-group-btn:last-child > .btn-group {
    margin-left: -1px;
}
.nav {
    list-style: outside none none;
    margin-bottom: 0;
    padding-left: 0;
}
.nav > li {
    display: block;
    position: relative;
}
.nav > li > a {
    display: block;
    padding: 10px 15px;
    position: relative;
}
.nav > li > a:hover, .nav > li > a:focus {
    background-color: #eee;
    text-decoration: none;
}
.nav > li.disabled > a {
    color: #777;
}
.nav > li.disabled > a:hover, .nav > li.disabled > a:focus {
    background-color: transparent;
    color: #777;
    cursor: not-allowed;
    text-decoration: none;
}
.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {
    background-color: #eee;
    border-color: #383838;
}
.nav .nav-divider {
    background-color: #e5e5e5;
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
}
.nav > li > a > img {
    max-width: none;
}
.nav-tabs {
    border-bottom: 1px solid #ddd;
}
.nav-tabs > li {
    float: left;
    margin-bottom: -1px;
}
.nav-tabs > li > a {
    border: 1px solid transparent;
    border-radius: 0;
    line-height: 1.42857;
    margin-right: 2px;
}
.nav-tabs > li > a:hover {
    border-color: #eee #eee #ddd;
}
.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    background-color: #fff;
    border-color: #ddd #ddd transparent;
    border-image: none;
    border-style: solid;
    border-width: 1px;
    color: #555;
    cursor: default;
}
.nav-tabs.nav-justified {
    border-bottom: 0 none;
    width: 100%;
}
.nav-tabs.nav-justified > li {
    float: none;
}
.nav-tabs.nav-justified > li > a {
    margin-bottom: 5px;
    text-align: center;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
    left: auto;
    top: auto;
}
@media (min-width: 768px) {
.nav-tabs.nav-justified > li {
    display: table-cell;
    width: 1%;
}
.nav-tabs.nav-justified > li > a {
    margin-bottom: 0;
}
}
.nav-tabs.nav-justified > li > a {
    border-radius: 0;
    margin-right: 0;
}
.nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {
    border: 1px solid #ddd;
}
@media (min-width: 768px) {
.nav-tabs.nav-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 0;
}
.nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {
    border-bottom-color: #fff;
}
}
.nav-pills > li {
    float: left;
}
.nav-pills > li > a {
    border-radius: 0;
}
.nav-pills > li + li {
    margin-left: 2px;
}
.nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {
    background-color: #248aaf;
    color: #fff;
}
.nav-stacked > li {
    float: none;
}
.nav-stacked > li + li {
    margin-left: 0;
    margin-top: 2px;
}
.nav-justified {
    width: 100%;
}
.nav-justified > li {
    float: none;
}
.nav-justified > li > a {
    margin-bottom: 5px;
    text-align: center;
}
.nav-justified > .dropdown .dropdown-menu {
    left: auto;
    top: auto;
}
@media (min-width: 768px) {
.nav-justified > li {
    display: table-cell;
    width: 1%;
}
.nav-justified > li > a {
    margin-bottom: 0;
}
}
.nav-tabs-justified {
    border-bottom: 0 none;
}
.nav-tabs-justified > li > a {
    border-radius: 0;
    margin-right: 0;
}
.nav-tabs-justified > .active > a, .nav-tabs-justified > .active > a:hover, .nav-tabs-justified > .active > a:focus {
    border: 1px solid #ddd;
}
@media (min-width: 768px) {
.nav-tabs-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 0;
}
.nav-tabs-justified > .active > a, .nav-tabs-justified > .active > a:hover, .nav-tabs-justified > .active > a:focus {
    border-bottom-color: #fff;
}
}
.tab-content > .tab-pane {
    display: none;
    visibility: hidden;
}
.tab-content > .active {
    display: block;
    visibility: visible;
}
.nav-tabs .dropdown-menu {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: -1px;
}
.navbar {
    border: 1px solid transparent;
    margin-bottom: 20px;
    min-height: 50px;
    position: relative;
}
@media (min-width: 768px) {
.navbar {
    border-radius: 0;
}
}
@media (min-width: 768px) {
.navbar-header {
    float: left;
}
}
.navbar-collapse {
    border-top: 1px solid transparent;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1) inset;
    overflow-x: visible;
    padding-left: 15px;
    padding-right: 15px;
}
.navbar-collapse.in {
    overflow-y: auto;
}
@media (min-width: 768px) {
.navbar-collapse {
    border-top: 0 none;
    box-shadow: none;
    width: auto;
}
.navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    padding-bottom: 0;
    visibility: visible !important;
}
.navbar-collapse.in {
    overflow-y: visible;
}
.navbar-fixed-top .navbar-collapse, .navbar-static-top .navbar-collapse, .navbar-fixed-bottom .navbar-collapse {
    padding-left: 0;
    padding-right: 0;
}
}
.navbar-fixed-top .navbar-collapse, .navbar-fixed-bottom .navbar-collapse {
    max-height: 340px;
}
@media (max-device-width: 480px) and (orientation: landscape) {
.navbar-fixed-top .navbar-collapse, .navbar-fixed-bottom .navbar-collapse {
    max-height: 200px;
}
}
.container > .navbar-header, .container-fluid > .navbar-header, .container > .navbar-collapse, .container-fluid > .navbar-collapse {
    margin-left: -15px;
    margin-right: -15px;
}
@media (min-width: 768px) {
.container > .navbar-header, .container-fluid > .navbar-header, .container > .navbar-collapse, .container-fluid > .navbar-collapse {
    margin-left: 0;
    margin-right: 0;
}
}
.navbar-static-top {
    border-width: 0 0 1px;
    z-index: 1000;
}
@media (min-width: 768px) {
.navbar-static-top {
    border-radius: 0;
}
}
.navbar-fixed-top, .navbar-fixed-bottom {
    left: 0;
    position: fixed;
    right: 0;
    z-index: 1030;
}
@media (min-width: 768px) {
.navbar-fixed-top, .navbar-fixed-bottom {
    border-radius: 0;
}
}
.navbar-fixed-top {
    border-width: 0 0 1px;
    top: 0;
}
.navbar-fixed-bottom {
    border-width: 1px 0 0;
    bottom: 0;
    margin-bottom: 0;
}
.navbar-brand {
    float: left;
    font-size: 18px;
    height: 50px;
    line-height: 20px;
    padding: 15px;
}
.navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none;
}
.navbar-brand > img {
    display: block;
}
@media (min-width: 768px) {
.navbar > .container .navbar-brand, .navbar > .container-fluid .navbar-brand {
    margin-left: -15px;
}
}
.navbar-toggle {
    background-color: transparent;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 0;
    float: right;
    margin-bottom: 8px;
    margin-right: 15px;
    margin-top: 8px;
    padding: 9px 10px;
    position: relative;
}
.navbar-toggle:focus {
    outline: 0 none;
}
.navbar-toggle .icon-bar {
    border-radius: 1px;
    display: block;
    height: 2px;
    width: 22px;
}
.navbar-toggle .icon-bar + .icon-bar {
    margin-top: 4px;
}
@media (min-width: 768px) {
.navbar-toggle {
    display: none;
}
}
.navbar-nav {
    margin: 7.5px -15px;
}
.navbar-nav > li > a {
    line-height: 20px;
    padding-bottom: 10px;
    padding-top: 10px;
}
@media (max-width: 767px) {
.navbar-nav .open .dropdown-menu {
    background-color: transparent;
    border: 0 none;
    box-shadow: none;
    float: none;
    margin-top: 0;
    position: static;
    width: auto;
}
.navbar-nav .open .dropdown-menu > li > a, .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 15px 5px 25px;
}
.navbar-nav .open .dropdown-menu > li > a {
    line-height: 20px;
}
.navbar-nav .open .dropdown-menu > li > a:hover, .navbar-nav .open .dropdown-menu > li > a:focus {
    background-image: none;
}
}
@media (min-width: 768px) {
.navbar-nav {
    float: left;
    margin: 0;
}
.navbar-nav > li {
    float: left;
}
.navbar-nav > li > a {
    padding-bottom: 15px;
    padding-top: 15px;
}
}
.navbar-form {
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1) inset, 0 1px 0 rgba(255, 255, 255, 0.1);
    margin: 8px -15px;
    padding: 10px 15px;
}
@media (min-width: 768px) {
.navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
}
.navbar-form .form-control {
    display: inline-block;
    vertical-align: middle;
    width: auto;
}
.navbar-form .form-control-static {
    display: inline-block;
}
.navbar-form .input-group {
    display: inline-table;
    vertical-align: middle;
}
.navbar-form .input-group .input-group-addon, .navbar-form .input-group .input-group-btn, .navbar-form .input-group .form-control {
    width: auto;
}
.navbar-form .input-group > .form-control {
    width: 100%;
}
.navbar-form .control-label {
    margin-bottom: 0;
    vertical-align: middle;
}
.navbar-form .radio, .navbar-form .checkbox {
    display: inline-block;
    margin-bottom: 0;
    margin-top: 0;
    vertical-align: middle;
}
.navbar-form .radio label, .navbar-form .checkbox label {
    padding-left: 0;
}
.navbar-form .radio input[type="radio"], .navbar-form .checkbox input[type="checkbox"] {
    margin-left: 0;
    position: relative;
}
.navbar-form .has-feedback .form-control-feedback {
    top: 0;
}
}
@media (max-width: 767px) {
.navbar-form .form-group {
    margin-bottom: 5px;
}
.navbar-form .form-group:last-child {
    margin-bottom: 0;
}
}
@media (min-width: 768px) {
.navbar-form {
    border: 0 none;
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 0;
    padding-top: 0;
    width: auto;
}
}
.navbar-nav > li > .dropdown-menu {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: 0;
}
.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
    border-radius: 0;
    margin-bottom: 0;
}
.navbar-btn {
    margin-bottom: 8px;
    margin-top: 8px;
}
.navbar-btn.btn-sm {
    margin-bottom: 10px;
    margin-top: 10px;
}
.navbar-btn.btn-xs {
    margin-bottom: 14px;
    margin-top: 14px;
}
.navbar-text {
    margin-bottom: 15px;
    margin-top: 15px;
}
@media (min-width: 768px) {
.navbar-text {
    float: left;
    margin-left: 15px;
    margin-right: 15px;
}
}
@media (min-width: 768px) {
.navbar-left {
    float: left !important;
}
.navbar-right {
    float: right !important;
    margin-right: -15px;
}
.navbar-right ~ .navbar-right {
    margin-right: 0;
}
}
.navbar-default {
    background-color: #fff;
    border-color: #eee;
}
.navbar-default .navbar-brand {
    color: #555;
}
.navbar-default .navbar-brand:hover, .navbar-default .navbar-brand:focus {
    background-color: transparent;
    color: #3b3b3b;
}
.navbar-default .navbar-text {
    color: #555;
}
.navbar-default .navbar-nav > li > a {
    color: #555;
}
.navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {
    background-color: transparent;
    color: #282828;
}
.navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {
    background-color: #eee;
    color: #333;
}
.navbar-default .navbar-nav > .disabled > a, .navbar-default .navbar-nav > .disabled > a:hover, .navbar-default .navbar-nav > .disabled > a:focus {
    background-color: transparent;
    color: #ccc;
}
.navbar-default .navbar-toggle {
    border-color: #ddd;
}
.navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus {
    background-color: #ddd;
}
.navbar-default .navbar-toggle .icon-bar {
    background-color: #888;
}
.navbar-default .navbar-collapse, .navbar-default .navbar-form {
    border-color: #eee;
}
.navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:hover, .navbar-default .navbar-nav > .open > a:focus {
    background-color: #eee;
    color: #333;
}
@media (max-width: 767px) {
.navbar-default .navbar-nav .open .dropdown-menu > li > a {
    color: #555;
}
.navbar-default .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
    background-color: transparent;
    color: #282828;
}
.navbar-default .navbar-nav .open .dropdown-menu > .active > a, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
    background-color: #eee;
    color: #333;
}
.navbar-default .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    background-color: transparent;
    color: #ccc;
}
}
.navbar-default .navbar-link {
    color: #555;
}
.navbar-default .navbar-link:hover {
    color: #282828;
}
.navbar-default .btn-link {
    color: #555;
}
.navbar-default .btn-link:hover, .navbar-default .btn-link:focus {
    color: #282828;
}
.navbar-default .btn-link[disabled]:hover, fieldset[disabled] .navbar-default .btn-link:hover, .navbar-default .btn-link[disabled]:focus, fieldset[disabled] .navbar-default .btn-link:focus {
    color: #ccc;
}
.navbar-inverse {
    background-color: #222;
    border-color: #080808;
}
.navbar-inverse .navbar-brand {
    color: #9d9d9d;
}
.navbar-inverse .navbar-brand:hover, .navbar-inverse .navbar-brand:focus {
    background-color: transparent;
    color: #fff;
}
.navbar-inverse .navbar-text {
    color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a {
    color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a:hover, .navbar-inverse .navbar-nav > li > a:focus {
    background-color: transparent;
    color: #fff;
}
.navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover, .navbar-inverse .navbar-nav > .active > a:focus {
    background-color: #080808;
    color: #fff;
}
.navbar-inverse .navbar-nav > .disabled > a, .navbar-inverse .navbar-nav > .disabled > a:hover, .navbar-inverse .navbar-nav > .disabled > a:focus {
    background-color: transparent;
    color: #444;
}
.navbar-inverse .navbar-toggle {
    border-color: #333;
}
.navbar-inverse .navbar-toggle:hover, .navbar-inverse .navbar-toggle:focus {
    background-color: #333;
}
.navbar-inverse .navbar-toggle .icon-bar {
    background-color: #fff;
}
.navbar-inverse .navbar-collapse, .navbar-inverse .navbar-form {
    border-color: #101010;
}
.navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus {
    background-color: #080808;
    color: #fff;
}
@media (max-width: 767px) {
.navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
    border-color: #080808;
}
.navbar-inverse .navbar-nav .open .dropdown-menu .divider {
    background-color: #080808;
}
.navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
    color: #9d9d9d;
}
.navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
    background-color: transparent;
    color: #fff;
}
.navbar-inverse .navbar-nav .open .dropdown-menu > .active > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
    background-color: #080808;
    color: #fff;
}
.navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    background-color: transparent;
    color: #444;
}
}
.navbar-inverse .navbar-link {
    color: #9d9d9d;
}
.navbar-inverse .navbar-link:hover {
    color: #fff;
}
.navbar-inverse .btn-link {
    color: #9d9d9d;
}
.navbar-inverse .btn-link:hover, .navbar-inverse .btn-link:focus {
    color: #fff;
}
.navbar-inverse .btn-link[disabled]:hover, fieldset[disabled] .navbar-inverse .btn-link:hover, .navbar-inverse .btn-link[disabled]:focus, fieldset[disabled] .navbar-inverse .btn-link:focus {
    color: #444;
}
.pagination {
    border-radius: 0;
    display: inline-block;
    margin: 20px 0;
    padding-left: 0;
}
.pagination > li {
    display: inline;
}
.pagination > li > a, .pagination > li > span {
    background-color: #fff;
    border: 1px solid #ddd;
    color: #383838;
    float: left;
    line-height: 1.42857;
    margin-left: -1px;
    padding: 6px 12px;
    position: relative;
    text-decoration: none;
}
.pagination > li:first-child > a, .pagination > li:first-child > span {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    margin-left: 0;
}
.pagination > li:last-child > a, .pagination > li:last-child > span {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.pagination > li > a:hover, .pagination > li > span:hover, .pagination > li > a:focus, .pagination > li > span:focus {
    background-color: #eee;
    border-color: #ddd;
    color: #ff4d3a;
}
.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus {
    background-color: #ff4d3a;
    border-color: #ff4d3a;
    color: #fff;
    cursor: default;
    z-index: 2;
}
.pagination > .disabled > span, .pagination > .disabled > span:hover, .pagination > .disabled > span:focus, .pagination > .disabled > a, .pagination > .disabled > a:hover, .pagination > .disabled > a:focus {
    background-color: #fff;
    border-color: #ddd;
    color: #777;
    cursor: not-allowed;
}
.pagination-lg > li > a, .pagination-lg > li > span {
    font-size: 18px;
    padding: 10px 16px;
}
.pagination-lg > li:first-child > a, .pagination-lg > li:first-child > span {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.pagination-lg > li:last-child > a, .pagination-lg > li:last-child > span {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.pagination-sm > li > a, .pagination-sm > li > span {
    font-size: 12px;
    padding: 5px 10px;
}
.pagination-sm > li:first-child > a, .pagination-sm > li:first-child > span {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.pagination-sm > li:last-child > a, .pagination-sm > li:last-child > span {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.pager {
    list-style: outside none none;
    margin: 20px 0;
    padding-left: 0;
    text-align: center;
}
.pager li {
    display: inline;
}
.pager li > a, .pager li > span {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 15px;
    display: inline-block;
    padding: 5px 14px;
}
.pager li > a:hover, .pager li > a:focus {
    background-color: #eee;
    text-decoration: none;
}
.pager .next > a, .pager .next > span {
    float: right;
}
.pager .previous > a, .pager .previous > span {
    float: left;
}
.pager .disabled > a, .pager .disabled > a:hover, .pager .disabled > a:focus, .pager .disabled > span {
    background-color: #fff;
    color: #777;
    cursor: not-allowed;
}
.label {
    border-radius: 0.25em;
    color: #fff;
    display: inline;
    font-size: 75%;
    font-weight: bold;
    line-height: 1;
    padding: 0.2em 0.6em 0.3em;
    text-align: center;
    vertical-align: baseline;
    white-space: nowrap;
}
a.label:hover, a.label:focus {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
.label:empty {
    display: none;
}
.btn .label {
    position: relative;
    top: -1px;
}
.label-default {
    background-color: #777;
}
.label-default[href]:hover, .label-default[href]:focus {
    background-color: #5e5e5e;
}
.label-primary {
    background-color: #248aaf;
}
.label-primary[href]:hover, .label-primary[href]:focus {
    background-color: #1b6985;
}
.label-success {
    background-color: #3cbc8d;
}
.label-success[href]:hover, .label-success[href]:focus {
    background-color: #309570;
}
.label-info {
    background-color: #3dbfd9;
}
.label-info[href]:hover, .label-info[href]:focus {
    background-color: #25a4be;
}
.label-warning {
    background-color: #fc9526;
}
.label-warning[href]:hover, .label-warning[href]:focus {
    background-color: #ec7c03;
}
.label-danger {
    background-color: #eb5745;
}
.label-danger[href]:hover, .label-danger[href]:focus {
    background-color: #e42f19;
}
.badge {
    background-color: #ff4d3a;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    min-width: 10px;
    padding: 3px 7px;
    text-align: center;
    vertical-align: baseline;
    white-space: nowrap;
}
.badge:empty {
    display: none;
}
.btn .badge {
    position: relative;
    top: -1px;
}
.btn-xs .badge {
    padding: 1px 5px;
    top: 0;
}
a.badge:hover, a.badge:focus {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
.list-group-item.active > .badge, .nav-pills > .active > a > .badge {
    background-color: #fff;
    color: #383838;
}
.list-group-item > .badge {
    float: right;
}
.list-group-item > .badge + .badge {
    margin-right: 5px;
}
.nav-pills > li > a > .badge {
    margin-left: 3px;
}
.thumbnail {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0;
    display: block;
    line-height: 1.42857;
    margin-bottom: 20px;
    padding: 4px;
    transition: border 0.2s ease-in-out 0s;
}
.thumbnail > img, .thumbnail a > img {
    margin-left: auto;
    margin-right: auto;
}
a.thumbnail:hover, a.thumbnail:focus, a.thumbnail.active {
    border-color: #383838;
}
.thumbnail .caption {
    color: #333;
    padding: 9px;
}
.alert {
    border: 1px solid transparent;
    border-radius: 0;
    margin-bottom: 20px;
    padding: 15px;
}
.alert h4 {
    color: inherit;
    margin-top: 0;
}
.alert .alert-link {
    font-weight: bold;
}
.alert > p, .alert > ul {
    margin-bottom: 0;
}
.alert > p + p {
    margin-top: 5px;
}
.alert-dismissable, .alert-dismissible {
    padding-right: 35px;
}
.alert-dismissable .close, .alert-dismissible .close {
    color: inherit;
    position: relative;
    right: -21px;
    top: -2px;
}
.alert-success {
    background-color: #3cbc8d;
    border-color: #36a96b;
    color: #fff;
}
.alert-success hr {
    border-top-color: #30955f;
}
.alert-success .alert-link {
    color: #e6e6e6;
}
.alert-info {
    background-color: #3dbfd9;
    border-color: #28cbcb;
    color: #fff;
}
.alert-info hr {
    border-top-color: #24b5b5;
}
.alert-info .alert-link {
    color: #e6e6e6;
}
.alert-warning {
    background-color: #fc9526;
    border-color: #fc610d;
    color: #fff;
}
.alert-warning hr {
    border-top-color: #ec5503;
}
.alert-warning .alert-link {
    color: #e6e6e6;
}
.alert-danger {
    background-color: #eb5745;
    border-color: #e92e39;
    color: #fff;
}
.alert-danger hr {
    border-top-color: #e41924;
}
.alert-danger .alert-link {
    color: #e6e6e6;
}
@keyframes progress-bar-stripes {
0% {
    background-position: 40px 0;
}
100% {
    background-position: 0 0;
}
}
.progress {
    background-color: #f5f5f5;
    border-radius: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
}
.progress-bar {
    background-color: #248aaf;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.15) inset;
    color: #fff;
    float: left;
    font-size: 12px;
    height: 100%;
    line-height: 20px;
    text-align: center;
    transition: width 0.6s ease 0s;
    width: 0;
}
.progress-striped .progress-bar, .progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 40px 40px;
}
.progress.active .progress-bar, .progress-bar.active {
    animation: 2s linear 0s normal none infinite running progress-bar-stripes;
}
.progress-bar-success {
    background-color: #3cbc8d;
}
.progress-striped .progress-bar-success {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-info {
    background-color: #3dbfd9;
}
.progress-striped .progress-bar-info {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-warning {
    background-color: #fc9526;
}
.progress-striped .progress-bar-warning {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-danger {
    background-color: #eb5745;
}
.progress-striped .progress-bar-danger {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.list-group {
    margin-bottom: 20px;
    padding-left: 0;
}
.list-group-item {
    background-color: #fff;
    border: 1px solid #ddd;
    display: block;
    margin-bottom: -1px;
    padding: 10px 15px;
    position: relative;
}
.list-group-item:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.list-group-item:last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: 0;
}
a.list-group-item {
    color: #555;
}
a.list-group-item .list-group-item-heading {
    color: #333;
}
a.list-group-item:hover, a.list-group-item:focus {
    background-color: #fff;
    color: #555;
    text-decoration: none;
}
.list-group-item.disabled, .list-group-item.disabled:hover, .list-group-item.disabled:focus {
    background-color: #eee;
    color: #777;
    cursor: not-allowed;
}
.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading {
    color: inherit;
}
.list-group-item.disabled .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text {
    color: #777;
}
.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
    background-color: #248aaf;
    border-color: #248aaf;
    color: #fff;
    z-index: 2;
}
.list-group-item.active .list-group-item-heading, .list-group-item.active:hover .list-group-item-heading, .list-group-item.active:focus .list-group-item-heading, .list-group-item.active .list-group-item-heading > small, .list-group-item.active:hover .list-group-item-heading > small, .list-group-item.active:focus .list-group-item-heading > small, .list-group-item.active .list-group-item-heading > .small, .list-group-item.active:hover .list-group-item-heading > .small, .list-group-item.active:focus .list-group-item-heading > .small {
    color: inherit;
}
.list-group-item.active .list-group-item-text, .list-group-item.active:hover .list-group-item-text, .list-group-item.active:focus .list-group-item-text {
    color: #b0deef;
}
.list-group-item-success {
    background-color: #3cbc8d;
    color: #3cbc8d;
}
a.list-group-item-success {
    color: #3cbc8d;
}
a.list-group-item-success .list-group-item-heading {
    color: inherit;
}
a.list-group-item-success:hover, a.list-group-item-success:focus {
    background-color: #36a97f;
    color: #3cbc8d;
}
a.list-group-item-success.active, a.list-group-item-success.active:hover, a.list-group-item-success.active:focus {
    background-color: #3cbc8d;
    border-color: #3cbc8d;
    color: #fff;
}
.list-group-item-info {
    background-color: #3dbfd9;
    color: #3dbfd9;
}
a.list-group-item-info {
    color: #3dbfd9;
}
a.list-group-item-info .list-group-item-heading {
    color: inherit;
}
a.list-group-item-info:hover, a.list-group-item-info:focus {
    background-color: #29b7d3;
    color: #3dbfd9;
}
a.list-group-item-info.active, a.list-group-item-info.active:hover, a.list-group-item-info.active:focus {
    background-color: #3dbfd9;
    border-color: #3dbfd9;
    color: #fff;
}
.list-group-item-warning {
    background-color: #fc9526;
    color: #fc9526;
}
a.list-group-item-warning {
    color: #fc9526;
}
a.list-group-item-warning .list-group-item-heading {
    color: inherit;
}
a.list-group-item-warning:hover, a.list-group-item-warning:focus {
    background-color: #fc890d;
    color: #fc9526;
}
a.list-group-item-warning.active, a.list-group-item-warning.active:hover, a.list-group-item-warning.active:focus {
    background-color: #fc9526;
    border-color: #fc9526;
    color: #fff;
}
.list-group-item-danger {
    background-color: #eb5745;
    color: #eb5745;
}
a.list-group-item-danger {
    color: #eb5745;
}
a.list-group-item-danger .list-group-item-heading {
    color: inherit;
}
a.list-group-item-danger:hover, a.list-group-item-danger:focus {
    background-color: #e9422e;
    color: #eb5745;
}
a.list-group-item-danger.active, a.list-group-item-danger.active:hover, a.list-group-item-danger.active:focus {
    background-color: #eb5745;
    border-color: #eb5745;
    color: #fff;
}
.list-group-item-heading {
    margin-bottom: 5px;
    margin-top: 0;
}
.list-group-item-text {
    line-height: 1.3;
    margin-bottom: 0;
}
.panel {
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 0;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
}
.panel-body {
    padding: 15px;
}
.panel-heading {
    border-bottom: 1px solid transparent;
    padding: 10px 15px;
}
.panel-heading > .dropdown .dropdown-toggle {
    color: inherit;
}
.panel-title {
    color: inherit;
    font-size: 16px;
    margin-bottom: 0;
    margin-top: 0;
}
.panel-title > a, .panel-title > small, .panel-title > .small, .panel-title > small > a, .panel-title > .small > a {
    color: inherit;
}
.panel-footer {
    background-color: #f5f5f5;
    border-top: 1px solid #ddd;
    padding: 10px 15px;
}
.panel > .list-group, .panel > .panel-collapse > .list-group {
    margin-bottom: 0;
}
.panel > .list-group .list-group-item, .panel > .panel-collapse > .list-group .list-group-item {
    border-radius: 0;
    border-width: 1px 0;
}
.panel > .list-group:first-child .list-group-item:first-child, .panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {
    border-top: 0 none;
}
.panel > .list-group:last-child .list-group-item:last-child, .panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {
    border-bottom: 0 none;
}
.panel-heading + .list-group .list-group-item:first-child {
    border-top-width: 0;
}
.list-group + .panel-footer {
    border-top-width: 0;
}
.panel > .table, .panel > .table-responsive > .table, .panel > .panel-collapse > .table {
    margin-bottom: 0;
}
.panel > .table caption, .panel > .table-responsive > .table caption, .panel > .panel-collapse > .table caption {
    padding-left: 15px;
    padding-right: 15px;
}
.panel > .table:first-child, .panel > .table-responsive:first-child > .table:first-child {
}
.panel > .table:first-child > thead:first-child > tr:first-child, .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child, .panel > .table:first-child > tbody:first-child > tr:first-child, .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {
}
.panel > .table:first-child > thead:first-child > tr:first-child td:first-child, .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child, .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child, .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child, .panel > .table:first-child > thead:first-child > tr:first-child th:first-child, .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child, .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child, .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {
}
.panel > .table:first-child > thead:first-child > tr:first-child td:last-child, .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child, .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child, .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child, .panel > .table:first-child > thead:first-child > tr:first-child th:last-child, .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child, .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child, .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {
}
.panel > .table:last-child, .panel > .table-responsive:last-child > .table:last-child {
}
.panel > .table:last-child > tbody:last-child > tr:last-child, .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child, .panel > .table:last-child > tfoot:last-child > tr:last-child, .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child, .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child, .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child, .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child, .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child, .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child, .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child, .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child, .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child, .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child, .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child, .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child, .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {
}
.panel > .panel-body + .table, .panel > .panel-body + .table-responsive, .panel > .table + .panel-body, .panel > .table-responsive + .panel-body {
    border-top: 1px solid #ddd;
}
.panel > .table > tbody:first-child > tr:first-child th, .panel > .table > tbody:first-child > tr:first-child td {
    border-top: 0 none;
}
.panel > .table-bordered, .panel > .table-responsive > .table-bordered {
    border: 0 none;
}
.panel > .table-bordered > thead > tr > th:first-child, .panel > .table-responsive > .table-bordered > thead > tr > th:first-child, .panel > .table-bordered > tbody > tr > th:first-child, .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child, .panel > .table-bordered > tfoot > tr > th:first-child, .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child, .panel > .table-bordered > thead > tr > td:first-child, .panel > .table-responsive > .table-bordered > thead > tr > td:first-child, .panel > .table-bordered > tbody > tr > td:first-child, .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child, .panel > .table-bordered > tfoot > tr > td:first-child, .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0 none;
}
.panel > .table-bordered > thead > tr > th:last-child, .panel > .table-responsive > .table-bordered > thead > tr > th:last-child, .panel > .table-bordered > tbody > tr > th:last-child, .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child, .panel > .table-bordered > tfoot > tr > th:last-child, .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child, .panel > .table-bordered > thead > tr > td:last-child, .panel > .table-responsive > .table-bordered > thead > tr > td:last-child, .panel > .table-bordered > tbody > tr > td:last-child, .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child, .panel > .table-bordered > tfoot > tr > td:last-child, .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0 none;
}
.panel > .table-bordered > thead > tr:first-child > td, .panel > .table-responsive > .table-bordered > thead > tr:first-child > td, .panel > .table-bordered > tbody > tr:first-child > td, .panel > .table-responsive > .table-bordered > tbody > tr:first-child > td, .panel > .table-bordered > thead > tr:first-child > th, .panel > .table-responsive > .table-bordered > thead > tr:first-child > th, .panel > .table-bordered > tbody > tr:first-child > th, .panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {
    border-bottom: 0 none;
}
.panel > .table-bordered > tbody > tr:last-child > td, .panel > .table-responsive > .table-bordered > tbody > tr:last-child > td, .panel > .table-bordered > tfoot > tr:last-child > td, .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td, .panel > .table-bordered > tbody > tr:last-child > th, .panel > .table-responsive > .table-bordered > tbody > tr:last-child > th, .panel > .table-bordered > tfoot > tr:last-child > th, .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {
    border-bottom: 0 none;
}
.panel > .table-responsive {
    border: 0 none;
    margin-bottom: 0;
}
.panel-group {
    margin-bottom: 20px;
}
.panel-group .panel {
    border-radius: 0;
    margin-bottom: 0;
}
.panel-group .panel + .panel {
    margin-top: 5px;
}
.panel-group .panel-heading {
    border-bottom: 0 none;
}
.panel-group .panel-heading + .panel-collapse > .panel-body, .panel-group .panel-heading + .panel-collapse > .list-group {
    border-top: 1px solid #ddd;
}
.panel-group .panel-footer {
    border-top: 0 none;
}
.panel-group .panel-footer + .panel-collapse .panel-body {
    border-bottom: 1px solid #ddd;
}
.panel-default {
    border-color: #ff4d3a;
}
.panel-default > .panel-heading {
    background-color: #fff;
    border-color: #ff4d3a;
    color: #333;
}
.panel-default > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #ff4d3a;
}
.panel-default > .panel-heading .badge {
    background-color: #333;
    color: #fff;
}
.panel-default > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #ff4d3a;
}
.panel-primary {
    border-color: #248aaf;
}
.panel-primary > .panel-heading {
    background-color: #248aaf;
    border-color: #248aaf;
    color: #fff;
}
.panel-primary > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #248aaf;
}
.panel-primary > .panel-heading .badge {
    background-color: #fff;
    color: #248aaf;
}
.panel-primary > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #248aaf;
}
.panel-success {
    border-color: #36a96b;
}
.panel-success > .panel-heading {
    background-color: #3cbc8d;
    border-color: #36a96b;
    color: #fff;
}
.panel-success > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #36a96b;
}
.panel-success > .panel-heading .badge {
    background-color: #fff;
    color: #3cbc8d;
}
.panel-success > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #36a96b;
}
.panel-info {
    border-color: #28cbcb;
}
.panel-info > .panel-heading {
    background-color: #3dbfd9;
    border-color: #28cbcb;
    color: #fff;
}
.panel-info > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #28cbcb;
}
.panel-info > .panel-heading .badge {
    background-color: #fff;
    color: #3dbfd9;
}
.panel-info > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #28cbcb;
}
.panel-warning {
    border-color: #fc610d;
}
.panel-warning > .panel-heading {
    background-color: #fc9526;
    border-color: #fc610d;
    color: #fff;
}
.panel-warning > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #fc610d;
}
.panel-warning > .panel-heading .badge {
    background-color: #fff;
    color: #fc9526;
}
.panel-warning > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #fc610d;
}
.panel-danger {
    border-color: #e92e39;
}
.panel-danger > .panel-heading {
    background-color: #eb5745;
    border-color: #e92e39;
    color: #fff;
}
.panel-danger > .panel-heading + .panel-collapse > .panel-body {
    border-top-color: #e92e39;
}
.panel-danger > .panel-heading .badge {
    background-color: #fff;
    color: #eb5745;
}
.panel-danger > .panel-footer + .panel-collapse > .panel-body {
    border-bottom-color: #e92e39;
}
.well {
    background-color: #fff;
    border: 1px solid #ededed;
    border-radius: 0;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05) inset;
    margin-bottom: 20px;
    min-height: 20px;
    padding: 19px;
}
.well blockquote {
    border-color: rgba(0, 0, 0, 0.15);
}
.well-lg {
    border-radius: 0;
    padding: 24px;
}
.well-sm {
    border-radius: 0;
    padding: 9px;
}
.close {
    color: #000;
    float: right;
    font-size: 21px;
    font-weight: bold;
    line-height: 1;
    opacity: 0.2;
    text-shadow: 0 1px 0 #fff;
}
.close:hover, .close:focus {
    color: #000;
    cursor: pointer;
    opacity: 0.5;
    text-decoration: none;
}
button.close {
    background: transparent none repeat scroll 0 0;
    border: 0 none;
    cursor: pointer;
    padding: 0;
}
.modal-open {
    overflow: hidden;
}
.modal {
    bottom: 0;
    display: none;
    left: 0;
    outline: 0 none;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1040;
}
.modal.fade .modal-dialog {
    transform: translate(0px, -25%);
    transition: transform 0.3s ease-out 0s;
}
.modal.in .modal-dialog {
    transform: translate(0px, 0px);
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.modal-dialog {
    margin: 10px;
    position: relative;
    width: auto;
}
.modal-content {
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    outline: 0 none;
    position: relative;
}
.modal-backdrop {
    background-color: #000;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}
.modal-backdrop.fade {
    opacity: 0;
}
.modal-backdrop.in {
    opacity: 0.5;
}
.modal-header {
    border-bottom: 1px solid #e5e5e5;
    min-height: 16.4286px;
    padding: 15px;
}
.modal-header .close {
    margin-top: -2px;
}
.modal-title {
    line-height: 1.42857;
    margin: 0;
}
.modal-body {
    padding: 15px;
    position: relative;
}
.modal-footer {
    border-top: 1px solid #e5e5e5;
    padding: 15px;
    text-align: right;
}
.modal-footer .btn + .btn {
    margin-bottom: 0;
    margin-left: 5px;
}
.modal-footer .btn-group .btn + .btn {
    margin-left: -1px;
}
.modal-footer .btn-block + .btn-block {
    margin-left: 0;
}
.modal-scrollbar-measure {
    height: 50px;
    overflow: scroll;
    position: absolute;
    top: -9999px;
    width: 50px;
}
@media (min-width: 768px) {
.modal-dialog {
    margin: 30px auto;
    width: 600px;
}
.modal-content {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}
.modal-sm {
    width: 300px;
}
}
@media (min-width: 992px) {
.modal-lg {
    width: 900px;
}
}
.tooltip {
    display: block;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    opacity: 0;
    position: absolute;
    visibility: visible;
    z-index: 1070;
}
.tooltip.in {
    opacity: 0.9;
}
.tooltip.top {
    margin-top: -3px;
    padding: 5px 0;
}
.tooltip.right {
    margin-left: 3px;
    padding: 0 5px;
}
.tooltip.bottom {
    margin-top: 3px;
    padding: 5px 0;
}
.tooltip.left {
    margin-left: -3px;
    padding: 0 5px;
}
.tooltip-inner {
    background-color: #383838;
    border-radius: 0;
    color: #fff;
    max-width: 250px;
    padding: 3px 8px;
    text-align: center;
    text-decoration: none;
}
.tooltip-arrow {
    border-color: transparent;
    border-style: solid;
    height: 0;
    position: absolute;
    width: 0;
}
.tooltip.top .tooltip-arrow {
    border-top-color: #383838;
    border-width: 5px 5px 0;
    bottom: 0;
    left: 50%;
    margin-left: -5px;
}
.tooltip.top-left .tooltip-arrow {
    border-top-color: #383838;
    border-width: 5px 5px 0;
    bottom: 0;
    margin-bottom: -5px;
    right: 5px;
}
.tooltip.top-right .tooltip-arrow {
    border-top-color: #383838;
    border-width: 5px 5px 0;
    bottom: 0;
    left: 5px;
    margin-bottom: -5px;
}
.tooltip.right .tooltip-arrow {
    border-right-color: #383838;
    border-width: 5px 5px 5px 0;
    left: 0;
    margin-top: -5px;
    top: 50%;
}
.tooltip.left .tooltip-arrow {
    border-left-color: #383838;
    border-width: 5px 0 5px 5px;
    margin-top: -5px;
    right: 0;
    top: 50%;
}
.tooltip.bottom .tooltip-arrow {
    border-bottom-color: #383838;
    border-width: 0 5px 5px;
    left: 50%;
    margin-left: -5px;
    top: 0;
}
.tooltip.bottom-left .tooltip-arrow {
    border-bottom-color: #383838;
    border-width: 0 5px 5px;
    margin-top: -5px;
    right: 5px;
    top: 0;
}
.tooltip.bottom-right .tooltip-arrow {
    border-bottom-color: #383838;
    border-width: 0 5px 5px;
    left: 5px;
    margin-top: -5px;
    top: 0;
}
.popover {
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    display: none;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    font-weight: normal;
    left: 0;
    line-height: 1.42857;
    max-width: 276px;
    padding: 1px;
    position: absolute;
    text-align: left;
    top: 0;
    white-space: normal;
    z-index: 1060;
}
.popover.top {
    margin-top: -10px;
}
.popover.right {
    margin-left: 10px;
}
.popover.bottom {
    margin-top: 10px;
}
.popover.left {
    margin-left: -10px;
}
.popover-title {
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    font-size: 14px;
    margin: 0;
    padding: 8px 14px;
}
.popover-content {
    padding: 9px 14px;
}
.popover > .arrow, .popover > .arrow::after {
    border-color: transparent;
    border-style: solid;
    display: block;
    height: 0;
    position: absolute;
    width: 0;
}
.popover > .arrow {
    border-width: 11px;
}
.popover > .arrow::after {
    border-width: 10px;
    content: "";
}
.popover.top > .arrow {
    border-bottom-width: 0;
    border-top-color: rgba(0, 0, 0, 0.25);
    bottom: -11px;
    left: 50%;
    margin-left: -11px;
}
.popover.top > .arrow::after {
    border-bottom-width: 0;
    border-top-color: #fff;
    bottom: 1px;
    content: " ";
    margin-left: -10px;
}
.popover.right > .arrow {
    border-left-width: 0;
    border-right-color: rgba(0, 0, 0, 0.25);
    left: -11px;
    margin-top: -11px;
    top: 50%;
}
.popover.right > .arrow::after {
    border-left-width: 0;
    border-right-color: #fff;
    bottom: -10px;
    content: " ";
    left: 1px;
}
.popover.bottom > .arrow {
    border-bottom-color: rgba(0, 0, 0, 0.25);
    border-top-width: 0;
    left: 50%;
    margin-left: -11px;
    top: -11px;
}
.popover.bottom > .arrow::after {
    border-bottom-color: #fff;
    border-top-width: 0;
    content: " ";
    margin-left: -10px;
    top: 1px;
}
.popover.left > .arrow {
    border-left-color: rgba(0, 0, 0, 0.25);
    border-right-width: 0;
    margin-top: -11px;
    right: -11px;
    top: 50%;
}
.popover.left > .arrow::after {
    border-left-color: #fff;
    border-right-width: 0;
    bottom: -10px;
    content: " ";
    right: 1px;
}
.carousel {
    position: relative;
}
.carousel-inner {
    overflow: hidden;
    position: relative;
    width: 100%;
}
.carousel-inner > .item {
    display: none;
    position: relative;
    transition: left 0.6s ease-in-out 0s;
}
.carousel-inner > .item > img, .carousel-inner > .item > a > img {
    line-height: 1;
}
@media not all, not all {
.carousel-inner > .item {
    backface-visibility: hidden;
    transition: transform 0.6s ease-in-out 0s;
}
.carousel-inner > .item.next, .carousel-inner > .item.active.right {
    left: 0;
    transform: translate3d(100%, 0px, 0px);
}
.carousel-inner > .item.prev, .carousel-inner > .item.active.left {
    left: 0;
    transform: translate3d(-100%, 0px, 0px);
}
.carousel-inner > .item.next.left, .carousel-inner > .item.prev.right, .carousel-inner > .item.active {
    left: 0;
    transform: translate3d(0px, 0px, 0px);
}
}
.carousel-inner > .active, .carousel-inner > .next, .carousel-inner > .prev {
    display: block;
}
.carousel-inner > .active {
    left: 0;
}
.carousel-inner > .next, .carousel-inner > .prev {
    position: absolute;
    top: 0;
    width: 100%;
}
.carousel-inner > .next {
    left: 100%;
}
.carousel-inner > .prev {
    left: -100%;
}
.carousel-inner > .next.left, .carousel-inner > .prev.right {
    left: 0;
}
.carousel-inner > .active.left {
    left: -100%;
}
.carousel-inner > .active.right {
    left: 100%;
}
.carousel-control {
    bottom: 0;
    color: #fff;
    font-size: 20px;
    left: 0;
    opacity: 0.5;
    position: absolute;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
    top: 0;
    width: 15%;
}
.carousel-control.left {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0px, rgba(0, 0, 0, 0) 100%);
    background-repeat: repeat-x;
}
.carousel-control.right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0px, rgba(0, 0, 0, 0.5) 100%);
    background-repeat: repeat-x;
    left: auto;
    right: 0;
}
.carousel-control:hover, .carousel-control:focus {
    color: #fff;
    opacity: 0.9;
    outline: 0 none;
    text-decoration: none;
}
.carousel-control .icon-prev, .carousel-control .icon-next, .carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right {
    display: inline-block;
    position: absolute;
    top: 50%;
    z-index: 5;
}
.carousel-control .icon-prev, .carousel-control .glyphicon-chevron-left {
    left: 50%;
    margin-left: -10px;
}
.carousel-control .icon-next, .carousel-control .glyphicon-chevron-right {
    margin-right: -10px;
    right: 50%;
}
.carousel-control .icon-prev, .carousel-control .icon-next {
    font-family: serif;
    height: 20px;
    line-height: 1;
    margin-top: -10px;
    width: 20px;
}
.carousel-control .icon-prev::before {
    content: "鈥�";
}
.carousel-control .icon-next::before {
    content: "鈥�";
}
.carousel-indicators {
    bottom: 10px;
    left: 50%;
    list-style: outside none none;
    margin-left: -30%;
    padding-left: 0;
    position: absolute;
    text-align: center;
    width: 60%;
    z-index: 15;
}
.carousel-indicators li {
    background-color: rgba(0, 0, 0, 0);
    border: 1px solid #fff;
    border-radius: 10px;
    cursor: pointer;
    display: inline-block;
    height: 10px;
    margin: 1px;
    text-indent: -999px;
    width: 10px;
}
.carousel-indicators .active {
    background-color: #fff;
    height: 12px;
    margin: 0;
    width: 12px;
}
.carousel-caption {
    bottom: 20px;
    color: #fff;
    left: 15%;
    padding-bottom: 20px;
    padding-top: 20px;
    position: absolute;
    right: 15%;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
    z-index: 10;
}
.carousel-caption .btn {
    text-shadow: none;
}
@media screen and (min-width: 768px) {
.carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right, .carousel-control .icon-prev, .carousel-control .icon-next {
    font-size: 30px;
    height: 30px;
    margin-top: -15px;
    width: 30px;
}
.carousel-control .glyphicon-chevron-left, .carousel-control .icon-prev {
    margin-left: -15px;
}
.carousel-control .glyphicon-chevron-right, .carousel-control .icon-next {
    margin-right: -15px;
}
.carousel-caption {
    left: 20%;
    padding-bottom: 30px;
    right: 20%;
}
.carousel-indicators {
    bottom: 20px;
}
}
.clearfix::before, .clearfix::after, .dl-horizontal dd::before, .dl-horizontal dd::after, .container::before, .container::after, .container-fluid::before, .container-fluid::after, .row::before, .row::after, .form-horizontal .form-group::before, .form-horizontal .form-group::after, .btn-toolbar::before, .btn-toolbar::after, .btn-group-vertical > .btn-group::before, .btn-group-vertical > .btn-group::after, .nav::before, .nav::after, .navbar::before, .navbar::after, .navbar-header::before, .navbar-header::after, .navbar-collapse::before, .navbar-collapse::after, .pager::before, .pager::after, .panel-body::before, .panel-body::after, .modal-footer::before, .modal-footer::after {
    content: " ";
    display: table;
}
.clearfix::after, .dl-horizontal dd::after, .container::after, .container-fluid::after, .row::after, .form-horizontal .form-group::after, .btn-toolbar::after, .btn-group-vertical > .btn-group::after, .nav::after, .navbar::after, .navbar-header::after, .navbar-collapse::after, .pager::after, .panel-body::after, .modal-footer::after {
    clear: both;
}
.center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.pull-right {
    float: right !important;
}
.pull-left {
    float: left !important;
}
.hide {
    display: none !important;
}
.show {
    display: block !important;
}
.invisible {
    visibility: hidden;
}
.text-hide {
    background-color: transparent;
    border: 0 none;
    color: transparent;
    font: 0px/0 a;
    text-shadow: none;
}
.hidden {
    display: none !important;
    visibility: hidden !important;
}
.affix {
    position: fixed;
}
.visible-xs, .visible-sm, .visible-md, .visible-lg {
    display: none !important;
}
.visible-xs-block, .visible-xs-inline, .visible-xs-inline-block, .visible-sm-block, .visible-sm-inline, .visible-sm-inline-block, .visible-md-block, .visible-md-inline, .visible-md-inline-block, .visible-lg-block, .visible-lg-inline, .visible-lg-inline-block {
    display: none !important;
}
@media (max-width: 767px) {
.visible-xs {
    display: block !important;
}
table.visible-xs {
    display: table;
}
tr.visible-xs {
    display: table-row !important;
}
th.visible-xs, td.visible-xs {
    display: table-cell !important;
}
}
@media (max-width: 767px) {
.visible-xs-block {
    display: block !important;
}
}
@media (max-width: 767px) {
.visible-xs-inline {
    display: inline !important;
}
}
@media (max-width: 767px) {
.visible-xs-inline-block {
    display: inline-block !important;
}
}
@media (min-width: 768px) and (max-width: 991px) {
.visible-sm {
    display: block !important;
}
table.visible-sm {
    display: table;
}
tr.visible-sm {
    display: table-row !important;
}
th.visible-sm, td.visible-sm {
    display: table-cell !important;
}
}
@media (min-width: 768px) and (max-width: 991px) {
.visible-sm-block {
    display: block !important;
}
}
@media (min-width: 768px) and (max-width: 991px) {
.visible-sm-inline {
    display: inline !important;
}
}
@media (min-width: 768px) and (max-width: 991px) {
.visible-sm-inline-block {
    display: inline-block !important;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
.visible-md {
    display: block !important;
}
table.visible-md {
    display: table;
}
tr.visible-md {
    display: table-row !important;
}
th.visible-md, td.visible-md {
    display: table-cell !important;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
.visible-md-block {
    display: block !important;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
.visible-md-inline {
    display: inline !important;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
.visible-md-inline-block {
    display: inline-block !important;
}
}
@media (min-width: 1200px) {
.visible-lg {
    display: block !important;
}
table.visible-lg {
    display: table;
}
tr.visible-lg {
    display: table-row !important;
}
th.visible-lg, td.visible-lg {
    display: table-cell !important;
}
}
@media (min-width: 1200px) {
.visible-lg-block {
    display: block !important;
}
}
@media (min-width: 1200px) {
.visible-lg-inline {
    display: inline !important;
}
}
@media (min-width: 1200px) {
.visible-lg-inline-block {
    display: inline-block !important;
}
}
@media (max-width: 767px) {
.hidden-xs {
    display: none !important;
}
}
@media (min-width: 768px) and (max-width: 991px) {
.hidden-sm {
    display: none !important;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
.hidden-md {
    display: none !important;
}
}
@media (min-width: 1200px) {
.hidden-lg {
    display: none !important;
}
}
.visible-print {
    display: none !important;
}
@media print {
.visible-print {
    display: block !important;
}
table.visible-print {
    display: table;
}
tr.visible-print {
    display: table-row !important;
}
th.visible-print, td.visible-print {
    display: table-cell !important;
}
}
.visible-print-block {
    display: none !important;
}
@media print {
.visible-print-block {
    display: block !important;
}
}
.visible-print-inline {
    display: none !important;
}
@media print {
.visible-print-inline {
    display: inline !important;
}
}
.visible-print-inline-block {
    display: none !important;
}
@media print {
.visible-print-inline-block {
    display: inline-block !important;
}
}
@media print {
.hidden-print {
    display: none !important;
}
}
/*!
 *  Font Awesome 4.4.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: 'FontAwesome';
  /* src: url('../fonts/fontawesome-webfont.eot?v=4.4.0'); */
  /* src: url('../fonts/fontawesome-webfont.eot?#iefix&v=4.4.0') format('embedded-opentype'), url('../fonts/fontawesome-webfont.woff2?v=4.4.0') format('woff2'), url('../fonts/fontawesome-webfont.woff?v=4.4.0') format('woff'), url('../fonts/fontawesome-webfont.ttf?v=4.4.0') format('truetype'), url('../fonts/fontawesome-webfont.svg?v=4.4.0#fontawesomeregular') format('svg'); */
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 ;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-fw {
  width: 1.28571429em;
  text-align: center;
}
.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}
.fa-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.85714286em;
}
.fa-border {
  padding: .2em .25em .15em;
  border: solid 0.08em #eeeeee;
  border-radius: .1em;
}
.fa-pull-left {
  float: left;
}
.fa-pull-right {
  float: right;
}
.fa.fa-pull-left {
  margin-right: .3em;
}
.fa.fa-pull-right {
  margin-left: .3em;
}
/* Deprecated as of 4.4.0 */
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
.fa.pull-left {
  margin-right: .3em;
}
.fa.pull-right {
  margin-left: .3em;
}
.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}
.fa-pulse {
  -webkit-animation: fa-spin 1s infinite steps(8);
  animation: fa-spin 1s infinite steps(8);
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.fa-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.fa-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.fa-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  -webkit-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  transform: scale(-1, 1);
}
.fa-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  -webkit-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical {
  filter: none;
}
.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}
.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.fa-stack-1x {
  line-height: inherit;
}
.fa-stack-2x {
  font-size: 2em;
}
.fa-inverse {
  color: #ffffff;
}
/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\f000";
}
.fa-music:before {
  content: "\f001";
}
.fa-search:before {
  content: "\f002";
}
.fa-envelope-o:before {
  content: "\f003";
}
.fa-heart:before {
  content: "\f004";
}
.fa-star:before {
  content: "\f005";
}
.fa-star-o:before {
  content: "\f006";
}
.fa-user:before {
  content: "\f007";
}
.fa-film:before {
  content: "\f008";
}
.fa-th-large:before {
  content: "\f009";
}
.fa-th:before {
  content: "\f00a";
}
.fa-th-list:before {
  content: "\f00b";
}
.fa-check:before {
  content: "\f00c";
}
.fa-remove:before,
.fa-close:before,
.fa-times:before {
  content: "\f00d";
}
.fa-search-plus:before {
  content: "\f00e";
}
.fa-search-minus:before {
  content: "\f010";
}
.fa-power-off:before {
  content: "\f011";
}
.fa-signal:before {
  content: "\f012";
}
.fa-gear:before,
.fa-cog:before {
  content: "\f013";
}
.fa-trash-o:before {
  content: "\f014";
}
.fa-home:before {
  content: "\f015";
}
.fa-file-o:before {
  content: "\f016";
}
.fa-clock-o:before {
  content: "\f017";
}
.fa-road:before {
  content: "\f018";
}
.fa-download:before {
  content: "\f019";
}
.fa-arrow-circle-o-down:before {
  content: "\f01a";
}
.fa-arrow-circle-o-up:before {
  content: "\f01b";
}
.fa-inbox:before {
  content: "\f01c";
}
.fa-play-circle-o:before {
  content: "\f01d";
}
.fa-rotate-right:before,
.fa-repeat:before {
  content: "\f01e";
}
.fa-refresh:before {
  content: "\f021";
}
.fa-list-alt:before {
  content: "\f022";
}
.fa-lock:before {
  content: "\f023";
}
.fa-flag:before {
  content: "\f024";
}
.fa-headphones:before {
  content: "\f025";
}
.fa-volume-off:before {
  content: "\f026";
}
.fa-volume-down:before {
  content: "\f027";
}
.fa-volume-up:before {
  content: "\f028";
}
.fa-qrcode:before {
  content: "\f029";
}
.fa-barcode:before {
  content: "\f02a";
}
.fa-tag:before {
  content: "\f02b";
}
.fa-tags:before {
  content: "\f02c";
}
.fa-book:before {
  content: "\f02d";
}
.fa-bookmark:before {
  content: "\f02e";
}
.fa-print:before {
  content: "\f02f";
}
.fa-camera:before {
  content: "\f030";
}
.fa-font:before {
  content: "\f031";
}
.fa-bold:before {
  content: "\f032";
}
.fa-italic:before {
  content: "\f033";
}
.fa-text-height:before {
  content: "\f034";
}
.fa-text-width:before {
  content: "\f035";
}
.fa-align-left:before {
  content: "\f036";
}
.fa-align-center:before {
  content: "\f037";
}
.fa-align-right:before {
  content: "\f038";
}
.fa-align-justify:before {
  content: "\f039";
}
.fa-list:before {
  content: "\f03a";
}
.fa-dedent:before,
.fa-outdent:before {
  content: "\f03b";
}
.fa-indent:before {
  content: "\f03c";
}
.fa-video-camera:before {
  content: "\f03d";
}
.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: "\f03e";
}
.fa-pencil:before {
  content: "\f040";
}
.fa-map-marker:before {
  content: "\f041";
}
.fa-adjust:before {
  content: "\f042";
}
.fa-tint:before {
  content: "\f043";
}
.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\f044";
}
.fa-share-square-o:before {
  content: "\f045";
}
.fa-check-square-o:before {
  content: "\f046";
}
.fa-arrows:before {
  content: "\f047";
}
.fa-step-backward:before {
  content: "\f048";
}
.fa-fast-backward:before {
  content: "\f049";
}
.fa-backward:before {
  content: "\f04a";
}
.fa-play:before {
  content: "\f04b";
}
.fa-pause:before {
  content: "\f04c";
}
.fa-stop:before {
  content: "\f04d";
}
.fa-forward:before {
  content: "\f04e";
}
.fa-fast-forward:before {
  content: "\f050";
}
.fa-step-forward:before {
  content: "\f051";
}
.fa-eject:before {
  content: "\f052";
}
.fa-chevron-left:before {
  content: "\f053";
}
.fa-chevron-right:before {
  content: "\f054";
}
.fa-plus-circle:before {
  content: "\f055";
}
.fa-minus-circle:before {
  content: "\f056";
}
.fa-times-circle:before {
  content: "\f057";
}
.fa-check-circle:before {
  content: "\f058";
}
.fa-question-circle:before {
  content: "\f059";
}
.fa-info-circle:before {
  content: "\f05a";
}
.fa-crosshairs:before {
  content: "\f05b";
}
.fa-times-circle-o:before {
  content: "\f05c";
}
.fa-check-circle-o:before {
  content: "\f05d";
}
.fa-ban:before {
  content: "\f05e";
}
.fa-arrow-left:before {
  content: "\f060";
}
.fa-arrow-right:before {
  content: "\f061";
}
.fa-arrow-up:before {
  content: "\f062";
}
.fa-arrow-down:before {
  content: "\f063";
}
.fa-mail-forward:before,
.fa-share:before {
  content: "\f064";
}
.fa-expand:before {
  content: "\f065";
}
.fa-compress:before {
  content: "\f066";
}
.fa-plus:before {
  content: "\f067";
}
.fa-minus:before {
  content: "\f068";
}
.fa-asterisk:before {
  content: "\f069";
}
.fa-exclamation-circle:before {
  content: "\f06a";
}
.fa-gift:before {
  content: "\f06b";
}
.fa-leaf:before {
  content: "\f06c";
}
.fa-fire:before {
  content: "\f06d";
}
.fa-eye:before {
  content: "\f06e";
}
.fa-eye-slash:before {
  content: "\f070";
}
.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\f071";
}
.fa-plane:before {
  content: "\f072";
}
.fa-calendar:before {
  content: "\f073";
}
.fa-random:before {
  content: "\f074";
}
.fa-comment:before {
  content: "\f075";
}
.fa-magnet:before {
  content: "\f076";
}
.fa-chevron-up:before {
  content: "\f077";
}
.fa-chevron-down:before {
  content: "\f078";
}
.fa-retweet:before {
  content: "\f079";
}
.fa-shopping-cart:before {
  content: "\f07a";
}
.fa-folder:before {
  content: "\f07b";
}
.fa-folder-open:before {
  content: "\f07c";
}
.fa-arrows-v:before {
  content: "\f07d";
}
.fa-arrows-h:before {
  content: "\f07e";
}
.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\f080";
}
.fa-twitter-square:before {
  content: "\f081";
}
.fa-facebook-square:before {
  content: "\f082";
}
.fa-camera-retro:before {
  content: "\f083";
}
.fa-key:before {
  content: "\f084";
}
.fa-gears:before,
.fa-cogs:before {
  content: "\f085";
}
.fa-comments:before {
  content: "\f086";
}
.fa-thumbs-o-up:before {
  content: "\f087";
}
.fa-thumbs-o-down:before {
  content: "\f088";
}
.fa-star-half:before {
  content: "\f089";
}
.fa-heart-o:before {
  content: "\f08a";
}
.fa-sign-out:before {
  content: "\f08b";
}
.fa-linkedin-square:before {
  content: "\f08c";
}
.fa-thumb-tack:before {
  content: "\f08d";
}
.fa-external-link:before {
  content: "\f08e";
}
.fa-sign-in:before {
  content: "\f090";
}
.fa-trophy:before {
  content: "\f091";
}
.fa-github-square:before {
  content: "\f092";
}
.fa-upload:before {
  content: "\f093";
}
.fa-lemon-o:before {
  content: "\f094";
}
.fa-phone:before {
  content: "\f095";
}
.fa-square-o:before {
  content: "\f096";
}
.fa-bookmark-o:before {
  content: "\f097";
}
.fa-phone-square:before {
  content: "\f098";
}
.fa-twitter:before {
  content: "\f099";
}
.fa-facebook-f:before,
.fa-facebook:before {
  content: "\f09a";
}
.fa-github:before {
  content: "\f09b";
}
.fa-unlock:before {
  content: "\f09c";
}
.fa-credit-card:before {
  content: "\f09d";
}
.fa-feed:before,
.fa-rss:before {
  content: "\f09e";
}
.fa-hdd-o:before {
  content: "\f0a0";
}
.fa-bullhorn:before {
  content: "\f0a1";
}
.fa-bell:before {
  content: "\f0f3";
}
.fa-certificate:before {
  content: "\f0a3";
}
.fa-hand-o-right:before {
  content: "\f0a4";
}
.fa-hand-o-left:before {
  content: "\f0a5";
}
.fa-hand-o-up:before {
  content: "\f0a6";
}
.fa-hand-o-down:before {
  content: "\f0a7";
}
.fa-arrow-circle-left:before {
  content: "\f0a8";
}
.fa-arrow-circle-right:before {
  content: "\f0a9";
}
.fa-arrow-circle-up:before {
  content: "\f0aa";
}
.fa-arrow-circle-down:before {
  content: "\f0ab";
}
.fa-globe:before {
  content: "\f0ac";
}
.fa-wrench:before {
  content: "\f0ad";
}
.fa-tasks:before {
  content: "\f0ae";
}
.fa-filter:before {
  content: "\f0b0";
}
.fa-briefcase:before {
  content: "\f0b1";
}
.fa-arrows-alt:before {
  content: "\f0b2";
}
.fa-group:before,
.fa-users:before {
  content: "\f0c0";
}
.fa-chain:before,
.fa-link:before {
  content: "\f0c1";
}
.fa-cloud:before {
  content: "\f0c2";
}
.fa-flask:before {
  content: "\f0c3";
}
.fa-cut:before,
.fa-scissors:before {
  content: "\f0c4";
}
.fa-copy:before,
.fa-files-o:before {
  content: "\f0c5";
}
.fa-paperclip:before {
  content: "\f0c6";
}
.fa-save:before,
.fa-floppy-o:before {
  content: "\f0c7";
}
.fa-square:before {
  content: "\f0c8";
}
.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\f0c9";
}
.fa-list-ul:before {
  content: "\f0ca";
}
.fa-list-ol:before {
  content: "\f0cb";
}
.fa-strikethrough:before {
  content: "\f0cc";
}
.fa-underline:before {
  content: "\f0cd";
}
.fa-table:before {
  content: "\f0ce";
}
.fa-magic:before {
  content: "\f0d0";
}
.fa-truck:before {
  content: "\f0d1";
}
.fa-pinterest:before {
  content: "\f0d2";
}
.fa-pinterest-square:before {
  content: "\f0d3";
}
.fa-google-plus-square:before {
  content: "\f0d4";
}
.fa-google-plus:before {
  content: "\f0d5";
}
.fa-money:before {
  content: "\f0d6";
}
.fa-caret-down:before {
  content: "\f0d7";
}
.fa-caret-up:before {
  content: "\f0d8";
}
.fa-caret-left:before {
  content: "\f0d9";
}
.fa-caret-right:before {
  content: "\f0da";
}
.fa-columns:before {
  content: "\f0db";
}
.fa-unsorted:before,
.fa-sort:before {
  content: "\f0dc";
}
.fa-sort-down:before,
.fa-sort-desc:before {
  content: "\f0dd";
}
.fa-sort-up:before,
.fa-sort-asc:before {
  content: "\f0de";
}
.fa-envelope:before {
  content: "\f0e0";
}
.fa-linkedin:before {
  content: "\f0e1";
}
.fa-rotate-left:before,
.fa-undo:before {
  content: "\f0e2";
}
.fa-legal:before,
.fa-gavel:before {
  content: "\f0e3";
}
.fa-dashboard:before,
.fa-tachometer:before {
  content: "\f0e4";
}
.fa-comment-o:before {
  content: "\f0e5";
}
.fa-comments-o:before {
  content: "\f0e6";
}
.fa-flash:before,
.fa-bolt:before {
  content: "\f0e7";
}
.fa-sitemap:before {
  content: "\f0e8";
}
.fa-umbrella:before {
  content: "\f0e9";
}
.fa-paste:before,
.fa-clipboard:before {
  content: "\f0ea";
}
.fa-lightbulb-o:before {
  content: "\f0eb";
}
.fa-exchange:before {
  content: "\f0ec";
}
.fa-cloud-download:before {
  content: "\f0ed";
}
.fa-cloud-upload:before {
  content: "\f0ee";
}
.fa-user-md:before {
  content: "\f0f0";
}
.fa-stethoscope:before {
  content: "\f0f1";
}
.fa-suitcase:before {
  content: "\f0f2";
}
.fa-bell-o:before {
  content: "\f0a2";
}
.fa-coffee:before {
  content: "\f0f4";
}
.fa-cutlery:before {
  content: "\f0f5";
}
.fa-file-text-o:before {
  content: "\f0f6";
}
.fa-building-o:before {
  content: "\f0f7";
}
.fa-hospital-o:before {
  content: "\f0f8";
}
.fa-ambulance:before {
  content: "\f0f9";
}
.fa-medkit:before {
  content: "\f0fa";
}
.fa-fighter-jet:before {
  content: "\f0fb";
}
.fa-beer:before {
  content: "\f0fc";
}
.fa-h-square:before {
  content: "\f0fd";
}
.fa-plus-square:before {
  content: "\f0fe";
}
.fa-angle-double-left:before {
  content: "\f100";
}
.fa-angle-double-right:before {
  content: "\f101";
}
.fa-angle-double-up:before {
  content: "\f102";
}
.fa-angle-double-down:before {
  content: "\f103";
}
.fa-angle-left:before {
  content: "\f104";
}
.fa-angle-right:before {
  content: "\f105";
}
.fa-angle-up:before {
  content: "\f106";
}
.fa-angle-down:before {
  content: "\f107";
}
.fa-desktop:before {
  content: "\f108";
}
.fa-laptop:before {
  content: "\f109";
}
.fa-tablet:before {
  content: "\f10a";
}
.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\f10b";
}
.fa-circle-o:before {
  content: "\f10c";
}
.fa-quote-left:before {
  content: "\f10d";
}
.fa-quote-right:before {
  content: "\f10e";
}
.fa-spinner:before {
  content: "\f110";
}
.fa-circle:before {
  content: "\f111";
}
.fa-mail-reply:before,
.fa-reply:before {
  content: "\f112";
}
.fa-github-alt:before {
  content: "\f113";
}
.fa-folder-o:before {
  content: "\f114";
}
.fa-folder-open-o:before {
  content: "\f115";
}
.fa-smile-o:before {
  content: "\f118";
}
.fa-frown-o:before {
  content: "\f119";
}
.fa-meh-o:before {
  content: "\f11a";
}
.fa-gamepad:before {
  content: "\f11b";
}
.fa-keyboard-o:before {
  content: "\f11c";
}
.fa-flag-o:before {
  content: "\f11d";
}
.fa-flag-checkered:before {
  content: "\f11e";
}
.fa-terminal:before {
  content: "\f120";
}
.fa-code:before {
  content: "\f121";
}
.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\f122";
}
.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\f123";
}
.fa-location-arrow:before {
  content: "\f124";
}
.fa-crop:before {
  content: "\f125";
}
.fa-code-fork:before {
  content: "\f126";
}
.fa-unlink:before,
.fa-chain-broken:before {
  content: "\f127";
}
.fa-question:before {
  content: "\f128";
}
.fa-info:before {
  content: "\f129";
}
.fa-exclamation:before {
  content: "\f12a";
}
.fa-superscript:before {
  content: "\f12b";
}
.fa-subscript:before {
  content: "\f12c";
}
.fa-eraser:before {
  content: "\f12d";
}
.fa-puzzle-piece:before {
  content: "\f12e";
}
.fa-microphone:before {
  content: "\f130";
}
.fa-microphone-slash:before {
  content: "\f131";
}
.fa-shield:before {
  content: "\f132";
}
.fa-calendar-o:before {
  content: "\f133";
}
.fa-fire-extinguisher:before {
  content: "\f134";
}
.fa-rocket:before {
  content: "\f135";
}
.fa-maxcdn:before {
  content: "\f136";
}
.fa-chevron-circle-left:before {
  content: "\f137";
}
.fa-chevron-circle-right:before {
  content: "\f138";
}
.fa-chevron-circle-up:before {
  content: "\f139";
}
.fa-chevron-circle-down:before {
  content: "\f13a";
}
.fa-html5:before {
  content: "\f13b";
}
.fa-css3:before {
  content: "\f13c";
}
.fa-anchor:before {
  content: "\f13d";
}
.fa-unlock-alt:before {
  content: "\f13e";
}
.fa-bullseye:before {
  content: "\f140";
}
.fa-ellipsis-h:before {
  content: "\f141";
}
.fa-ellipsis-v:before {
  content: "\f142";
}
.fa-rss-square:before {
  content: "\f143";
}
.fa-play-circle:before {
  content: "\f144";
}
.fa-ticket:before {
  content: "\f145";
}
.fa-minus-square:before {
  content: "\f146";
}
.fa-minus-square-o:before {
  content: "\f147";
}
.fa-level-up:before {
  content: "\f148";
}
.fa-level-down:before {
  content: "\f149";
}
.fa-check-square:before {
  content: "\f14a";
}
.fa-pencil-square:before {
  content: "\f14b";
}
.fa-external-link-square:before {
  content: "\f14c";
}
.fa-share-square:before {
  content: "\f14d";
}
.fa-compass:before {
  content: "\f14e";
}
.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\f150";
}
.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\f151";
}
.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\f152";
}
.fa-euro:before,
.fa-eur:before {
  content: "\f153";
}
.fa-gbp:before {
  content: "\f154";
}
.fa-dollar:before,
.fa-usd:before {
  content: "\f155";
}
.fa-rupee:before,
.fa-inr:before {
  content: "\f156";
}
.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\f157";
}
.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\f158";
}
.fa-won:before,
.fa-krw:before {
  content: "\f159";
}
.fa-bitcoin:before,
.fa-btc:before {
  content: "\f15a";
}
.fa-file:before {
  content: "\f15b";
}
.fa-file-text:before {
  content: "\f15c";
}
.fa-sort-alpha-asc:before {
  content: "\f15d";
}
.fa-sort-alpha-desc:before {
  content: "\f15e";
}
.fa-sort-amount-asc:before {
  content: "\f160";
}
.fa-sort-amount-desc:before {
  content: "\f161";
}
.fa-sort-numeric-asc:before {
  content: "\f162";
}
.fa-sort-numeric-desc:before {
  content: "\f163";
}
.fa-thumbs-up:before {
  content: "\f164";
}
.fa-thumbs-down:before {
  content: "\f165";
}
.fa-youtube-square:before {
  content: "\f166";
}
.fa-youtube:before {
  content: "\f167";
}
.fa-xing:before {
  content: "\f168";
}
.fa-xing-square:before {
  content: "\f169";
}
.fa-youtube-play:before {
  content: "\f16a";
}
.fa-dropbox:before {
  content: "\f16b";
}
.fa-stack-overflow:before {
  content: "\f16c";
}
.fa-instagram:before {
  content: "\f16d";
}
.fa-flickr:before {
  content: "\f16e";
}
.fa-adn:before {
  content: "\f170";
}
.fa-bitbucket:before {
  content: "\f171";
}
.fa-bitbucket-square:before {
  content: "\f172";
}
.fa-tumblr:before {
  content: "\f173";
}
.fa-tumblr-square:before {
  content: "\f174";
}
.fa-long-arrow-down:before {
  content: "\f175";
}
.fa-long-arrow-up:before {
  content: "\f176";
}
.fa-long-arrow-left:before {
  content: "\f177";
}
.fa-long-arrow-right:before {
  content: "\f178";
}
.fa-apple:before {
  content: "\f179";
}
.fa-windows:before {
  content: "\f17a";
}
.fa-android:before {
  content: "\f17b";
}
.fa-linux:before {
  content: "\f17c";
}
.fa-dribbble:before {
  content: "\f17d";
}
.fa-skype:before {
  content: "\f17e";
}
.fa-foursquare:before {
  content: "\f180";
}
.fa-trello:before {
  content: "\f181";
}
.fa-female:before {
  content: "\f182";
}
.fa-male:before {
  content: "\f183";
}
.fa-gittip:before,
.fa-gratipay:before {
  content: "\f184";
}
.fa-sun-o:before {
  content: "\f185";
}
.fa-moon-o:before {
  content: "\f186";
}
.fa-archive:before {
  content: "\f187";
}
.fa-bug:before {
  content: "\f188";
}
.fa-vk:before {
  content: "\f189";
}
.fa-weibo:before {
  content: "\f18a";
}
.fa-renren:before {
  content: "\f18b";
}
.fa-pagelines:before {
  content: "\f18c";
}
.fa-stack-exchange:before {
  content: "\f18d";
}
.fa-arrow-circle-o-right:before {
  content: "\f18e";
}
.fa-arrow-circle-o-left:before {
  content: "\f190";
}
.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\f191";
}
.fa-dot-circle-o:before {
  content: "\f192";
}
.fa-wheelchair:before {
  content: "\f193";
}
.fa-vimeo-square:before {
  content: "\f194";
}
.fa-turkish-lira:before,
.fa-try:before {
  content: "\f195";
}
.fa-plus-square-o:before {
  content: "\f196";
}
.fa-space-shuttle:before {
  content: "\f197";
}
.fa-slack:before {
  content: "\f198";
}
.fa-envelope-square:before {
  content: "\f199";
}
.fa-wordpress:before {
  content: "\f19a";
}
.fa-openid:before {
  content: "\f19b";
}
.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: "\f19c";
}
.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: "\f19d";
}
.fa-yahoo:before {
  content: "\f19e";
}
.fa-google:before {
  content: "\f1a0";
}
.fa-reddit:before {
  content: "\f1a1";
}
.fa-reddit-square:before {
  content: "\f1a2";
}
.fa-stumbleupon-circle:before {
  content: "\f1a3";
}
.fa-stumbleupon:before {
  content: "\f1a4";
}
.fa-delicious:before {
  content: "\f1a5";
}
.fa-digg:before {
  content: "\f1a6";
}
.fa-pied-piper:before {
  content: "\f1a7";
}
.fa-pied-piper-alt:before {
  content: "\f1a8";
}
.fa-drupal:before {
  content: "\f1a9";
}
.fa-joomla:before {
  content: "\f1aa";
}
.fa-language:before {
  content: "\f1ab";
}
.fa-fax:before {
  content: "\f1ac";
}
.fa-building:before {
  content: "\f1ad";
}
.fa-child:before {
  content: "\f1ae";
}
.fa-paw:before {
  content: "\f1b0";
}
.fa-spoon:before {
  content: "\f1b1";
}
.fa-cube:before {
  content: "\f1b2";
}
.fa-cubes:before {
  content: "\f1b3";
}
.fa-behance:before {
  content: "\f1b4";
}
.fa-behance-square:before {
  content: "\f1b5";
}
.fa-steam:before {
  content: "\f1b6";
}
.fa-steam-square:before {
  content: "\f1b7";
}
.fa-recycle:before {
  content: "\f1b8";
}
.fa-automobile:before,
.fa-car:before {
  content: "\f1b9";
}
.fa-cab:before,
.fa-taxi:before {
  content: "\f1ba";
}
.fa-tree:before {
  content: "\f1bb";
}
.fa-spotify:before {
  content: "\f1bc";
}
.fa-deviantart:before {
  content: "\f1bd";
}
.fa-soundcloud:before {
  content: "\f1be";
}
.fa-database:before {
  content: "\f1c0";
}
.fa-file-pdf-o:before {
  content: "\f1c1";
}
.fa-file-word-o:before {
  content: "\f1c2";
}
.fa-file-excel-o:before {
  content: "\f1c3";
}
.fa-file-powerpoint-o:before {
  content: "\f1c4";
}
.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: "\f1c5";
}
.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: "\f1c6";
}
.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: "\f1c7";
}
.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\f1c8";
}
.fa-file-code-o:before {
  content: "\f1c9";
}
.fa-vine:before {
  content: "\f1ca";
}
.fa-codepen:before {
  content: "\f1cb";
}
.fa-jsfiddle:before {
  content: "\f1cc";
}
.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: "\f1cd";
}
.fa-circle-o-notch:before {
  content: "\f1ce";
}
.fa-ra:before,
.fa-rebel:before {
  content: "\f1d0";
}
.fa-ge:before,
.fa-empire:before {
  content: "\f1d1";
}
.fa-git-square:before {
  content: "\f1d2";
}
.fa-git:before {
  content: "\f1d3";
}
.fa-y-combinator-square:before,
.fa-yc-square:before,
.fa-hacker-news:before {
  content: "\f1d4";
}
.fa-tencent-weibo:before {
  content: "\f1d5";
}
.fa-qq:before {
  content: "\f1d6";
}
.fa-wechat:before,
.fa-weixin:before {
  content: "\f1d7";
}
.fa-send:before,
.fa-paper-plane:before {
  content: "\f1d8";
}
.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\f1d9";
}
.fa-history:before {
  content: "\f1da";
}
.fa-circle-thin:before {
  content: "\f1db";
}
.fa-header:before {
  content: "\f1dc";
}
.fa-paragraph:before {
  content: "\f1dd";
}
.fa-sliders:before {
  content: "\f1de";
}
.fa-share-alt:before {
  content: "\f1e0";
}
.fa-share-alt-square:before {
  content: "\f1e1";
}
.fa-bomb:before {
  content: "\f1e2";
}
.fa-soccer-ball-o:before,
.fa-futbol-o:before {
  content: "\f1e3";
}
.fa-tty:before {
  content: "\f1e4";
}
.fa-binoculars:before {
  content: "\f1e5";
}
.fa-plug:before {
  content: "\f1e6";
}
.fa-slideshare:before {
  content: "\f1e7";
}
.fa-twitch:before {
  content: "\f1e8";
}
.fa-yelp:before {
  content: "\f1e9";
}
.fa-newspaper-o:before {
  content: "\f1ea";
}
.fa-wifi:before {
  content: "\f1eb";
}
.fa-calculator:before {
  content: "\f1ec";
}
.fa-paypal:before {
  content: "\f1ed";
}
.fa-google-wallet:before {
  content: "\f1ee";
}
.fa-cc-visa:before {
  content: "\f1f0";
}
.fa-cc-mastercard:before {
  content: "\f1f1";
}
.fa-cc-discover:before {
  content: "\f1f2";
}
.fa-cc-amex:before {
  content: "\f1f3";
}
.fa-cc-paypal:before {
  content: "\f1f4";
}
.fa-cc-stripe:before {
  content: "\f1f5";
}
.fa-bell-slash:before {
  content: "\f1f6";
}
.fa-bell-slash-o:before {
  content: "\f1f7";
}
.fa-trash:before {
  content: "\f1f8";
}
.fa-copyright:before {
  content: "\f1f9";
}
.fa-at:before {
  content: "\f1fa";
}
.fa-eyedropper:before {
  content: "\f1fb";
}
.fa-paint-brush:before {
  content: "\f1fc";
}
.fa-birthday-cake:before {
  content: "\f1fd";
}
.fa-area-chart:before {
  content: "\f1fe";
}
.fa-pie-chart:before {
  content: "\f200";
}
.fa-line-chart:before {
  content: "\f201";
}
.fa-lastfm:before {
  content: "\f202";
}
.fa-lastfm-square:before {
  content: "\f203";
}
.fa-toggle-off:before {
  content: "\f204";
}
.fa-toggle-on:before {
  content: "\f205";
}
.fa-bicycle:before {
  content: "\f206";
}
.fa-bus:before {
  content: "\f207";
}
.fa-ioxhost:before {
  content: "\f208";
}
.fa-angellist:before {
  content: "\f209";
}
.fa-cc:before {
  content: "\f20a";
}
.fa-shekel:before,
.fa-sheqel:before,
.fa-ils:before {
  content: "\f20b";
}
.fa-meanpath:before {
  content: "\f20c";
}
.fa-buysellads:before {
  content: "\f20d";
}
.fa-connectdevelop:before {
  content: "\f20e";
}
.fa-dashcube:before {
  content: "\f210";
}
.fa-forumbee:before {
  content: "\f211";
}
.fa-leanpub:before {
  content: "\f212";
}
.fa-sellsy:before {
  content: "\f213";
}
.fa-shirtsinbulk:before {
  content: "\f214";
}
.fa-simplybuilt:before {
  content: "\f215";
}
.fa-skyatlas:before {
  content: "\f216";
}
.fa-cart-plus:before {
  content: "\f217";
}
.fa-cart-arrow-down:before {
  content: "\f218";
}
.fa-diamond:before {
  content: "\f219";
}
.fa-ship:before {
  content: "\f21a";
}
.fa-user-secret:before {
  content: "\f21b";
}
.fa-motorcycle:before {
  content: "\f21c";
}
.fa-street-view:before {
  content: "\f21d";
}
.fa-heartbeat:before {
  content: "\f21e";
}
.fa-venus:before {
  content: "\f221";
}
.fa-mars:before {
  content: "\f222";
}
.fa-mercury:before {
  content: "\f223";
}
.fa-intersex:before,
.fa-transgender:before {
  content: "\f224";
}
.fa-transgender-alt:before {
  content: "\f225";
}
.fa-venus-double:before {
  content: "\f226";
}
.fa-mars-double:before {
  content: "\f227";
}
.fa-venus-mars:before {
  content: "\f228";
}
.fa-mars-stroke:before {
  content: "\f229";
}
.fa-mars-stroke-v:before {
  content: "\f22a";
}
.fa-mars-stroke-h:before {
  content: "\f22b";
}
.fa-neuter:before {
  content: "\f22c";
}
.fa-genderless:before {
  content: "\f22d";
}
.fa-facebook-official:before {
  content: "\f230";
}
.fa-pinterest-p:before {
  content: "\f231";
}
.fa-whatsapp:before {
  content: "\f232";
}
.fa-server:before {
  content: "\f233";
}
.fa-user-plus:before {
  content: "\f234";
}
.fa-user-times:before {
  content: "\f235";
}
.fa-hotel:before,
.fa-bed:before {
  content: "\f236";
}
.fa-viacoin:before {
  content: "\f237";
}
.fa-train:before {
  content: "\f238";
}
.fa-subway:before {
  content: "\f239";
}
.fa-medium:before {
  content: "\f23a";
}
.fa-yc:before,
.fa-y-combinator:before {
  content: "\f23b";
}
.fa-optin-monster:before {
  content: "\f23c";
}
.fa-opencart:before {
  content: "\f23d";
}
.fa-expeditedssl:before {
  content: "\f23e";
}
.fa-battery-4:before,
.fa-battery-full:before {
  content: "\f240";
}
.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\f241";
}
.fa-battery-2:before,
.fa-battery-half:before {
  content: "\f242";
}
.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\f243";
}
.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\f244";
}
.fa-mouse-pointer:before {
  content: "\f245";
}
.fa-i-cursor:before {
  content: "\f246";
}
.fa-object-group:before {
  content: "\f247";
}
.fa-object-ungroup:before {
  content: "\f248";
}
.fa-sticky-note:before {
  content: "\f249";
}
.fa-sticky-note-o:before {
  content: "\f24a";
}
.fa-cc-jcb:before {
  content: "\f24b";
}
.fa-cc-diners-club:before {
  content: "\f24c";
}
.fa-clone:before {
  content: "\f24d";
}
.fa-balance-scale:before {
  content: "\f24e";
}
.fa-hourglass-o:before {
  content: "\f250";
}
.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\f251";
}
.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\f252";
}
.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\f253";
}
.fa-hourglass:before {
  content: "\f254";
}
.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\f255";
}
.fa-hand-stop-o:before,
.fa-hand-paper-o:before {
  content: "\f256";
}
.fa-hand-scissors-o:before {
  content: "\f257";
}
.fa-hand-lizard-o:before {
  content: "\f258";
}
.fa-hand-spock-o:before {
  content: "\f259";
}
.fa-hand-pointer-o:before {
  content: "\f25a";
}
.fa-hand-peace-o:before {
  content: "\f25b";
}
.fa-trademark:before {
  content: "\f25c";
}
.fa-registered:before {
  content: "\f25d";
}
.fa-creative-commons:before {
  content: "\f25e";
}
.fa-gg:before {
  content: "\f260";
}
.fa-gg-circle:before {
  content: "\f261";
}
.fa-tripadvisor:before {
  content: "\f262";
}
.fa-odnoklassniki:before {
  content: "\f263";
}
.fa-odnoklassniki-square:before {
  content: "\f264";
}
.fa-get-pocket:before {
  content: "\f265";
}
.fa-wikipedia-w:before {
  content: "\f266";
}
.fa-safari:before {
  content: "\f267";
}
.fa-chrome:before {
  content: "\f268";
}
.fa-firefox:before {
  content: "\f269";
}
.fa-opera:before {
  content: "\f26a";
}
.fa-internet-explorer:before {
  content: "\f26b";
}
.fa-tv:before,
.fa-television:before {
  content: "\f26c";
}
.fa-contao:before {
  content: "\f26d";
}
.fa-500px:before {
  content: "\f26e";
}
.fa-amazon:before {
  content: "\f270";
}
.fa-calendar-plus-o:before {
  content: "\f271";
}
.fa-calendar-minus-o:before {
  content: "\f272";
}
.fa-calendar-times-o:before {
  content: "\f273";
}
.fa-calendar-check-o:before {
  content: "\f274";
}
.fa-industry:before {
  content: "\f275";
}
.fa-map-pin:before {
  content: "\f276";
}
.fa-map-signs:before {
  content: "\f277";
}
.fa-map-o:before {
  content: "\f278";
}
.fa-map:before {
  content: "\f279";
}
.fa-commenting:before {
  content: "\f27a";
}
.fa-commenting-o:before {
  content: "\f27b";
}
.fa-houzz:before {
  content: "\f27c";
}
.fa-vimeo:before {
  content: "\f27d";
}
.fa-black-tie:before {
  content: "\f27e";
}
.fa-fonticons:before {
  content: "\f280";
}

#ph_lay, #ph_zoom {
    display: none;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9999;
}
#ph_lay {
    height: 100%;
    position: fixed;
}
#ph_zoom {
    overflow-x: hidden;
    position: absolute;
}
#ph_zoom span {
    color: inherit;
    float: right;
    margin: 0;
    padding: 0 9px;
}
#ph_lay, #ph_cap, #ph_nav span {
    background: #000 none repeat scroll 0 0;
}
#ph_cap, #ph_nav {
    cursor: pointer;
    font-size: 14px;
    line-height: 21px;
    position: absolute;
}
#ph_nav #ph_prev, #ph_cap #ph_txt {
    float: left;
}
.zoomed {
    cursor: pointer;
    margin: 0;
    max-width: none;
    padding: 0;
    position: absolute;
}
.phzoom {
    display: block;
    max-width: 100%;
    position: relative;
}
.ph_hover {
    /* background: rgba(0, 0, 0, 0) url("images/ph_zoom.png") no-repeat scroll 50% 50%; */
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
.phzoom .loading {
    /* background: rgba(0, 0, 0, 0) url("images/ph_loading.gif") no-repeat scroll 50% 50%; */
}
*::-moz-selection {
    background: #3d4450 none repeat scroll 0 0;
    color: #fff;
}

li {
    line-height: 2;
}
a {
    outline: medium none;
    transition: all 0.3s ease 0s;
}
a:hover, a:focus {
    outline: medium none;
}
a.active {
    color: #ff4d3a;
}
.entry-content a, .page-content a {
    text-decoration: underline;
}
.entry-content p, .page-content p {
    line-height: 1.8em;
    margin: 0 0 20px;
}
.entry-summary p {
    margin: 0 0 10px;
}
.widget h2, .widget h3 {
    margin: 0;
    padding: 0;
}
.widget h2 {
    font-size: 16px;
}
.entry-content h2, .page-content h2 {
    border-bottom: 1px dashed #e1e1e1;
    margin: 20px -20px 10px;
    padding: 9px 20px;
}
.panel-specs {
    border: 0 none;
}
.panel-specs > .panel-heading {
    border-color: #ff4d3a;
    padding: 15px;
}
.well {
    box-shadow: none;
}
#nav.fixed {
    left: 0;
    margin-bottom: 0;
    opacity: 0.95;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
}
#masthead {
    background: #393939 none repeat scroll 0 0;
    height: 75px;
    overflow: hidden;
    width: 100%;
    z-index: 100;
}
#masthead .top-banner {
    height: 75px;
}
#masthead .brand {
    float: left;
    position: relative;
    z-index: 1;
}
#masthead .brand h1 {
    float: left;
    line-height: 43px;
    margin: 16px auto;
    position: relative;
}
#masthead .brand.brand-image h1 {
    float: left;
}
#masthead .brand.brand-image h1 small {
    margin: 0 10px;
}
#masthead .brand small {
    color: #dfdfdf;
    font-size: 15px;
    font-weight: normal;
    margin: 12px 15px;
    opacity: 0.7;
}
#masthead a.brand-text {
    color: #fff;
}
#masthead a.brand-text:hover {
    color: #ff4d3a;
}
#masthead .brand img {
    float: left;
    height: 50px;
    margin: 10px 0;
}
#masthead .top-banner .top-social {
    line-height: 65px;
}
#masthead .top-banner .top-social a {
    color: #c0c0c0;
    font-size: 22px;
    opacity: 0.6;
    padding: 5px;
    transition: opacity 0.4s ease-in-out 0s;
}
#masthead .top-banner .top-social a:hover {
    opacity: 1;
}
.dropdown-menu > li > a {
    line-height: 2.2;
}
.label {
    border-radius: 0;
}
.label-specs {
    background: #bbb none repeat scroll 0 0;
    font-size: 12px;
    padding: 3px 5px;
    transition: all 0.3s ease 0s;
}
.label-specs:hover {
    background: #999 none repeat scroll 0 0;
    cursor: pointer;
    transition: all 0.3s ease 0s;
}
.label-new {
    background-color: #ff4d3a;
}
.label-new[href]:hover, .label-new[href]:focus {
    background-color: #d9534f;
}
.entry-title {
    margin-top: 10px;
}
.entry-common .entry-title, .page .entry-title {
    margin-bottom: 20px;
    text-align: center;
}
.entry-meta {
    color: #aaa;
    line-height: 29px;
    margin: 5px 0 10px;
}
.entry-meta a {
    color: #aaa;
}
.entry-meta a:hover {
    color: #ff4d3a;
}
.entry-meta .dot {
    margin: 0 10px;
}
.entry-footer {
    margin: 10px 0;
}
.entry-tag {
    font-size: 12px;
    font-weight: normal;
    margin-left: 5px;
    padding: 2px 5px;
}
.footer-tag a {
    background: #bbb none repeat scroll 0 0;
    color: #fff;
    display: block;
    float: left;
    font-size: 12px;
    margin: 2px 5px 0 0;
    padding: 2px 5px;
}
.footer-tag a::before {
    content: "#";
}
.footer-tag a:hover {
    background: #999 none repeat scroll 0 0;
}
.entry-content img, .entry-summary img, .comment-content img, .widget img, .page-content img {
    height: auto;
    max-width: 100%;
}
img.aligncenter {
    display: block;
    margin: 0 auto;
}
.entry-cover {
    display: block;
    margin: -20px -20px 15px;
    overflow: hidden;
    position: relative;
}
.entry-cover img {
    display: block;
    height: auto;
    transition: all 0.3s ease 0s;
    width: 100%;
}
a.entry-cover:hover img {
    transform: scale(1.1);
}
a.entry-cover::before {
    background: #eb6c5f none repeat scroll 0 0;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: all 0.3s ease 0s;
    visibility: hidden;
    width: 100%;
    z-index: 2;
}
a.entry-cover::after {
    color: #fff;
    /* content: url("images/eye-icon.png"); */
    font-family: arial;
    font-size: 120px;
    left: 0;
    line-height: 1;
    margin-top: -0.5em;
    opacity: 0;
    position: absolute;
    text-align: center;
    top: 50%;
    transition: all 0.3s ease 0s;
    visibility: hidden;
    width: 100%;
    z-index: 3;
}
a.entry-cover:hover::before {
    opacity: 0.8;
    visibility: visible;
}
a.entry-cover:hover::after {
    opacity: 1;
    visibility: visible;
}
.archive-title {
    font-weight: bold;
}
.author-header {
    line-height: 24px;
}
.author-header .author-avatar {
    padding: 5px;
}
.author-meta {
    margin-left: 80px;
    margin-top: -15px;
}
.author-title {
    font-weight: bold;
    margin-bottom: 5px;
}
.entry-content h6, .page-content h6 {
    background: #f1f1f1 none repeat scroll 0 0;
    border-left: 5px solid #080808;
    color: #080808;
    font-size: 18px;
    margin: 8px 0;
    padding: 5px 0 5px 10px;
}
h6.copyright {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    border-color: #ff4d3a;
    border-image: none;
    border-style: solid;
    border-width: 1px 1px 1px thick;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
}
.related-posts {
    border-top: 1px dotted #ccc;
    margin-top: 30px;
}
.related-title {
    background: #fff none repeat scroll 0 0;
    color: #686868;
    display: inline-block;
    padding: 0 0.5em 0 0 !important;
    position: relative;
    top: -12px;
}
.related-posts ul {
    margin-left: -15px;
}
.related-posts li {
    line-height: 24px;
}
.list-archives li {
    padding-left: 40px;
}
#myTab li {
    border-bottom: 0 none;
    padding: 0;
}
#myTab li a {
    border-bottom: 0 none;
}
.widget-ad p {
    margin-top: 10px;
    text-align: center;
}
.widget-ad img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
}
img.avatar {
    border-radius: 100%;
    margin-right: 5px;
    transition: all 0.25s ease-in-out 0s;
}
.widget a:hover img.avatar, .page-content a:hover img.avatar {
    transform: rotate(360deg);
}
.comment-avatar {
    /* background: #f0f0f0 url("images/defauleHend.jpg") no-repeat scroll center center / 100% auto; */
    border-radius: 100%;
    float: left;
}
#comments .comment-avatar {
    height: 50px;
    margin: 10px 10px 0 0;
    width: 50px;
}
.comment_list {
    line-height: 40px;
}
.widget div.comment-avatar {
    height: 40px;
    margin-right: 5px;
    width: 40px;
}
.widget ul {
    margin: 0;
    padding: 0;
}
.widget ul li {
    border-bottom: 1px solid #ddd;
    list-style: outside none none;
    padding: 10px 15px;
}
.widget_links ul li {
    float: left;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    padding: 0 15px;
    width: 50%;
}
.textwidget, .tagcloud, .tag_clouds, .widget_search {
    overflow: hidden;
    padding: 10px 15px;
}
.textwidget * {
    overflow: hidden;
}
.tag_clouds a {
    border: 1px solid #e1e1e1;
    display: inline-block;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2px 5px;
}
.textwidget img {
    display: block;
    margin: 0 auto;
}
#calendar_wrap {
    padding: 5px 10px;
}
#calendar_wrap .table caption {
    font-size: 16px;
    padding: 10px 15px;
}
#calendar_wrap #today {
    color: #ff4d3a;
}
footer#body-footer {
    background: #393939 none repeat scroll 0 0;
    bottom: 0;
    color: #fff;
    padding: 10px 20px;
    position: relative;
    text-align: center;
}
footer#body-footer a {
    color: #ff4d3a;
}
#jump {
    bottom: 100px;
    position: fixed;
    right: 30px;
    width: 40px;
    z-index: 10;
}
#jump li {
    height: 50px;
    list-style: outside none none;
    margin-left: -30px;
    margin-top: 10px;
    width: 50px;
}
#jump li a {
    border-radius: 50%;
    color: #393939;
    display: block;
    font-size: 32px;
    height: 50px;
    position: relative;
    width: 50px;
    z-index: 11;
}
#jump li a:hover {
    color: #ff4d3a;
}
#EWM {
    display: none;
    height: 150px;
    left: -160px;
    position: absolute;
    top: 0;
    width: 150px;
    z-index: 12;
}
#EWM img {
    height: 150px;
    width: 150px;
}
.nofound {
    font-size: 18px;
    margin: 50px 0;
    padding: 100px;
    text-align: center;
}
.nofound h2 {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 40px;
}
.nofound h2 a {
    color: #c0392b;
}
.nofound h2 a:hover {
    color: #ff4d3a;
}
#tag a {
    text-decoration: none;
}
#tag_letter {
    background: #f1f1f1 none repeat scroll 0 0;
    font-size: 25px;
    line-height: 32px;
    padding: 5px 2px;
}
#all_tags .tag_name {
    border-bottom: 1px solid #efefef;
    margin-top: 15px;
    padding-left: 10px;
}
#all_tags li a {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 20px;
    word-break: keep-all;
}
.bs-masthead h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
}
.fa-icons .fa-hover {
    border-radius: 4px;
    color: #222;
    display: block;
    height: 32px;
    line-height: 32px;
    padding-left: 10px;
}
.fa-icons .fa-hover .fa {
    display: inline-block;
    font-size: 14px;
    margin-right: 10px;
    text-align: right;
    width: 32px;
}
.fa-icons .fa-hover:hover {
    background-color: #ff4d3a;
    color: #fff;
    text-decoration: none;
}
.fa-icons .fa-hover:hover .fa {
    font-size: 28px;
    vertical-align: -6px;
}
.links li {
    margin-bottom: 10px;
}
.links li a img {
    display: inline;
    height: 16px;
    margin-right: 5px;
    margin-top: -3px;
    width: 16px;
}
#comments_top_12 a {
    display: inline-block;
    height: 60px;
    margin: 5px 0;
    text-align: center;
    vertical-align: middle;
}
#comments_top_12 a:hover {
    border: medium none;
}
#comments_top_12 img {
    display: inline-block;
}
#comments ul {
    list-style: outside none none;
    padding: 0;
}
@media screen and (min-width: 768px) {
#comments ul.children li.depth-2 {
    margin-left: 50px;
}
}
.comments-title, #reply-title {
    border-bottom: 1px solid #f1f1f1;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
}
.comment-wrap {
    border-bottom: 1px solid #f1f1f1;
    margin-top: 20px;
    padding: 10px 0 30px;
    position: relative;
}
.comment-body .comment-date {
    color: #999;
    font-size: 14px;
}
.comment-body .fn {
    color: #666;
    font-size: 16px;
}
.comment-body .fn a, .comment-body .reply-comment-author a {
    color: #eb6c5f;
}
.comment-body .fn a:hover {
    text-decoration: none;
}
.comment-body .label-danger:hover {
    background-color: #d2322d;
    border-color: #ac2925;
    color: #fff;
}
.comment-body .label-danger a {
    color: #fff;
    line-height: 14px;
    padding: 5px;
}
.comment-body .label-danger a:hover {
    text-decoration: none;
}
.comment-body p {
    line-height: 24px;
}
.comment-wrap .avatar {
    left: 0;
    position: absolute;
    top: 20px;
    transition: all 0.25s ease-in-out 0s;
}
.comment-reply-title small {
    font-size: 12px;
}
#commentform .required {
    color: #ac2925;
}
#commentform .form-control-feedback {
    top: 0;
}
.commentnav {
    font-size: 12px;
    margin-top: 15px;
}
.commentnav .page-numbers, .commentnav a {
    margin: 2px;
    padding: 3px 8px;
    text-decoration: none;
}
.commentnav a:hover {
    background-color: #ff4d3a;
    color: #ffffff;
}
.commentnav span.current {
    background-color: #ff4d3a;
    color: #ffffff;
    margin: 2px;
    padding: 3px 8px;
}
img.wp-smiley {
    height: auto !important;
    max-height: 2em !important;
    vertical-align: middle !important;
    width: 18px !important;
}
.comment-form-comment .smilies {
    margin: 5px 0;
}
.comment-form-comment .smilies a {
    margin-right: 3px;
}
.comment-form-comment .smilies img.wp-smiley {
    height: auto !important;
    width: 24px !important;
}
.share {
    position: relative;
}
.share li a {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
    color: #fff;
    display: inline-block;
    font-size: 20px;
    height: 32px;
    opacity: 0.8;
    transition: opacity 0.3s ease-in-out 0s;
    width: 32px;
}
.share li a:hover {
    opacity: 1;
}
#share-weibo {
    background: #e6162d none repeat scroll 0 0;
}
#share-tencent {
    background: #28a8e2 none repeat scroll 0 0;
}
#share-qzone {
    background: #f3b73d none repeat scroll 0 0;
}
#share-renren {
    background: #0070ce none repeat scroll 0 0;
}
#share-weixin {
    background: #0cc417 none repeat scroll 0 0;
}
@media (min-width: 1200px) {
#float {
    width: 358px;
}
}
@media (min-width: 992px) and (max-width: 1199px) {
#float {
    width: 294px;
}
}
#slide {
    margin-bottom: 20px;
}
.carousel-indicators li {
    margin: 1px 5px;
}
.carousel-inner > .item > img, .carousel-inner > .item > a > img {
    width: 100%;
}
.carousel-control.left, .carousel-control.right {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
    filter: none;
}
.carousel-control .icon-prev, .carousel-control .icon-next, .carousel-control .fa-arrow-circle-left, .carousel-control .fa-arrow-circle-right {
    display: inline-block;
    position: absolute;
    top: 50%;
    z-index: 5;
}
.carousel-control .icon-prev, .carousel-control .fa-arrow-circle-left {
    left: 50%;
    margin-left: -10px;
}
.carousel-control .icon-next, .carousel-control .fa-arrow-circle-right {
    margin-right: -10px;
    right: 50%;
}
@media screen and (min-width: 768px) {
.carousel-control .fa-arrow-circle-left, .carousel-control .fa-arrow-circle-right, .carousel-control .icon-prev, .carousel-control .icon-next {
    font-size: 40px;
    height: 40px;
    margin-top: -15px;
    width: 40px;
}
.carousel-control .fa-arrow-circle-left, .carousel-control .icon-prev {
    margin-left: -15px;
}
.carousel-control .fa-arrow-circle-right, .carousel-control .icon-next {
    margin-right: -15px;
}
}
.specs_background {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -1;
}
.specs_background img {
    height: 100%;
    width: 100%;
}
#stripe {
    /* background: transparent url("images/stripe.png") repeat scroll 0 0; */
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
#background_pattern {
    background-repeat: repeat;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -1;
}
.ads_page_footer, .ads_index_list {
    margin: 10px auto;
    overflow: hidden;
    text-align: center;
}
.ads_index_list {
    background: #fff none repeat scroll 0 0;
    border: 1px solid #e3e3e3;
}
.ads_page_top {
    height: auto;
    margin: 10px auto 20px;
    overflow: hidden;
    text-align: center;
    width: auto;
}
a.thumbLink {
    border: 1px solid #e1e1e1;
    display: inline-block;
    float: left;
    height: 128px;
    margin-right: 10px;
    padding: 3px;
    width: 228px;
}
.entry-content img.thumb {
    height: 120px;
    width: 220px;
}
#share_box .bds {
    /* background: rgba(0, 0, 0, 0) url("images/sharebg.png") no-repeat scroll 0 0 !important; */
    height: 30px;
    padding: 0 !important;
    transition: all 0.3s ease 0s;
    width: 30px;
}
#share_box .bds_tsina {
    background-position: 0 0 !important;
}
#share_box .bds_tsina:hover {
    background-position: 0 -30px !important;
}
#share_box .bds_qzone {
    background-position: -29px 0 !important;
}
#share_box .bds_qzone:hover {
    background-position: -29px -30px !important;
}
#share_box .bds_douban {
    background-position: -59px 0 !important;
}
#share_box .bds_douban:hover {
    background-position: -59px -30px !important;
}
#share_box .bds_renren {
    background-position: -90px 0 !important;
}
#share_box .bds_renren:hover {
    background-position: -90px -30px !important;
}
#share_box .bds_weixin {
    background-position: -120px 0 !important;
}
#share_box .bds_weixin:hover {
    background-position: -120px -30px !important;
}
#share_box .bds_tqq {
    background-position: -149px 0 !important;
}
#share_box .bds_tqq:hover {
    background-position: -149px -30px !important;
}
#share_box .bds_more {
    background-position: -179px 0 !important;
}
#share_box .bds_more:hover {
    background-position: -179px -30px !important;
}
.post-like {
    padding: 10px;
    text-align: center;
}
.post-like a.done {
    cursor: not-allowed;
}
.ias-trigger, .ias-spinner, .ias-noneleft {
    background: #fcf8e3 none repeat scroll 0 0;
    border: 1px solid #faebcc;
    border-radius: 4px;
    color: #8a6d3b;
    font-weight: bold;
    margin-bottom: 20px;
    padding: 15px;
}
.ias-trigger a, .ias-noneleft a {
    color: #66512c;
    font-weight: bold;
}
code {
    background: #f8f8f8 none repeat scroll 0 0;
    border: 1px solid #e1e1e1;
    border-radius: 0;
    color: #eb5745;
    font-weight: bold;
    margin: 0 5px;
    padding: 2px 5px;
}
img.lazyLoad {
    /* background: rgba(0, 0, 0, 0) url("images/loading.gif") no-repeat scroll center center; */
}
.item-weibo .well {
    margin-left: 30px;
}
.weibo-pics {
    text-align: center;
}
.weibo-pics {
    max-width: 400px;
}
p.weibo-text .fa-weibo {
    color: #d04341;
}
p.weibo-rtext {
    margin-top: 0;
}
.weibo-pics a.thumb {
    margin: 5px auto;
}
.item-weibo .weibo-time {
    color: #bbb;
    font-size: 12px;
}
.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
}
.animated.infinite {
    animation-iteration-count: infinite;
}
.animated.hinge {
    animation-duration: 2s;
}
@keyframes fadeInUp {
0% {
    opacity: 0;
    transform: translate3d(0px, 100%, 0px);
}
100% {
    opacity: 1;
    transform: none;
}
}
.fadeInUp {
    animation-name: fadeInUp;
}
.hideO {
    opacity: 0;
}
.showO {
    opacity: 1;
}
.left-hide {
    opacity: 0;
    perspective-origin: center top;
    transform: scale(0.9);
    transition: all 0.3s ease-in-out 0s;
}
.left-show {
    opacity: 1;
    transform: scale(1);
}
.rating {
    display: inline-block;
    height: 20px;
    position: relative;
    width: 65px;
}
.rating::before, .percent::before {
    color: #c5c5c5;
    /* font-family: "FontAwesome"; */
    font-size: 14px;
    position: absolute;
}
.percent {
    height: 20px;
    overflow: hidden;
    position: absolute;
    width: 0;
}
.percent::before {
    color: #fc9526;
}
.star {
    font-size: 14px;
}
.star::before {
    /* font-family: "FontAwesome"; */
}
.star-5::before {
    content: "飥咃€咃€咃€咃€�";
}
.star-4::before {
    content: "飥咃€咃€咃€�";
}
.star-3::before {
    content: "飥咃€咃€�";
}
.star-2::before {
    content: "飥咃€�";
}
.star-1::before {
    content: "飥�";
}
#sidebar {
    margin-bottom: 10px;
}
.affix-top {
    position: relative;
}
.affix {
    top: 65px;
}
.affix, .affix-bottom {
    width: 293.313px;
}
.affix-bottom {
    position: absolute;
}
@media (min-width: 1200px) {
.affix, .affix-bottom {
    width: 360px;
}
}
blockquote {
    font-size: 14px;
}
.prettyprint {
    background: white none repeat scroll 0 0;
    border: 1px solid #ccc;
    font-family: Menlo,"Bitstream Vera Sans Mono","DejaVu Sans Mono",Monaco,Consolas,monospace;
    font-size: 12px;
    line-height: 1.5;
    max-height: 350px;
    padding: 10px;
}
.pln {
    color: #4d4d4c;
}
@media screen {
.str {
    color: #718c00;
}
.kwd {
    color: #8959a8;
}
.com {
    color: #8e908c;
}
.typ {
    color: #4271ae;
}
.lit {
    color: #f5871f;
}
.pun {
    color: #4d4d4c;
}
.opn {
    color: #4d4d4c;
}
.clo {
    color: #4d4d4c;
}
.tag {
    color: #c82829;
}
.atn {
    color: #f5871f;
}
.atv {
    color: #3e999f;
}
.dec {
    color: #f5871f;
}
.var {
    color: #c82829;
}
.fun {
    color: #4271ae;
}
}
@media print, projection {
.str {
    color: #006600;
}
.kwd {
    color: #006;
    font-weight: bold;
}
.com {
    color: #600;
    font-style: italic;
}
.typ {
    color: #404;
    font-weight: bold;
}
.lit {
    color: #004444;
}
.pun, .opn, .clo {
    color: #444400;
}
.tag {
    color: #006;
    font-weight: bold;
}
.atn {
    color: #440044;
}
.atv {
    color: #006600;
}
}
ol.linenums {
    margin-bottom: 0;
    margin-top: 0;
}
li.L0, li.L1, li.L2, li.L3, li.L4, li.L5, li.L6, li.L7, li.L8, li.L9 {
}
li.L1, li.L3, li.L5, li.L7, li.L9 {
}
#pLoading {
    background: rgba(0, 0, 0, 0.4) none repeat scroll 0 0;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}
#pLoading img {
    left: 50%;
    position: absolute;
    top: 50%;
}
#pLoading .spinner {
    font-size: 10px;
    height: 30px;
    left: 50%;
    margin-left: -25px;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 50px;
}
.spinner > div {
    animation: 1.2s ease-in-out 0s normal none infinite running stretchdelay;
    background-color: #fff;
    display: inline-block;
    height: 100%;
    width: 6px;
}
.spinner .rect2 {
    animation-delay: -1.1s;
}
.spinner .rect3 {
    animation-delay: -1s;
}
.spinner .rect4 {
    animation-delay: -0.9s;
}
.spinner .rect5 {
    animation-delay: -0.8s;
}
@keyframes stretchdelay {
0%, 40%, 100% {
    transform: scaleY(0.4);
}
20% {
    transform: scaleY(1);
}
}
/* reset */
* {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}


.body{overflow-x:hidden;}

a:focus, i:focus, img:focus{
	outline: 0;background-color: transparent !important;-webkit-tap-highlight-color:rgba(0,0,0,0);
}
input[type=checkbox]:focus, input[type=radio]:focus{outline: 0;}
select{width:170px;}
 h1, h2, h3, h4, h5, h6, div, dl, dt, dd, ul, ol, li, p, blockquote, pre, hr, figure, table, caption, th, td, form, fieldset, legend, input, button, textarea, menu {
	margin: 0;
	padding: 0;
}
header, footer, section, article, aside, nav, hgroup, address, figure, figcaption, menu, details {
	display: block;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
caption, th {
	text-align: left;
	font-weight: normal;
}
 fieldset, img, iframe, abbr {
	border: 0;
}
i, cite, em, var, address, dfn, dt, dd {
	font-style: normal;
	font-weight: normal
}
[hidefocus], summary {
	outline: 0;
}
li {
	list-style: none;
}
h1, h2, h3, h4, h5, h6, small {
	font-size: 100%;
}
sup, sub {
	font-size: 83%;
}
pre, code, kbd, samp {
	font-family: inherit;
}
q:before, q:after {
	content: none;
}
textarea {
	overflow: auto;
	resize: none;
}
label, summary {
	cursor: default;
}
a, button {
	cursor: pointer;
}
h1, h2, h3, h4, h5, h6, strong, b {
	font-weight: bold;
}
del, ins, u, s, a, a:hover {
	text-decoration: none;
}
 textarea, input, button, select, keygen, legend {
	font: 12px/1.14 microsoft yahei, \5b8b\4f53;
	color: #333;
	outline: 0;
}

a, a:hover {
	color: #333;
}

/*鍥炬爣*/
/* .fa-caret-left{background:url(../img/l.png) no-repeat 0 center;background-size: 19px 20px;margin-right:0 !important}
.fa-caret-right{background:url(../img/r.png) no-repeat right center;background-size: 19px 20px;margin-right:0 !important}
.fa-circle{display:inline-block;border-radius:10px;width:14px;height:14px;vertical-align: middle;}
.fa-angle-down{background:url(../img/l.png) no-repeat 0 center;background-size: 19px 20px;margin-right:0 !important;}
.fa-camera{background:url(../img/camera.png) no-repeat 0 center;background-size: 19px 20px;margin-right:2px !important;display:inline-block;width:18px;height:14px; vertical-align: middle;  margin-top: -2px;}
.fa-eye{background:url(../img/eye.png) no-repeat 0 center;background-size: 19px 20px;margin-right:2px !important;display:inline-block;width:18px;height:14px;vertical-align: middle;margin-top:-2px;}
.fa-list{background:url(../img/order_details.png) no-repeat 0 center;margin-right:2px !important;display:inline-block;width:18px;height:14px;vertical-align:middle;margin-top:-3px;}
.fa-angle-right{background:url(../img/r-blue.png) no-repeat 0 center;margin-right:0 !important;display:inline-block;width:18px;height:25px;}
.fa-angle-down{background:url(../img/d-blue.png) no-repeat 0 center;margin-right:0 !important;display:inline-block;width:18px;height:34px;} */
.fa-camera:before,  .fa-angle-right:before, .fa-list:before, .fa-eye:before, .fa-caret-left:before, .fa-caret-right:before{content:"" !important;}

/*绔栫嚎*/
.line-shu {
	color: #B3B3B3;
	margin: 0 5px;
	font-weight: normal;
	font-size: 15px;
	font-family:"Arial Narrow";
}
.tab-line-shu {
	color: #B3B3B3;
	margin: 0;
	font-weight: normal;
	font-size: 15px;
	font-family:"Arial Narrow";
	margin-right: -4px;
}
/*琛ㄥ崟*/
.select-app {
	font-size: 14px;
	color: #157EFB;
	border: 0;
	background: transparent;
	-webkit-appearance: none; /*for chrome*/
}

.select-group{
	position: relative;
	display: inline-block;
}
.select-group .select-con{position: absolute;right:0;top:0;color:#157EFB;text-align:right;}
.select-group select{opacity:.0}

.file-group {
	position: relative;
	display: block;
}
.file-group input[type="file"] {
	position: absolute;
	z-index: 9;
	opacity: 0;
	width: 70px;
	height: 25px;
	top: 10px;
	left: 0;
	cursor: pointer
}
.prompt-ipt {
	height: 65px;
	width: 180px;
}
.prompt-textarea {
	height: 75px;
	width: 195px;
	padding: 5px;
	border: 1px solid #bfbfbf
}
.prompt-box {
	padding: 10px 15px;
	background: #e3e4e6;
}
.prompt-con {
	font-size: 16px;
	color: #000;
	padding: 5px;
}
.prompt-btn-bar {
	text-align: center;
	border-top: 1px solid #bfbfbf;
	background: #e3e4e6;
}
.prompt-line {
	border-right: 1px solid #bfbfbf !important;
}
.prompt-btn-bar button {
	font-size: 16px;
	color: #157EFB;
	background: none;
	border: 0;
	vertical-align: middle;
	display: inline-block;
	height: 35px;
	text-align: center;
	width: 100px
}
.font18 {
	font-size: 18px;
}
/*background color*/
.fa-circle.c-gray{background:#b3b3b3}
.fa-circle.c-purple{background:#bb9bcd}
.fa-circle.c-orange{background:#ff5a00}
.fa-circle.c-redlight{background:#f56080}
.fa-circle.c-pink{background:#ff5eb9}
.fa-circle.c-greenlight{background:#a1cd18}
.fa-circle.c-blue{background:#0088ae}
.fa-circle.c-green{background:#53d769}
/*font color*/
.c-gray {
	color: #b3b3b3;
}
.c-purple {
	color: #bb9bcd;/*绱壊*/
}
.c-orange {
	color: #ff5a00;/*姗橀粍*/
}
.c-redlight {
	color: #f56080;/*瑗跨摐绾�*/
}
.c-pink {
	color: #ff5eb9;/*绮夌孩*/
}
.c-greenlight {
	color: #a1cd18;
}
.c-green {
	color: #53d769;
}
.c-blue {
	color: #0088ae;
}
.c-bluelight {
	color: #157efb;
}
.c-808080 {
	color: #808080
}
/*鑳屾櫙鑹�*/
.bg-purple {
	background: #bb9bcd;
}
.bg-white{background:#fff;}
/*鐘舵€侀鑹�*/
.warning-box {
	height: 30px;;
	line-height: 30px;
	color: #ff5a00;
	background: #ffdecc;
	padding: 0 10px;
	margin: 10px 0
}
/*杈规*/
.bder0 {
	border: 0 !important;
}
.bder-lf{border-left:1px solid #808080}
/*鏂囧瓧闄愬埗*/
.t-overflow {
	display: block;
	text-overflow: ellipsis;
	width: 130px;
	white-space: nowrap;
	overflow: hidden
}
/* function */
.f-clr, .f-cb, .f-cbli li {
	zoom: 1;
}
.f-clr:after {
	display: block;
	clear: both;
	visibility: hidden;
	height: 0;
	overflow: hidden;
	content: ".";
}
.f-cb:after, .f-cbli li:after {
	display: block;
	clear: both;
	visibility: hidden;
	height: 0;
	overflow: hidden;
	content: ".";
}
.f-ib {
	display: inline-block;
	zoom: 1;
}
.f-dn {
	display: none;
}
.f-db {
	display: block;
}
.f-mc{margin:0 auto}
.f-fl {
	float: left;
}
.f-fr {
	float: right;
}
.f-pr {
	position: relative;
}
.f-prz {
	position: relative;
	zoom: 1;
}
.f-oh {
	overflow: hidden;
}
.f-ff0 {
	font-family: arial, \5b8b\4f53;
}
.f-ff1 {
	font-family: "Microsoft YaHei", \5fae\8f6f\96c5\9ed1, arial, \5b8b\4f53;
}
.f-fs1 {
	font-size: 12px;
}
.f-fs2 {
	font-size: 14px;
}
.f-fwn {
	font-weight: normal;
}
.f-fwb {
	font-weight: bold;
}
.f-tal {
	text-align: left;
}
.f-tac {
	text-align: center;
}
.f-tar {
	text-align: right;
}
.f-taj {
	text-align: justify;
	text-justify: inter-ideograph;
}
.f-vam, .f-vama * {
	vertical-align: middle;
}
.f-wsn {
	word-wrap: normal;
	white-space: nowrap;
}
.f-pre {
	overflow: hidden;
	text-align: left;
	white-space: pre-wrap;
	word-wrap: break-word;
	word-break: break-all;
}
.f-wwb {
	white-space: normal;
	word-wrap: break-word;
	word-break: break-all;
}
.f-ti {
	overflow: hidden;
	text-indent: -30000px;
}
.f-ti2 {
	text-indent: 2em;
}
.f-lhn {
	line-height: normal;
}
.f-tdu, .f-tdu:hover {
	text-decoration: underline;
}
.f-tdn, .f-tdn:hover {
	text-decoration: none;
}
.f-toe {
	overflow: hidden;
	word-wrap: normal;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.f-csp {
	cursor: pointer;
}
.f-csd {
	cursor: default;
}
.f-csh {
	cursor: help;
}
.f-csm {
	cursor: move;
}
.f-usn {
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-o-user-select: none;
	user-select: none;
}

/* media 鏍规嵁涓嶅悓鍒嗚鲸鐜囧疄鐜板竷灞€鑷€傚簲*/
/* 妯睆 */
@media screen and (orientation: landscape) {
}
/* 绔栧睆 */
@media screen and (orientation: portrait) {
}
/* 绐楀彛瀹藉害<960,璁捐瀹藉害=768 */
@media screen and (max-width: 959px) {
}
/* 绐楀彛瀹藉害<768,璁捐瀹藉害=640 */
@media screen and (max-width: 767px) {
}
/* 绐楀彛瀹藉害<640,璁捐瀹藉害=480 */
@media screen and (max-width: 639px) {
}
/* 绐楀彛瀹藉害<480,璁捐瀹藉害=320 */
@media screen and (max-width: 479px) {
}
/* windows UI 璐撮潬 */
@media screen and (-ms-view-state: snapped) {
}
/* 鎵撳嵃 */
@media print {
}

/* animation */
/* 娣″叆 */
.a-fadein {
	-webkit-animation-name: fadein;
	-moz-animation-name: fadein;
	-ms-animation-name: fadein;
	animation-name: fadein;
}
/* define */
/* 娣″叆 */
@-webkit-keyframes fadein{
0%{opacity:0;}
100%{opacity:1;}
}
@-moz-keyframes fadein{
0%{opacity:0;}
100%{opacity:1;}
}
@-ms-keyframes fadein{
0%{opacity:0;}
100%{opacity:1;}
}
@keyframes fadein{
0%{opacity:0;}
100%{opacity:1;}
}

/*self write*/
#slideDown {
	margin-top: 0;
	width: 100%;
	max-height: 140px
}
#slideDown1, #slideDown2 {
	width: 100%;
	height: 70px;
	background: #e9f4f7;
	display: none;
}
#slideDown1 {
	height: 20px;
}
#slideDown1 > p, #slideDown2 > p {
	margin: 20px auto;
	text-align: center;
	font-size: 14px;
	color: #37bbf5;
}
.main {
	max-width: 900px;
	margin: 0 auto;
}
.header {
}
.footer {
	text-align: center;
}
.wid90 {
	width: 85%
}

.mui-switch {
	width: 52px;
	height: 31px;
	position: relative;
	border: 1px solid #dfdfdf;
	background-color: #fdfdfd;
	box-shadow: #dfdfdf 0 0 0 0 inset;
	border-radius: 20px;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
	background-clip: content-box;
	display: inline-block;
	-webkit-appearance: none;
	user-select: none;
	outline: none;
}
.mui-switch:before {
	content: '';
	width: 29px;
	height: 29px;
	position: absolute;
	top: 0px;
	left: 0;
	border-radius: 20px;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}
.mui-switch:checked {
	border-color: #64bd63;
	box-shadow: #64bd63 0 0 0 16px inset;
	background-color: #64bd63;
}
.mui-switch:checked:before {
	left: 21px;
}
.mui-switch.mui-switch-animbg {
	transition: background-color ease 0.4s;
}
.mui-switch.mui-switch-animbg:before {
	transition: left 0.3s;
}
.mui-switch.mui-switch-animbg:checked {
	box-shadow: #dfdfdf 0 0 0 0 inset;
	background-color: #64bd63;
	transition: border-color 0.4s, background-color ease 0.4s;
}
.mui-switch.mui-switch-animbg:checked:before {
	transition: left 0.3s;
}
.mui-switch.mui-switch-anim {
	transition: border cubic-bezier(0, 0, 0, 1) 0.4s, box-shadow cubic-bezier(0, 0, 0, 1) 0.4s;
}
.mui-switch.mui-switch-anim:before {
	transition: left 0.3s;
}
.mui-switch.mui-switch-anim:checked {
	box-shadow: #64bd63 0 0 0 16px inset;
	background-color: #64bd63;
	transition: border ease 0.4s, box-shadow ease 0.4s, background-color ease 1.2s;
}
.mui-switch.mui-switch-anim:checked:before {
	transition: left 0.3s;
}
.f-lf-8{margin-left:-8px}
/*pull-refresh S*/
.m-pullToRefresh {
    position: relative;text-align: center;color: #000;
}
.m-pullToRefresh i{
    position: absolute;left: 48%;margin-left: -35px;
    width: 35px;height: 200px;
    /* background: url("../img/refresh.png") no-repeat 0 6px; */
    background-size:  100%;
    display:none;
}
.footer span, .m-pullToRefresh span{
    position: absolute;left: 49%;bottom: 10px;
}
.footer span img,.m-pullToRefresh span img{ position: absolute;left:-25px;bottom: 0px}
.footer i,.m-pullToRefresh i, .m-pullToRefresh span{
    display: inline-block;
}

.footer{position: relative;text-align: center;color: #000;}

/* CSS Document */
/*审核交易单*/
.c-808080 {
	color: #808080
}

.c-b2b2b2 {
	color: #b2b2b2
}

.c-3e3f41 {
	color: #3e3f41
}

.audit_orders {
}

	.audit_orders li {
		height: 130px;
		background: #fff;
		margin: 10px auto;
		height: 135px;
	}

	.audit_orders .order-list-dl {
		padding: 0 10px;
	}

		.audit_orders .order-list-dl dd {
			height: 42px;
			line-height: 42px;
		}

		.audit_orders .order-list-dl .order-list-dt {
			border-bottom: 1px solid #ccc
		}

			.audit_orders .order-list-dl .order-list-dt div {
				height: 40px
			}

	.audit_orders .audit_info {
		line-height: 30px;
		padding: 0 15px
	}

	.audit_orders .audit_order_num {
	}

	.audit_orders .audit_order_name {
	}

	.audit_orders .audit_order_content {
	}

	.audit_orders .audit_info .font-bg-gray {
		background-color: #cccccc;
		color: #ffffff;
		padding-left: 1px;
		padding-right: 1px;
		border-radius: 2px;
	}

	.audit_orders .audit_delivery {
		line-height: 30px;
	}

		.audit_orders .audit_delivery .b-dc {
			border-bottom: 1px solid #ccc;
			padding: 0 15px
		}

		.audit_orders .audit_delivery .audit_de_info {
			height: 130px;
			padding: 0 15px
		}

		.audit_orders .audit_delivery .audit_de_txt {
			margin:0 10px
		}

			.audit_orders .audit_delivery .audit_de_txt textarea {
				width: 100%;
				height: 80px;
				color: #157efb;
				padding: 5px;
				font-size: 14px;
			}

.btn-footer {
	margin-top: 10px;
}

	.btn-footer:after {
		clear: both;
		zoom: 1;
		content: ""
	}

	.btn-footer button {
		width: 50%;
		text-align: center;
		padding: 20px 0;
		border: 0px;
		font-size: 14px;
	}

	.btn-footer .btn-white {
		background-color: #ffffff;
		color: #3e3f41;
	}

	.btn-footer .btn-red {
		background-color: #cc3729;
		color: #ffffff;
	}

/*审核付款*/
.c-157efb {
	color: #157efb
}

.detailed-tit {
	background-color: #ebebeb;
	margin-top: 16px;
	font-weight: bold;
	height: 50px;
	line-height: 48px;
	padding: 0px 15px;
	font-size: 1.17em;
}

.pay-info {
	background: #fff;
	margin-bottom: 10px;
}

.info-detailed {
}

	.info-detailed dl {
	}

		.info-detailed dl dd {
			margin: auto 10px;
			height: 40px;
			line-height: 38px;
			border-bottom: 1px solid #ccc
		}

	.info-detailed .deal {
	}

		.info-detailed .deal span {
			display: inline-block
		}

		.info-detailed .deal a {
			color: #157efb
		}

		.info-detailed .deal .fa-angle-right {
			margin-top: 5px
		}

/*订单详细*/
.details-tit {
	height: 45px;
	line-height: 45px;
	padding: 0px 10px;
}

.details-info {
	background: #fff;
	margin-bottom: 10px;
}

	.details-info .list-info, .details-info .tit-info {
		height: 40px;
		line-height: 38px;
		border-bottom: 1px solid #d9d9d9;
		margin: auto 15px;
	}

		.details-info .list-info .list-l, .details-info .tit-info .list-l {
			width: 50%;
			overflow: hidden
		}

		.details-info .list-info .list-r, .details-info .tit-info .list-r {
			width: 50%;
			overflow: hidden
		}

.details-total {
	padding: 0px 15px;
}

/*审核二次结算付款*/
.b-dc {
	border-bottom: 1px solid #ccc;
}

.sauit-info {
	background: #fff;
	margin: 10px auto;
}

	.sauit-info dd, .buyer-box dd {
		margin: auto 15px;
		height: 40px;
		line-height: 38px;
	}

.sauit-infos dd {
	margin: auto 15px;
	height: 30px;
	line-height: 30px;
}

.sauit-info-account {
	height: 40px;
	line-height: 40px;
	padding: 0 15px;
	border-bottom: 1px solid #ccc;
}

/*文字限制*/
.t-overflow-w {
	display: block;
	text-overflow: ellipsis;
	width: 60%;
	white-space: nowrap;
	overflow: hidden
}

.deal-time {
	text-align: center;
	line-height: 40px;
	height: 40px
}

	.deal-time i {
		vertical-align: middle;
		cursor: pointer;
		width: 50px;
		height: 30px;
	}

	.deal-time span {
		vertical-align: middle
	}

/*进销票*/
.votes-menu {
	height: 40px;
	line-height: 40px;
	background-color: #f9f9f9;
	margin-bottom: 10px
}

	.votes-menu div {
		text-align: center;
		width: 49%
	}

		.votes-menu div a {
			display: inline-block;
			width: 47%;
			height: 40px;
		}

	.votes-menu .current {
		border-bottom: 2px solid #157efb;
		height: 39px;
		color: #157efb
	}

		.votes-menu .current a {
			color: #157efb
		}

.pb-10 {
	padding-bottom: 10px
}

.invoice-1x {
	width: 20px;
	height: 12px
}

.invoice-2x {
	width: 38px;
	height: 24px
}

.invoice-3x {
	width: 57px;
	height: 36px
}

.invoice-4x {
	width: 62px;
	height: 40px
}

/* .into_invoice_select {
	background: url(../img/into_invoice_select.png) no-repeat center center;
}

.into_invoice_unselect {
	background: url(../img/into_invoice_unselect.png) no-repeat center center;
}

.out_invoice_select {
	background: url(../img/out_invoice_select.png) no-repeat center center;
}

.out_invoice_unselect {
	background: url(../img/out_invoice_unselect.png) no-repeat center center;
} */

.ticket-1x {
	width: 36px;
	height: 15px
}

.ticket-2x {
	width: 72px;
	height: 31px
}

.ticket-3x {
	width: 108px;
	height: 47px
}

.ticket-4x {
	width: 62px;
	height: 40px
}

/* .invoiced {
	background: url(../img/invoiced.png) no-repeat center center;
}

.un_invoice {
	background: url(../img/un_invoice.png) no-repeat center center;
} */

.invoice .list01 {
	width: 20%
}

.invoice .list02 {
	width: 80%
}

/* 窗口宽度<480,设计宽度=320 */
@media screen and (max-width: 479px) {
	.invoice .list01 {
		overflow: hidden;
		height: 40px;
		width: 60px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.invoice .list02 {
		overflow: hidden;
		height: 40px;
		width: 220px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}


/*应收应付*/
.funds {
	width: 17px;
	height: 17px;
	vertical-align: middle
}

/* .funds-income {
	background: url(../img/income.png) no-repeat center center;
}

.funds-pay {
	background: url(../img/expenditure.png) no-repeat center center;
} */

/*卖家卖家客户*/
.buyer-box {
	margin: 10px;
	background: #f9f9f9;
	border-radius: 5px;
	border: 1px solid #cccccc
}

	.buyer-box .t-overflow {
		min-width: 90%
	}

	.buyer-box dd {
		line-height: 28px;
		height: 30px;
	}

		.buyer-box dd a {
			margin-left: 10px
		}

		.buyer-box dd:first-child {
			line-height: 38px;
			height: 40px;
		}

/*服务中心报表*/
.scr-titbg {
	background-image: -moz-linear-gradient(top, #ff7b04, #ffa304); /* Firefox */
	background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #ff7b04), color-stop(1, #ffa304)); /* Saf4+, Chrome */
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff7b04', endColorstr='#ffa304', GradientType='0'); /* IE*/
	padding-top: 20px;
	padding-bottom: 20px;
	color: #ffffff;
	text-align: center;
	line-height: 30px
}

	.scr-titbg b {
		font-size: 16px
	}

	.scr-titbg div {
		width: 50%;
		text-align: center
	}

		.scr-titbg div.line {
			width: 5px;
			height: 90px;
			/* background: url(../img/black_line.png) no-repeat center center; */
			position: absolute;
			left: 50%
		}

.scr-list {
	background: #ffffff
}

	.scr-list .list-tit {
		background: #f6f6f6;
		height: 40px;
		line-height: 40px;
	}

	.scr-list ul {
		cursor: pointer;
	}

		.scr-list ul li {
			height: 45px;
			line-height: 45px
		}

	.scr-list .list01 {
		width: 30%;
		padding-left: 2%
	}

	.scr-list .list02 {
		width: 30%;
		text-align: center
	}

	.scr-list .list03 {
		width: 40%;
		padding-right: 2%;
		text-align: right
	}

	.scr-list ul li.list01 {
		color: #157efb
	}

	.scr-list .even {
		background: #fafafa
	}

	.scr-list .list-left {
		width: 15%;
	}

		.scr-list .list-left .list01 {
			padding-left: 5%;
			width: 95%
		}

	.scr-list .list-right {
		width: 85%;
		overflow: auto
	}

		.scr-list .list-right dd {
			width: 800px;
		}

		.scr-list .list-right .list04 {
			width: 200px;
			text-align: center
		}

		.scr-list .list-right .list05 {
			width: 200px;
			text-align: center
		}

		.scr-list .list-right .list06 {
			width: 200px;
			text-align: center
		}

		.scr-list .list-right .list07 {
			width: 180px;
			text-align: right;
			padding-right: 15px
		}

	.scr-list .totalbg {
		background: #fff4ee
	}

.lineh25 {
	line-height: 25px;
}

/*点击加载*/
.info-tips {
	text-align: center;
	padding-top: 15px
}

	.info-tips .fa-cloading {
		/* background: url(../img/click.png) no-repeat; */
		width: 100px;
		height: 150px;
		margin: auto
	}

	.info-tips .fa-nodata {
		/* background: url(../img/no_data.png) no-repeat; */
		width: 100px;
		height: 100px;
		margin: auto
	}

/*按纽置底*/
.btn-bottom {
	position: absolute;
	bottom: 0px;
}

.simple-info {
	line-height: 22px;
}

	.simple-info img {
		width: 110px;
		height: 110px;
	}

.enImgs {
	padding-left: 16px;
	padding-bottom: 12px;
	background: #fff;
	margin-bottom: 12px; /* white-space: nowrap; */ /* overflow: auto; */
}

	.enImgs .detailed-tit {
		border: none
	}

	.enImgs .bg-autoSize {
		height: 100px;
		margin-right: 3px;
	}

.enImgs-container {
	white-space: nowrap;
	overflow: auto;
}

.enImgs + div {
	padding: 0 16px 16px;
	background: #fff;
	margin-bottom: 12px;
}

	.enImgs + div + div {
		padding: 0 16px 16px;
		background: #fff;
		margin-bottom: 12px;
	}

		.enImgs + div + div .detailed-tit {
			border: none;
		}

.m-lists {
	padding: 12px 15px;
	background: #F6F6F6;
	font-size: 14px;
}

	.m-lists > div {
		box-shadow: 0 0 2px 3px #eee;
		border-radius: 5px;
	}

.details-info {
	padding: 0 12px 12px;
	margin-bottom: 12px;
	border-radius: 5px;
	color: rgba(0, 0, 0, .8);
}

.detailed-tit {
	margin-top: 0;
	background: #fff;
	border-bottom: 1px solid #E5E5E5;
	position: relative;
	padding-left: 0;
}

	.detailed-tit:after {
		content: '';
		position: absolute;
		left: 68px;
		top: 20px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #378AFB;
		z-index: 1;
		visibility: visible;
	}

	.detailed-tit:before {
		content: '';
		position: absolute;
		left: 72px;
		top: 22px;
		width: 8px;
		height: 8px;
		opacity: .3;
		background-color: #378AFB;
		border-radius: 50%;
	}

.details-info .list-info, .details-info .tit-info {
	margin: 0;
	border-bottom: 1px solid #E5E5E5;
}

.list-info-item {
	display: flex;
	justify-content: space-between;
}

.details-info .list-info, .hx-info .list-info {
	border: 1px solid #e5e5e5;
	margin-top: -1px;
	padding: 0 16px;
}

.phisical-info .tit-info, .hx-info .tit-info {
	background-color: #F0F2F5;
	border: 1px solid #e5e5e5;
	border-top: none;
	padding: 0 16px;
	font-weight: 600;
}

.query-btn {
	width: 100px;
	height: 100px;
	background: linear-gradient(180deg, #62C9FF 0%, #3399FF 100%);
	box-shadow: 0px 0px 9px 0px rgba(255, 255, 255, 0.5), 0px 4px 16px 0px #4E97F6;
	border-radius: 50%;
	color: #fff;
	text-align: center;
	line-height: 100px;
	margin: 10px auto;
	font-size: 18px;
}

.company-info {
	padding: 0 16px 16px;
	background: #fff;
	margin-bottom: 12px;
}

	.company-info .detailed-tit {
		border: none;
	}

		.company-info .detailed-tit:after {
			left: 166px;
		}

		.company-info .detailed-tit:before {
			left: 170px;
		}


header {
	width: 100%;
	height: 65px;
	background: #2E323D;
	padding: 12px 15px;
}

	header img {
		height: 100%;
	}

.footer {
	width: 100%;
	height: 180px;
	background: #2E323D;
	filter: blur(0px);
	padding: 12px 18px;
	display: flex;
	color: #ccc;
	font-size: 12px;
}

	.footer .footer-title {
		font-weight: 600;
		font-size: 13px;
		margin-bottom: 5px;
	}

		.footer .footer-title:before {
			content: '';
			display: inline-block;
			width: 4px;
			height: 4px;
			background: rgba(55, 138, 251, 0.8);
			border-radius: 50%;
			vertical-align: middle;
			margin-right: 5px;
			position: relative;
			top: -1px;
		}

	.footer .contact {
		width: 60%;
	}

		.footer .contact .contact-container {
			height: 120px;
		}

		.footer .contact .contact-item {
			display: flex;
			text-align: left;
			line-height: 17px;
			font-weight: lighter;
		}

.contact-item .contact-item-label {
	width: 40px;
	flex: none;
}

.footer .qrcode {
	width: 40%;
}

.qrcode-img {
	width: 110px;
	height: 110px;
	margin: 10px auto;
}

	.qrcode-img img {
		width: 100%;
	}

.details-info .list-info:nth-of-type(even) {
	background-color: rgba(240, 242, 245, 0.40);
}

/deep/ .table-info table{
	width: 100%;
	border: #ccc solid 1px;
	text-align: center;
    margin:0;padding:0;
    border-collapse: collapse;

}

/deep/	.table-info td, /deep/.table-info th {
		padding: 12px 8px !important;
        border-left:  #e5e5e5 1px solid;
        border-bottom:  #e5e5e5 1px solid;
	}
    

    /deep/	.table-info th {
		border-top: none;
		background-color: #F0F2F5;
		font-weight: bold;
	}

    /deep/	.table-info td:first-of-type {
		color: #378AFB;
		text-align: left;
	}

    /deep/	.table-info td:last-of-type {
		color: #1EC09F;
	}


</style>


// WEBPACK FOOTER //
// src/components/manufacturers4.vue